/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ([
/* 0 */
/***/ (function(module) {

function setLanguageLocale() {
    let userLang = getLangFromURL();
    localStorage.setItem('lang', userLang);
}

function getLanguageLocale() {
    let userLang = localStorage.getItem('lang');
    return userLang !== null ? userLang : 'ca';
}

function getLangFromURL() {
    let path = window.location.pathname;
    let urlChunks = path.split('/');
    let userCandidateLang = urlChunks[1];
    let userLang = /^(es|en|ca|oc|gl|eu|bg|de|fr|it|pt|ro)/.test(userCandidateLang) ? userCandidateLang : 'ca';
    return userLang;
}

function isSameLanguage(lang) {
    return getLangFromURL() === lang;
}
// * Toggle password input visibility
$(".toggle-password").on("click", function () {
    $(this).toggleClass("eye eye-slash");
    var input = $($(this).attr("toggle"));
    if (input.attr("type") == "password") {
        input.attr("type", "text");
    } else {
        input.attr("type", "password");
    }
});

//  * jQuery function-extend per gestionar l'animació del scroll
$.fn.extend({
    animateScroll: function (sHost, levels) {
        console.log("function animateScroll()");

        const $target = $(this);
        console.log("Target:", $target);

        const $sHost = sHost ? $(sHost) : $("html,body");
        console.log("sHost:", $sHost);

        /*        
        console.log("///sHost////");
        console.log(sHost);
        console.log($sHost);
        console.log("///sHost?////");
       
        const rectTarget = $target[0].getBoundingClientRect();
        const rectHost = sHost ? $sHost[0].getBoundingClientRect() : {top: 0, bottom: $sHost[0].clientHeight};
        const sTopSH = sHost ? $sHost.scrollTop() : $(window);
        console.log('sTopSH: '+sTopSH);
        console.log('rectTarget.top: '+rectTarget.top);
        console.log('rectTarget.bottom: '+rectTarget.bottom);
        console.log('rectHost.top: '+rectHost.top);
        console.log('rectHost.bottom: '+rectHost.bottom);

        let topDiff = rectTarget.top - rectHost.top;
        console.log('topDiff: '+topDiff);
        let botDiff = rectHost.bottom - rectTarget.bottom;
        console.log('botDiff: '+botDiff);
        let st;

        if (topDiff <= 0) {
            st = sTopSH + topDiff;
            console.log('TOPst: '+st);
        } else if (topDiff > 0 && botDiff < 0) {
            st = sTopSH + Math.min(topDiff, -botDiff);
            console.log('BOTst: '+st);
        }
        */

        console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>" + $(this).prop("nodeName"));

        var parentPos = $(this).parents().eq(levels).position();

        if (parentPos === undefined) return; // TODO: Esto si no es un input petaba y he hecho que salga la función (<select> viene undefined)
        console.log("Parent position", parentPos);

        st = parentPos.top;
        $sHost
            .animate({scrollTop: st}, "slow")
            .eq(0) // we want function to be called just once (ref. "html,body")
            .queue(focusCallback($target));
    },
});

// * animateScroll callback function
function focusCallback($target) {
    console.log("function focusCallback()");
    // Must change focus!
    $target.trigger("focus");
    if ($target.is(":focus")) {
        // Checking if the target was focused
        // return false;
        console.log('$target.is(":focus")');
    } else {
        $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
        $target.trigger("focus"); // Set focus again

        if ($target.is(":focus")) {
            // 2nd Checking if the target was focused
            console.log('$target.is(":focus") (2nd chance)');
        }
    }
}

$(function(){
    $( ".global-lang" ).on("change", function() {
        console.log("change global lang"); 
        // console.log("origin: ", window.location.origin);
        // console.log("pathname: ", window.location.pathname);
        // console.log("lang: ", window.location.pathname.split('/')[1].trim());
        let response = new get(`${window.location.origin}/${window.location.pathname.split('/')[1]}/lang-change/lang/${this.value}`); 
        console.log(response);
        response
            .done(function (result) {
                console.log(result);
                if(result.success) {
                    window.location = result.redirect; // ajax dont admit redirection at server side
                }
            })
            .fail(function (jqXHR, textStatus, error) {
                console.log(`${jqXHR.statusText} (${jqXHR.status}) : ${textStatus}`);
                console.log(jqXHR.responseText);
            })
        ;

    });
});
/**
 * Ajax POST request
 *
 * @param {string} url
 * @param {object} data
 * @param {object=} options
 * @returns {*}
 */
const post = function (url, data, options) {
    return $.ajax($.extend({
        url: url,
        type: 'POST',
        contentType: 'application/json; charset=utf-8',
        cache: false,
        dataType: 'json',
        processData: true,
        data: typeof data !== 'undefined' ? JSON.stringify(data) : null,
        headers: {
            'Accept': "application/json; charset=utf-8"
        }
    }, options));
};

/**
 * Ajax GET request.
 *
 * @param {string} url
 * @param {object} options
 * @returns {*}
 */
const get = function (url, options) {
    return $.ajax($.extend({
        url: url,
        type: 'GET',
        contentType: 'application/json; charset=utf-8',
        cache: false,
        dataType: 'json',
        processData: true
    }, options || {}));
};

/**
 * Check response object for error and show error message.
 *
 * @param {Object} xhr
 * @returns {Boolean}
 */
const handleError = function (xhr) {
    // Handle only errors
    if (xhr.status == 422 || (xhr.status < 400 && xhr.status >= 599)) {
        return false;
    }

    let message = null;

    if (xhr.responseJSON) {
        if ('message' in xhr.responseJSON) {
            message = xhr.responseJSON.message;
        }
        if ('error' in xhr.responseJSON && 'message' in xhr.responseJSON.error) {
            message = xhr.responseJSON.error.message;
        }
    }

    //message = message || __('Server error');

    Swal.hideLoading();
    Swal.fire({
        type: 'error',
        text: message
    });

    return true;
};

// export {post, get, handleError}

module.exports.post = post;
module.exports.get = get;
module.exports.handleError = handleError;
function getCp() {
  return get("/user/cp");
}

function saveCp(cp) {
  post("/user/cp", {cp: cp})
    .done(function (result) {
      console.log("saved cp");
    })
    .fail(function (jqXHR, textStatus) {
      console.log(
        "error saving cp: ",
        jqXHR.statusText,
        jqXHR.status,
        jqXHR.responseText,
        textStatus
      );
    });
}

function getThirdPartyPromotion(eventId) {
  return get(`/user/event/${eventId}/opt-in`);
}

function saveThirdPartyPromotion(organizationId) {
  post("/user/opt-in", {id_organization: organizationId})
    .done(function (result) {
      console.log("saved third party promotion");
    })
    .fail(function (jqXHR, textStatus) {
      console.log(
        "error saving third party promotion: ",
        jqXHR.statusText,
        jqXHR.status,
        jqXHR.responseText,
        textStatus
      );
    });
}

const login = function login(username, password, token = "") {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: "post",
            url: "taquilla/login/",
            contentType: "application/json; charset=utf-8",
            cache: false,
            processData: true,
            dataType: "json",
            data: JSON.stringify({username: username, password: password, token: token}),
            headers: {
                Accept: "application/json; charset=utf-8",
            },
        })
            .done(function (result) {
                console.log("login ajax:", result, typeof result);
                if (result.success) {
                    token = result.token;
                    var base64Url = token.split(".")[1];
                    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
                    var jsonPayload = decodeURIComponent(
                        atob(base64)
                            .split("")
                            .map(function (c) {
                                return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                            })
                            .join("")
                    );
                    const payload = JSON.parse(jsonPayload);
                    console.log({payload});
                    // localStorage.setItem('from', 'public');
                    localStorage.setItem("access_token", token);
                    localStorage.setItem("username", payload.name);
                    localStorage.setItem("surname", payload.surname);
                    localStorage.setItem("privileges", typeof result.privileges !== "string" ? JSON.stringify(result.privileges) : result.privileges);
                    $("#uil").val(1);
                    $("#current-user-email").val(result.current_user_email);
                    loadUserMenu();
                    resolve(true);
                }
                resolve(false);
            })
            .fail(function (jqXHR, textStatus) {
                console.log("fail updateOrderLines: " + jqXHR.statusText + " (" + jqXHR.status + ") : " + textStatus);
                console.log(jqXHR.responseText);
                reject(false);
            });
    });
};

// TODO Eliminar aquesta funció quan estigui enllestit el tema de sesions, es la pasarela entre public i panell
// Si no hay local storage logout
// Si hay local storage login (deberia comprobarse que se viene de panel)
const checkLoginStatus = function checkLoginStatus() {
    let from = localStorage.getItem("from");
    let access_token = localStorage.getItem("access_token");
    let username = localStorage.getItem("username");
    let surname = localStorage.getItem("surname");
    let privileges = localStorage.getItem("privileges");
    console.log(from, access_token, username, surname, privileges);
    if (!access_token || !username || !surname || !privileges) {
        // logout
        console.log("logout");
        if (!from) {
            // TODO Afegir al local storage de panel el "from" => "panel" [ANGULAR]
            localStorage.setItem("from", "public");
            window.location = $("#base_url").val() + "/logout";
        }
    } else {
        // TODO Quan vingui from de panel es quan es fa aquest login, ara s'esta fent diversos cops cal revisar aquest TODO
        // login
        new login("", "", access_token)
            .then((response) => {
                // window.location = base_url;
                loadUserMenu();
            })
            .catch((error) => {});

        // if(from != 'public') {

        // }else {
        //     console.log('Estas a public loguejat');
        // }
    }
};

function loadUserMenu() {
    $.ajax({
        type: "get",
        url: "user-menu",
        cache: false,
        processData: true,
        headers: {
            Accept: "text/html",
        },
    })
        .done(function (result) {
            $("#user-wrapper").html(result);
        })
        .fail(function (jqXHR, textStatus) {
            console.log("fail updateOrderLines: " + jqXHR.statusText + " (" + jqXHR.status + ") : " + textStatus);
            console.log(jqXHR.responseText);
        });
}

function isUserLogged() {
    return !$("#uil").val();
}

function clearLocalStorageIfNotLogged() {
    if (!isUserLogged()) {
        console.log("NOT LOGGED");
        // localStorage.clear();
    }
}

$(function () {
    console.log("Header;change");
    // checkLoginStatus();
    clearLocalStorageIfNotLogged();
    let userProfileImage = localStorage.getItem("image");
    if (userProfileImage !== null && userProfileImage !== "" && isUserLogged()) {
        let userProfileLoadPath = $("#user-profile-image").attr("src");
        let chunks = userProfileLoadPath.split("/");
        let userProfileLoadImage = chunks[chunks.length - 1];
        let path = chunks.slice(0, -1).join("/");
        if (userProfileLoadImage !== userProfileImage) {
            $("#user-profile-image").attr("src", `${path}/${userProfileImage}`);
            // change session for avoid loading image until next login
            $.ajax({
                type: "post",
                url: "user-image/" + userProfileImage,
                cache: false,
                processData: true,
                headers: {
                    Accept: "application/json",
                },
            })
                .done(function (result) {
                    console.log(result);
                })
                .fail(function (jqXHR, textStatus) {
                    console.log("fail image: " + jqXHR.statusText + " (" + jqXHR.status + ") : " + textStatus);
                    console.log(jqXHR.responseText);
                });
        }
    }
});
 
// 

/*
jQuery Redirect v1.1.3

Copyright (c) 2013-2018 Miguel Galante
Copyright (c) 2011-2013 Nemanja Avramovic, www.avramovic.info

Licensed under CC BY-SA 4.0 License: http://creativecommons.org/licenses/by-sa/4.0/

This means everyone is allowed to:

Share - copy and redistribute the material in any medium or format
Adapt - remix, transform, and build upon the material for any purpose, even commercially.
Under following conditions:

Attribution - You must give appropriate credit, provide a link to the license, and indicate if changes were made. You may do so in any reasonable manner, but not in any way that suggests the licensor endorses you or your use.
ShareAlike - If you remix, transform, or build upon the material, you must distribute your contributions under the same license as the original.
*/
;(function ($) {
  'use strict';

  //Defaults configuration
  var defaults = {
    url: null,
    values: null,
    method: "POST",
    target: null,
    traditional: false,
    redirectTop: false
  };

  /**
  * jQuery Redirect
  * @param {string} url - Url of the redirection
  * @param {Object} values - (optional) An object with the data to send. If not present will look for values as QueryString in the target url.
  * @param {string} method - (optional) The HTTP verb can be GET or POST (defaults to POST)
  * @param {string} target - (optional) The target of the form. "_blank" will open the url in a new window.
  * @param {boolean} traditional - (optional) This provides the same function as jquery's ajax function. The brackets are omitted on the field name if its an array.  This allows arrays to work with MVC.net among others.
  * @param {boolean} redirectTop - (optional) If its called from a iframe, force to navigate the top window. 
  *//**
  * jQuery Redirect
  * @param {string} opts - Options object
  * @param {string} opts.url - Url of the redirection
  * @param {Object} opts.values - (optional) An object with the data to send. If not present will look for values as QueryString in the target url.
  * @param {string} opts.method - (optional) The HTTP verb can be GET or POST (defaults to POST)
  * @param {string} opts.target - (optional) The target of the form. "_blank" will open the url in a new window.
  * @param {boolean} opts.traditional - (optional) This provides the same function as jquery's ajax function. The brackets are omitted on the field name if its an array.  This allows arrays to work with MVC.net among others.
  * @param {boolean} opts.redirectTop - (optional) If its called from a iframe, force to navigate the top window. 
  */
  $.redirect = function (url, values, method, target, traditional, redirectTop) {
    var opts = url;
    if (typeof url !== "object") {
      var opts = {
        url: url,
        values: values,
        method: method,
        target: target,
        traditional: traditional,
        redirectTop: redirectTop
      };
    }

    var config = $.extend({}, defaults, opts);
    var generatedForm = $.redirect.getForm(config.url, config.values, config.method, config.target, config.traditional);
    $('body', config.redirectTop ? window.top.document : undefined).append(generatedForm.form);
    
    generatedForm.submit();
    generatedForm.form.remove();
  };

  $.redirect.getForm = function (url, values, method, target, traditional) {
    method = (method && ["GET", "POST", "PUT", "DELETE"].indexOf(method.toUpperCase()) !== -1) ? method.toUpperCase() : 'POST';

    url = url.split("#");
    var hash = url[1] ? ("#" + url[1]) : "";
    url = url[0];

    if (!values) {
      var obj = $.parseUrl(url);
      url = obj.url;
      values = obj.params;
    }

    values = removeNulls(values);
    var form = $('<form>')
      .attr("method", method)
      .attr("action", url + hash);


    if (target) {
      form.attr("target", target);
    }

    var submit = form[0].submit;
    iterateValues(values, [], form, null, traditional);

    return { form: form, submit: function () { submit.call(form[0]); } };
  }

  //Utility Functions
	/**
	 * Url and QueryString Parser.
	 * @param {string} url - a Url to parse.
	 * @returns {object} an object with the parsed url with the following structure {url: URL, params:{ KEY: VALUE }}
	 */
  $.parseUrl = function (url) {

    if (url.indexOf('?') === -1) {
      return {
        url: url,
        params: {}
      };
    }
    var parts = url.split('?'),
      query_string = parts[1],
      elems = query_string.split('&');
    url = parts[0];

    var i, pair, obj = {};
    for (i = 0; i < elems.length; i += 1) {
      pair = elems[i].split('=');
      obj[pair[0]] = pair[1];
    }

    return {
      url: url,
      params: obj
    };
  };

  //Private Functions
  var getInput = function (name, value, parent, array, traditional) {
    var parentString;
    if (parent.length > 0) {
      parentString = parent[0];
      var i;
      for (i = 1; i < parent.length; i += 1) {
        parentString += "[" + parent[i] + "]";
      }

      if (array) {
        if (traditional)
          name = parentString;
        else
          name = parentString + "[" + name + "]";
      } else {
        name = parentString + "[" + name + "]";
      }
    }

    return $("<input>").attr("type", "hidden")
      .attr("name", name)
      .attr("value", value);
  };

  var iterateValues = function (values, parent, form, isArray, traditional) {
    var i, iterateParent = [];
    Object.keys(values).forEach(function (i) {
      if (typeof values[i] === "object") {
        iterateParent = parent.slice();
        iterateParent.push(i);
        iterateValues(values[i], iterateParent, form, Array.isArray(values[i]), traditional);
      } else {
        form.append(getInput(i, values[i], parent, isArray, traditional));
      }
    });
  };

  var removeNulls = function (values) {
    var propNames = Object.getOwnPropertyNames(values);
    for (var i = 0; i < propNames.length; i++) {
      var propName = propNames[i];
      if (values[propName] === null || values[propName] === undefined) {
        delete values[propName];
      } else if (typeof values[propName] === 'object') {
        values[propName] = removeNulls(values[propName]);
      } else if (values[propName].length < 1) {
        delete values[propName];
      }
    }
    return values;
  };
}(window.jQuery || window.Zepto || window.jqlite));

//===
// VARIABLES
//===
//const DATE_TARGET = new Date('08/17/1986 3:01 AM');
// DOM for render
const SPAN_DAYS = document.querySelector("span#days");
const SPAN_HOURS = document.querySelector("span#hours");
const SPAN_MINUTES = document.querySelector("span#minutes");
const SPAN_SECONDS = document.querySelector("span#seconds");
// Milliseconds for the calculations
const MILLISECONDS_OF_A_SECOND = 1000;
const MILLISECONDS_OF_A_MINUTE = MILLISECONDS_OF_A_SECOND * 60;
const MILLISECONDS_OF_A_HOUR = MILLISECONDS_OF_A_MINUTE * 60;
const MILLISECONDS_OF_A_DAY = MILLISECONDS_OF_A_HOUR * 24;

//===
// FUNCTIONS
//===

/**
 * Method that updates the countdown and the sample
 */
function updateCountdown(DATE_TARGET, intervalId) {
    // Thanks Pablo Monteserín (https://pablomonteserin.com/cuenta-regresiva/)
    // Calcs
    const NOW = new Date();
    const DURATION = DATE_TARGET - NOW;
    // const REMAINING_DAYS = Math.floor(DURATION / MILLISECONDS_OF_A_DAY);
    // const REMAINING_HOURS = Math.floor((DURATION % MILLISECONDS_OF_A_DAY) / MILLISECONDS_OF_A_HOUR);
    const REMAINING_MINUTES = Math.floor((DURATION % MILLISECONDS_OF_A_HOUR) / MILLISECONDS_OF_A_MINUTE);
    const REMAINING_SECONDS = Math.floor((DURATION % MILLISECONDS_OF_A_MINUTE) / MILLISECONDS_OF_A_SECOND);
    if (REMAINING_MINUTES >= 0 && REMAINING_SECONDS >= 0) {
        SPAN_MINUTES.textContent = REMAINING_MINUTES;
        SPAN_SECONDS.textContent = REMAINING_SECONDS < 10 ? "0" + REMAINING_SECONDS : REMAINING_SECONDS;
    } else {
        // timeout
        console.log("timeout");
        const pathname = window.location.pathname;
        const [_, userLang] = pathname.split("/");
        const eventSlug = $("#event-slug").val()
        const url = `/timeout/event-slug/${eventSlug}/lang/${userLang}`;
        clearInterval(intervalId);
        window.location = url;
    }
}

const userLangToTicketDescription = (lang) => {
    switch (lang) {
        case "ca":
            return "entrades";
        case "es":
            return "entradas";
        case "en":
            return "tickets";
        case "oc":
            return "tickets";
        case "gl":
            return "tickets";   
        case "eu":
            return "tickets";  
        case 'bg':
            return "билети";
        case 'fr':
            return "billets";
        case 'it':
            return "biglietti";
        case 'pt':
            return 'ingressos';
        case 'ro':
            return 'bilete'; 
    }
};

/*
//===
// INIT
//===
updateCountdown();
// Refresh every second
setInterval(updateCountdown, MILLISECONDS_OF_A_SECOND);
*/

// Organism cart-1-reserve scripts
console.log("// Organism cart-1-reserve scripts");

var orderLines = {};
var timeCount = null;
let firstEmptyCart = true;

var discounts = {};
var discountLines = {};

var blockedOrderId;

async function createOrder() {
    $("#attendee-assign-order, #attendee-assign-order-1-5, #goto-button-").prop("disabled", true);
    $("#attendee-assign-order, #attendee-assign-order-1-5, #goto-button-").addClass("disabled");
    console.log("function createOrder");
    return await createEmptyOrder();  // Return the result
}

async function createEmptyOrder() {
    console.log("function createEmptyOrder()");
    const eventSlug = $("#event-slug").val()
    const url = `/taquilla/reserve/${eventSlug}/status/empty`;
    
    try {
        const result = await $.ajax({
            type: "post",
            url: url,
            contentType: "application/json; charset=utf-8",
            cache: false,
            processData: true,
            dataType: "json",
        });
        
        console.log(result);
        const orderId = result.id_order;
        $("#cart").data("id_order", orderId);

        return orderId;  // Return the orderId
    } catch (error) {
        console.log("fail createEmptyOrder: " + error.statusText + " (" + error.status + ") : " + error.textStatus);
        console.log(error.responseText);
        throw error;  // Re-throw the error so it can be caught by the caller
    }
}

// Ensure a single in_cart order exists. Concurrent callers (rapid +/- clicks, or
// several tickets changed within the debounce window) reuse the same in-flight
// request instead of each creating a new order. Fixes duplicate in_cart orders.
let creatingOrderPromise = null;

async function ensureOrder() {
    let orderId = $("#cart").data("id_order");
    if (orderId != undefined) {
        return orderId;
    }
    if (!creatingOrderPromise) {
        creatingOrderPromise = createOrder();
    }
    try {
        orderId = await creatingOrderPromise;
    } finally {
        creatingOrderPromise = null;
    }
    return orderId;
}

function initTimer() {
    // The reservation countdown represents held stock; it must start only once,
    // when the first line is actually reserved (see returnStatus). Guard against
    // stacking multiple intervals on every cart reopen.
    if (timeCount !== null) {
        return;
    }
    const reserveTime = $("#reserve-time").val();
    const timeToReserve = reserveTime !== "" ? parseInt(reserveTime) : 15;
    const momentOfTime = new Date();
    const myTimeSpan = timeToReserve * 60 * 1000;
    const reservation = momentOfTime.setTime(momentOfTime.getTime() + myTimeSpan);
    
    $("#cart").data("reservation", reservation);
    const dateTarget = new Date(reservation);
    
    inactivityTime();
    updateCountdown(dateTarget);
    timeCount = setInterval(function () {
        updateCountdown(dateTarget, timeCount);
    }, MILLISECONDS_OF_A_SECOND);
}

async function createEmptyBlockingOrder(ticketRecurrenceId) {
    console.log("function createEmptyBlockingOrder()");
    const eventSlug = $("#event-slug").val()
    const url = `/taquilla/reserve/${eventSlug}/status/reserved`;
    $.ajax({
        type: "post",
        url: url,
        contentType: "application/json; charset=utf-8",
        cache: false,
        processData: true,
        dataType: "json",
    })
        .done(function (result) {
            console.log(result);
            const orderId = result.id_order; //order.id_order

            blockedOrderId = orderId;
            $("#cart").data("id_order_blocked_seats", orderId);

            loadSeatMap(orderId, ticketRecurrenceId, CART_MODE.BLOCKING);
            modalCart(16); 
        })
        .fail(function (jqXHR, textStatus) {
            console.log("fail createEmptyBlockingOrder: " + jqXHR.statusText + " (" + jqXHR.status + ") : " + textStatus);
            console.log(jqXHR.responseText);
        });
}

var inactivityTime = function () {
    console.log("Function inactivityTime");
    var time;
    resetTimer();
    // DOM Events
    document.onmousemove = resetTimer;
    document.onkeydown = resetTimer;
    document.ontouchstart = resetTimer;
    document.onclick = resetTimer; // touchpad clicks
    document.onkeydown = resetTimer; // onkeypress is deprectaed
    document.addEventListener("scroll", resetTimer, true); // improved; see comments

    function oneminut() {
        time = setTimeout(logout, 60000);
        console.log("one minut left...");
        //location.href = 'logout.html'
    }

    function logout() {
        if ($(".cart-5-response").css("display") == "block") {
            location.reload();
            return;
        }

        alert("La comanda s'ha cancel·lat per inactivitat");
        location.reload();
    }

    function resetTimer() {
        console.log("activity");
        clearTimeout(time);
        time = setTimeout(oneminut, 180000);
        // 1000 milliseconds = 1 second
    }
};

/**
 * Read the value of the quantity input and check that it does not exceed the maximum allowable limit.
 * @var {integer} idElement Id of ticket
 * @var {integer} max Maximum allowable value
 * @var {integer} value Input value
 * @returns {integer} Maximum allowable value
 */
$(function () {
    $(".qty-ticket-reserve").on("change", function () {
        console.log("Input Changed");

        const value = parseInt($(this).val());
        if (isNaN(value)) {
            $(this).val($(this).data("oldvalue"));
            return false;
        }

        const min = $(this).attr("min");
        if (value < min) {
            $(this).val(min);
        }

        const max = $(this).attr("max");
        if (value > max) {
            console.log('Max exceeded')
            $(this).val(max);
        }

        const idElement = $(this).attr("data-id");
        waitingForMoreChanges(idElement);
    });

    // CND 18-10-23 Esta funcionalidad no la usaremos de momento
    // $("#discounts-applyed").on("click", "button.discount-code-applyed", function () {
    //     console.log("Deleting discount");
    //     removeDiscount($(this).attr("data-id"));
    //     $(this).remove();
    // });
});

/**
 * Modify the value of the input through the plus and minus buttons. Check that it does not exceed the maximum allowed limit.
 * @param {integer} variation Operation performed, can be +1 or -1
 * @param {integer} idElement Id of ticket
 * @var {DOM} target Target to which changes apply
 * @var {integer} min Minimum allowable value
 * @var {integer} max Maximum allowable value
 * @var {integer} oldval Value before the new value
 * @returns {integer} Returns the value of the operation after the limits have been checked.
 */
function prepareReserve(variation, idElement) {
    console.log("function prepareReserve");
    const target = $("#qty-ticket-reserve-" + idElement);

    const value = parseInt(target.val());
    // Si restem i quantitat es 0 no fer res
    if (variation === -1 && value === 0) return false;

    const min = target.attr("min");
    const max = target.attr("max");
    target.val(function (i, oldval) {
        const operation = parseInt(oldval, 10) + variation;
        if (operation < min || operation > max) {
            console.log("Limit de reserves");
            return parseInt(oldval, 10);
        } else {
            console.log("Input actualitzat, pendent de validar");
            // waitingForMoreChanges(idElement)
            return operation;
        }
    });
    $(target).trigger("change");
}

/**
 * Adds a timer that delays the request for a certain time if it executes itself again. This timer is stored in the data of the same input.
 * @param {integer} idElement Id of ticket
 * @var {integer} time Waiting time
 * @var {DOM} target Target to which the timer is applied
 * @returns {integer} Returns the value of the operation after the limits have been checked.
 */
function waitingForMoreChanges(idElement) {
    console.log("function waitingForMoreChanges");
    $("#reserve-status-" + idElement + " > div").hide();
    $("#reserve-status-" + idElement + " .loading-reserve").show();
    disableNextStep();

    const time = 1000;
    const target = $("#qty-ticket-reserve-" + idElement);
    clearTimeout(target.data("reserve-timer"));
    target.data(
        "reserve-timer",
        setTimeout(function () {
            console.log("Reserva enviada");
            requestReserve(idElement);
        }, time)
    );
}

function disableNextStep() {
    console.log("function disableNextStep: " + status);
    $("#attendee-assign-order").prop("disabled", true);
    $("#attendee-assign-order").addClass("disabled");
    const time = 1200;
    const target = $("#attendee-assign-order");
    clearTimeout(target.data("reserve-timer"));
    target.data(
        "reserve-timer",
        setTimeout(function () {
            console.log("Next step habilitat");
            $("#attendee-assign-order").prop("disabled", false);
            $("#attendee-assign-order").removeClass("disabled");
        }, time)
    );

    return false;
}

//TODO Nota de Manu: La variació s'envia + al incrementar i - al decrementar jo entenc "remaining_stock" com la quantitat d'entrades que queden
// es dir comença en el mateix valor que el initial_stock i va baixant conforme es venen entrades
// si es com dic cla canviar el signe de com s'envien els valors a la variable "variation"
// si pel contrari remaining_stock comença a 0 i com a molt pot arribar a initial stock ja s'esta enviant bé cal aclarir aquest punt
/**
 * Calculates the variation between the initial value and the modified value. Executes a query through AJAX. Depending on the response received, accepts the change or undoes it.
 * @param {integer} idElement Id of ticket
 * @var {DOM} target Target to which the timer is applied
 * @var {integer} newvalue New input quantity value
 * @var {integer} oldvalue Old input quantity value
 * @var {integer} variation Difference between new and old value
 * @var {boolean} valid API response validation
 * @returns {integer} Returns the value of the operation, if not valid returns the previous value.
 */
async function requestReserve(idElement) {
    console.log("function requestReserve()");
    const target = $("#qty-ticket-reserve-" + idElement);
    const newvalue = target.val();
    let oldvalue = target.data("oldvalue");
    console.log(newvalue, oldvalue);
    if (oldvalue == undefined) {
        oldvalue = 0;
    }
    const variation = oldvalue - newvalue;
    if (variation === 0) {
        returnStatus(idElement, false, newvalue, oldvalue);
        return;
    }
    // Create the order lazily here (after the debounce), only when we actually
    // reserve stock, and only once even for concurrent reservations.
    try {
        await ensureOrder();
    } catch (error) {
        returnStatus(idElement, false, newvalue, oldvalue);
        return;
    }
    updateTicketStock(idElement, variation, newvalue, oldvalue);
}

function updateTicketStock(ticketRecurrenceId, variation, newvalue, oldvalue) {
    console.log("function updateTicketStock()");
    console.log(ticketRecurrenceId, "variation:", variation); 

    const reserveCard = $("#ticket-reserve-" + ticketRecurrenceId);
    const ticketMultiplier = reserveCard.attr("data-ticket-multiplier");

    $.ajax({
        type: "post",
        url: "/taquilla/reserve/update-stock/",
        contentType: "application/json; charset=utf-8",
        cache: false,
        processData: true,
        dataType: "json",
        data: JSON.stringify({
            id_ticket_recurrence: (ticketRecurrenceId+'').split('_')[0], 
            id_order: $("#cart").data("id_order"),
            stock: variation,
            multiplier: ticketMultiplier 
        }),
        headers: {
            Accept: "application/json; charset=utf-8",
        },
    })
        .done(function (result) {
            console.log("update stock:", result, typeof result);
            if (result.success) {
                const valid = result.data.status;
                console.log("Valid AJAX= " + valid);
                returnStatus(ticketRecurrenceId, valid, newvalue, oldvalue);
            } else {
                returnStatus(ticketRecurrenceId, false, newvalue, oldvalue);
            }
        })
        .fail(function (jqXHR, textStatus) {
            console.log("fail updateTicketStock: " + jqXHR.statusText + " (" + jqXHR.status + ") : " + textStatus);
            // console.log(jqXHR.responseText);
            returnStatus(ticketRecurrenceId, false, newvalue, oldvalue);
        });
}

function returnStatus(idElement, valid, newvalue, oldvalue) {
    console.log("function returnStatus()");
    console.log("#reserve-status-" + idElement);
    const target = $("#qty-ticket-reserve-" + idElement);

    $("#reserve-status-" + idElement + " .loading-reserve").hide();

    if (valid) {
        console.log("Reserva actualitzada");
        target.data("oldvalue", newvalue);
        $("#reserve-status-" + idElement + " .checked-reserve").show();
        if (firstEmptyCart === true) {
            $(".my-reserve.summary .title, .my-reserve.summary thead").removeClass("hidden");
            firstEmptyCart = false;
            // First confirmed reservation: now there is held stock to count down.
            initTimer();
        }
        updateOrderLine(idElement, parseInt(newvalue));
    } else {
        console.log("No és possible afegir més entrades");
        $("#qty-ticket-reserve-" + idElement).val(oldvalue);
        $("#reserve-status-" + idElement + " .not-reserve").show();
        // Stock no disponible: bloquear el botón "+" de esta entrada unos segundos
        // para no machacar el servidor con peticiones de stock inútiles.
        lockMoreButtonAfterNoStock(idElement);
    }
}

// Cuando el stock devuelve "no disponible", bloquea el botón "+" de esa entrada
// unos segundos para que el usuario no genere peticiones de stock en bucle.
const NO_STOCK_LOCK_MS = 3000;

function lockMoreButtonAfterNoStock(idElement) {
    const moreButton = $("#more-ticket-reserve-" + idElement);
    if (moreButton.length === 0) {
        return;
    }
    moreButton.prop("disabled", true).addClass("disabled");
    clearTimeout(moreButton.data("no-stock-timer"));
    moreButton.data(
        "no-stock-timer",
        setTimeout(function () {
            moreButton.prop("disabled", false).removeClass("disabled");
        }, NO_STOCK_LOCK_MS)
    );
}

/**
 * Updates the orderLines object, with the quantity values entered.
 * @param {integer} idElement Id of ticket
 * @param {integer} qty Amount reserved
 * @var {DOM} target Target to which the timer is applied
 * @var {float} price Ticket price
 * @var {float} handly Management fee
 * @var {string} label Name of ticket
 * @var {string} currency Symbol of currency
 * @var {integer} price_amount Total price for that ticket
 * @var {integer} handly_amount Total management fee for that ticket
 * @var {object} orderLines Object containing the order lines
 * @returns {object} Returns the object with updated values
 */
function updateOrderLine(idElement, qty) {
    const target = $("#ticket-reserve-" + idElement);
    const price = target.attr("data-price");
    const fee = parseFloat(target.attr("data-fee"));
    const p_type = target.attr("data-p-type");
    const label = target.attr("data-label");
    const currency = target.attr("data-currency");
    const id_ticket = target.attr("id-ticket");
    const price_amount = price * qty;
    const handly_amount = fee * qty;
    const ticket_type = target.attr("data-ticket-type");
    const multiplier = target.attr("data-ticket-multiplier");

    console.log("Ticket id: " + idElement);
    console.log("qty: " + qty);
    console.log("price_amount: " + price_amount);
    console.log("label: " + label);

    if (orderLines[idElement]) {
        //Si ja existia només reiniciem certs valors
        orderLines[idElement].qty = qty;
        orderLines[idElement].price = price;
        orderLines[idElement].price_amount = price_amount;
        orderLines[idElement].handly = handly_amount;
        orderLines[idElement].p_type = p_type;
        console.log("--------------------------");
        console.log(orderLines);
        console.log("--------------------------");
    } else {
        orderLines[idElement] = {
            id_ticket: id_ticket,
            id_ticket_recurrence: (idElement+'').split('_')[0],
            id_price_type: (idElement+'').split('_')[1],
            qty: qty,
            price: price,
            price_amount: price_amount,
            handly: handly_amount,
            p_type,
            label: label,
            currency: currency,
            ticket_type: ticket_type,
            multiplier: multiplier,
        };
    }
    if(qty === 0){

        console.log({qty})
        delete orderLines[idElement]
        console.log({orderLines})
    }

    if (cartHasValidDiscounts()) {
        console.log("Descomptes valids!")
        applyDiscounts();
    } else {
        console.log("Sense descomptes valids!")
        printMyReserve();
    }
}

/**
 * Prints the booking summary with the data of the orderLines object
 * @var {DOM} target Target to which the timer is applied
 * @var {float} totalQty Total price of the reservation
 * @var {float} totalAmount Total cost of the management
 * @var {string} totalCurrency Symbol of currency
 * @returns {HTML} Returns the HTML with the booking summary
 */
// ${$(getTranslationSelector("floor")).val()}: ${orderLine.floorName}
// - ${$(getTranslationSelector("zone")).val()}: ${orderLine.zoneName}
// - ${$(getTranslationSelector("grandstand")).val()}: ${orderLine.grandstandName}
// - ${$(getTranslationSelector("row")).val()}: ${orderLine.rowName}
// - ${$(getTranslationSelector("seat")).val()}: ${orderLine.seatName}
function printMyReserve() {
    $(".my-reserve.total *, .my-reserve.summary table tbody").remove();
    let totalQty = 0;
    let totalAmount = 0;
    const lang = "es-ES";
    const currency = "EUR";
    console.log("function printMyReserve()")
    Object.values(orderLines).forEach((orderLine) => {
        console.log({orderLine})

        let html = `<tbody><tr><th>
                    ${orderLine.qty}
                    x 
                    ${orderLine.label}`;

        if ("rid" in orderLine) {
            html += `<span class="row_seat">
                        ${orderLine.grandstandName}
                        - ${orderLine.rowName}
                        - ${orderLine.seatName}
                    - ${orderLine.price_type}
                    </span>`;
        }

        html += getReserveLineHtml({orderLine, lang, currency});
        $(".my-reserve.summary table").append(html);

        totalQty += orderLine.qty;
        totalAmount += orderLine.price_amount;
        totalAmount += orderLine.handly;
    });

    Object.values(discountLines).forEach((discountLineGroup) => {
        console.log({discountLineGroup})

        discountLineGroup.forEach((discountLine) => {
            console.log({discountLine});
            let html = `<tbody><tr><th>
                        ${discountLine.quantity}
                        x 
                        ${discountLine.label}`;
            html += getDiscountLineHtml({discountLine, lang, currency});
            $(".my-reserve.summary table").append(html);
            totalAmount += discountLine.total;
        });
    });

    if (totalAmount <= 0) {
        totalAmount = 0
    }
    if (totalQty <=0) {
        totalQty = 0
        $(".my-reserve.summary table thead").addClass("hidden");
        $(".my-reserve.summary table tbody").addClass("hidden");
    } else {
        $(".my-reserve.summary table thead").removeClass("hidden");
        $(".my-reserve.summary table tbody").removeClass("hidden");
    };

    totalAmount = new Intl.NumberFormat(lang, {
        style: "currency",
        currency: currency,
    }).format(totalAmount);

    $(".my-reserve.total").append(`<span>${totalQty} ${$("#ticketsLabelTrans").val()}</span>`);
    $(".my-reserve.total").append(`<span>${totalAmount}</span>`);

    if (totalQty === 0) {
        orderLines = {};
        discountLines = {};
        // Cart emptied, but the order still lives server-side (status in_cart, same
        // order.created) and the clean-stock cron frees it at order.created + reserve_time
        // regardless. So do NOT stop or reset the reservation countdown here: it stays
        // anchored to when the order was created and keeps running, so a later re-add
        // resumes the REAL remaining time instead of restarting a fresh 15-min window
        // that the server would not honour. Full reset only happens on checkout (cleanCart).
        $("#attendee-assign-order, #attendee-assign-order-1-5, #goto-button-").prop("disabled", true);
        $("#attendee-assign-order, #attendee-assign-order-1-5, #goto-button-").addClass("disabled");
    } else {
        $("#attendee-assign-order, #attendee-assign-order-1-5, #goto-button-").prop("disabled", false);
        $("#attendee-assign-order, #attendee-assign-order-1-5, #goto-button-").removeClass("disabled");
    }

    console.log("totalQty: " + totalQty);
    console.log("totalAmount: " + totalAmount);
    console.log({orderLines});
    console.log({discountLines});
}

function getReserveLineHtml({orderLine, lang, currency}) {
    const {price, price_amount: priceAmount, handly} = orderLine;
    let html = `</th><td>
    ${new Intl.NumberFormat(lang, {
        style: "currency",
        currency: currency,
    }).format(price)}
    </td><td>
    ${new Intl.NumberFormat(lang, {
        style: "currency",
        currency: currency,
    }).format(priceAmount)}
    </td><td>`;
    if (handly !== 0) {
        html += new Intl.NumberFormat(lang, {
            style: "currency",
            currency: currency,
        }).format(handly);
    } else {
        html += $("#expensesIncludedLabelTrans").val();
    }
    html += `</td></tr></tbody>`;
    return html;
}

function getDiscountLineHtml({discountLine, lang, currency}) {
    const {price, total: priceAmount} = discountLine;
    let html = `</th><td>
    ${new Intl.NumberFormat(lang, {
        style: "currency",
        currency: currency,
    }).format(price)}
    </td><td>
    ${new Intl.NumberFormat(lang, {
        style: "currency",
        currency: currency,
    }).format(priceAmount)}
    </td><td>`;
    html += $("#expensesIncludedLabelTrans").val();
    html += `</td></tr></tbody>`;
    return html;
}

$("#detail_1-toggle-order").on("click", function () {
    $(".summary-footer").toggleClass("opened");
});

$(".ticket-many-prices").on("change", function () {
    const ticketRecurrenceId = $(this).attr("data-ticket-recurrence-id");
    const priceTypeId = $(this).attr("data-price-type-id");
    console.log("CHANGE PRICE FOR: ", ticketRecurrenceId);
    $(`#ticket-reserve-${ticketRecurrenceId}_${priceTypeId}`).attr("data-price", $(this).val());
    $(`#ticket-reserve-${ticketRecurrenceId}_${priceTypeId}`).attr("data-fee", $("option:selected", this).attr("data-fee"));
    $(`#ticket-reserve-${ticketRecurrenceId}_${priceTypeId}`).attr("data-p-type", $("option:selected", this).attr("data-p-type"));
    const currentQuantity = parseInt($(`#qty-ticket-reserve-${ticketRecurrenceId}_${priceTypeId}`).val());
    if (currentQuantity > 0) {
        returnStatus(ticketRecurrenceId+"_"+priceTypeId, true, currentQuantity, currentQuantity);
    }
});

$(function () {
    let lastWindowWidth = window.innerWidth;
    if (lastWindowWidth < 600) {
        $("#1-5-timer-mobile").html($("#1-5-timer-desktop").contents());
        $("#1-5-timer-desktop").html("");
    }

    $(window).on("resize", function () { 
        $window = $(this);
        const currentWidth = $window.width();
        console.log("QUE PASA CON LA PANTALLA", $(".cart-1-5-seats").is(":visible"))
        if ($(".cart-1-5-seats").is(":visible")) {
            const timerData = lastWindowWidth < 600 ? $("#1-5-timer-mobile").contents() : $("#1-5-timer-desktop").contents();

            if (currentWidth < 600) {
                $("#1-5-timer-mobile").html(timerData);
                $("#1-5-timer-desktop").html("");
            } else {
                $("#1-5-timer-desktop").html(timerData);
                $("#1-5-timer-mobile").html("");
            }

            const svgConfig = getSvgConfig($("#current-id-ticket-recurrence").val());
            if(!svgConfig) return;
            initVariables(svgConfig);

            d3.select(getSvgContainerSelector())
                .on("scroll", scrolled)
                .call(myZoom.transform, d3.zoomIdentity.scale(_INITIAL_SCALE).translate(_INITIAL_X, _INITIAL_Y)) // initial positionj
                .call(myZoom);
        }
        lastWindowWidth = currentWidth;
    });

    // open/close legend event
    $("#legend_1_5-open-, #legend_1_5-close-").on("click", function () {
        $("#seats-wrap .legend").toggleClass("open");
    });

    // goto up/down event (mobile)
    $("#goto-button-").on("click", function () {
        const $this = $(this);
        const scroller = $("#cart > .main-container");
        const target = $("#seats-wrap .btn-row");
        const position = target.offset().top - scroller.offset().top + scroller.scrollTop() - 20;

        $this.hasClass("go-down") && scroller.animate({scrollTop: position}, "slow");
        $this.hasClass("go-up") && scroller.scrollTop(0);
        setTimeout(function () {
            $this.toggleClass("go-down go-up");
        }, 10);
    });

    $("#detail_1_5-toggle-order").on("click", function () {
        $(".summary-footer").toggleClass("opened");
    });

});

function defaultFormRow({ticketRecurrenceId, priceTypeId, attendeeIndex, label, attendee}) {
    const {name, surname, email, rid, grandstand, row, seat, price_type} = attendee;

    const currentAttendeeIndex = (rid === "" ? parseInt(attendeeIndex) + 1 : `${grandstand}-${row}-${seat}`);
    const currentAttendeeName = (rid === "" ? `${ticketRecurrenceId}-${currentAttendeeIndex}` : `${currentAttendeeIndex.trim().replace(/ /g, '-')}`);
    return `<fieldset class='attendee-fieldset card card--sm'>
        <h4>${label}
            #${price_type && grandstand && row && seat ? `${grandstand} - ${row} - ${seat} - ${price_type}` : attendeeIndex + 1}
        </h4>
        <div class='attendee-grid main-grid'>
            <div class="form-field name">
                <label>${$("#nameLabelTrans").val()}</label>
                <input class='input attendee' value="${name}" name="name-${currentAttendeeName}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-id-price-type="${priceTypeId}" data-attendee-index="${attendeeIndex}" data-rid="${rid}" required>
            </div>
            <div class="form-field surname">
                <label>${$("#surnameLabelTrans").val()}</label>
                <input class='input attendee' value="${surname}" name="surname-${currentAttendeeName}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-id-price-type="${priceTypeId}" data-attendee-index="${attendeeIndex}" data-attendee-invitation="${currentAttendeeName}" data-rid="${rid}" required>
            </div>
            <div class="form-field email">
                <label>${$("#emailOptionalLabelTrans").val()}</label>
                <input class='input attendee' type="email" value="${email}" name="email-${currentAttendeeName}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-id-price-type="${priceTypeId}" data-attendee-index="${attendeeIndex}" data-rid="${rid}">
            </div>
        </div>
    </fieldset>`;
}

function form5FormRow({ticketRecurrenceId, priceTypeId, attendeeIndex, label, attendee}) {
    const {name, surname, email, grandstand, row, seat, rid, price_type} = attendee;
    return `<fieldset class='attendee-fieldset card card--sm'>
        <h4>${label}
            #${price_type && grandstand && row && seat ? `${grandstand} - ${row} - ${seat} - ${price_type}` : attendeeIndex + 1}
        </h4>
        <div class='attendee-grid main-grid'>
            <div class="form-field name">
                <label>${$("#nameLabelTrans").val()}</label>
                <input class='input attendee' value="${name}" name="name-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-id-price-type="${priceTypeId}" data-attendee-index="${attendeeIndex}" required>
            </div>
            <div class="form-field surname">
                <label>${$("#surnameLabelTrans").val()}</label>
                <input class='input attendee' value="${surname}" name="surname-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-id-price-type="${priceTypeId}" data-attendee-index="${attendeeIndex}" required>
            </div>
            <div class="form-field email">
                <label>${$("#emailOptionalLabelTrans").val()}</label>
                <input class='input attendee' type="email" value="${email}" name="email-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-id-price-type="${priceTypeId}" data-attendee-index="${attendeeIndex}">
            </div>
            <div class="form-field code">
                <label>${$("#codeLabelTrans").val()}</label>
                <input class='input attendee ticket-code' type="text" value="" name="code-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-id-price-type="${priceTypeId}" data-attendee-index="${attendeeIndex}" data-rule-code="true" required>
            </div>
        </div>
    </fieldset>`;
}

// TODO: Translations
function form6FormRow({ticketRecurrenceId, priceTypeId, attendeeIndex, label, attendee}) {
    const {name, surname, email, footwear, sandwich, grandstand, row, seat, rid, price_type} = attendee;

    console.log({footwear});
    console.log({sandwich});

    return `<fieldset class='attendee-fieldset card card--sm'>
        <h4>${label}
            #${price_type && grandstand && row && seat ? `${grandstand} - ${row} - ${seat} - ${price_type}` : attendeeIndex + 1}
        </h4>
        <div class='attendee-grid main-grid'>
            <div class="form-field name">
                <label>${$("#nameLabelTrans").val()}</label>
                <input class='input attendee' value="${name}" name="name-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-id-price-type="${priceTypeId}" data-attendee-index="${attendeeIndex}" required>
            </div>
            <div class="form-field surname">
                <label>${$("#surnameLabelTrans").val()}</label>
                <input class='input attendee' value="${surname}" name="surname-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-id-price-type="${priceTypeId}" data-attendee-index="${attendeeIndex}" required>
            </div>
            <div class="form-field email">
                <label>${$("#emailOptionalLabelTrans").val()}</label>
                <input class='input attendee' type="email" value="${email}" name="email-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-id-price-type="${priceTypeId}" data-attendee-index="${attendeeIndex}">
            </div>
            <div class="form-field sandwich">
                <label>Quin entrepà voldràs?</label>
                <select class='input select attendee' name="sandwich-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-id-price-type="${priceTypeId}" data-attendee-index="${attendeeIndex}" data-rid="${rid}" required>
                    <option value=""></option>    
                    <option value="0" ${sandwich === "0" ? "selected" : ""}>Botifarra</option>
                    <option value="1" ${sandwich === "1" ? "selected" : ""}>Formatge</option>
                </select>
            </div>
        </div>
    </fieldset>`;
}


            // <div class="form-field footwear">
            //     <label>Quina talla de calçat fas servir?</label>
            //     <select class='input select attendee' name="footwear-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" data-rid="${rid}" required>
            //         <option value=""></option>
            //         <option value="0" ${footwear === "0" ? "selected" : ""}>S (fins a 36)</option>
            //         <option value="1" ${footwear === "1" ? "selected" : ""}>P (37-39)</option>
            //         <option value="2" ${footwear === "2" ? "selected" : ""}>M (40-42)</option>
            //         <option value="3" ${footwear === "3" ? "selected" : ""}>G (43 en amunt)</option>
            //     </select>
            // </div>

function minorForm({minorValue, eventId}) {
    return `<div class="form-field custom-check minor-wrap">
                <input class='attendee visually-hidden' type="checkbox" name="minor" id="minor" 
                value="${minorValue}"  ${minorValue === 1 ? "checked" : ""} required>
                <label for="minor" class="check-label">
                    <span>${$("#minorLabelTrans").val()} (<a target="_blank" href="/user/event/${eventId}/pdf/16"><span class="label">${$(
        "#minorLink16LabelTrans"
    ).val()}</span></a> 
                    &nbsp;|&nbsp;       
                    <a target="_blank" href="/user/event/${eventId}/pdf/18"><span class="label">${$("#minorLink18LabelTrans").val()}</span></a>)
                    </span>     
                </label>
            </div>
    `;
}




function formEscapeRoomBloc4FormRow({ticketRecurrenceId, attendeeIndex, label, attendee}) {
    console.log({attendeeIndex})
    let specialAttendeeIndex = parseInt(document.getElementById("specialAttendeeIndex").value);
    console.log({specialAttendeeIndex})
    document.getElementById("specialAttendeeIndex").value = specialAttendeeIndex + 1;
    const {name, surname, email, form_data, grandstand, row, seat, rid, price_type} = attendee;
    return `
    <fieldset class='attendee-fieldset escape-room-bloc4 card card--sm'>
        <h4>${label}
            #${price_type && grandstand && row && seat ? `${grandstand} - ${row} - ${seat} - ${price_type}` : attendeeIndex + 1}
        </h4>
        <div class='attendee-grid main-grid' id="form-${specialAttendeeIndex}">
            <div class="form-field important custom-check">
                <p><strong>${$("#important0LabelTrans").val()}</strong> ${$("#important0aLabelTrans").val()}</p>
            </div>

            <div class="form-field name">
                <label>${$("#nameRespLabelTrans").val()}</label>
                <input type='text' class='input attendee' value="${name}" name="name-${ticketRecurrenceId}${specialAttendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" data-rid="${rid}" required>
            </div>

            <div class="form-field surname">
                <label>${$("#surnameRespLabelTrans").val()}</label>
                <input type='text' class='input attendee' value="${surname}" name="surname-${ticketRecurrenceId}${specialAttendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" data-rid="${rid}" required>
            </div>

            <div class="form-field email">
                <label>${$("#emailRespLabelTrans").val()}</label>
                <input class='input attendee' type="email" value="${email}" name="email-${ticketRecurrenceId}${specialAttendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" data-rule-enrolment_email_unique_same_ticket_recurrence="false" data-rid="${rid}">
            </div>

            <div class="form-field typeGroup">
                <label>${$("#typeGroupLabelTrans").val()}</label>
                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" role="img">
                    <use href="images/icon-sprite.svg#angle-arrow"></use>
                </svg>
                <select 
                    class='input attendee' 
                    type="select"
                    value=''
                    name="typeGroup-${ticketRecurrenceId}${specialAttendeeIndex}"
                    data-id-ticket-recurrence="${ticketRecurrenceId}"
                    data-attendee-index="${attendeeIndex}"
                    onchange="
                    (function(e){ 
                        e.preventDefault(); 
                        (event.target.value) === 'centre_educatiu' ? 
                        
                            (
                                document.querySelector('#form-${specialAttendeeIndex} .attendee4').classList.add('visually-hidden'),
                                document.querySelector('#form-${specialAttendeeIndex} .attendee5').classList.add('visually-hidden'),
                                document.querySelector('#form-${specialAttendeeIndex} .attendee6').classList.add('visually-hidden'),
                                document.querySelector('#form-${specialAttendeeIndex} .attendee7').classList.add('visually-hidden'),
                                document.querySelector('#form-${specialAttendeeIndex} .attendee8').classList.add('visually-hidden'),
                                document.querySelector('#form-${specialAttendeeIndex} .attendee9').classList.add('visually-hidden'),
                                document.querySelector('#form-${specialAttendeeIndex} .attendee10').classList.add('visually-hidden'),
                                document.querySelectorAll('.type1${specialAttendeeIndex}').forEach(elemento => { elemento.classList.remove('visually-hidden'); }),
                                document.querySelectorAll('.type2${specialAttendeeIndex}').forEach(elemento => { elemento.classList.add('visually-hidden'); }),
                                maxAttendees[${specialAttendeeIndex}] = 1
                            ) 
                            : 
                            (
                                document.querySelector('#form-${specialAttendeeIndex} .attendee1,#form-${specialAttendeeIndex} .attendee2,#form-${specialAttendeeIndex} .attendee3,#form-${specialAttendeeIndex} .attendee4,#form-${specialAttendeeIndex} .attendee5,#form-${specialAttendeeIndex} .attendee6,#form-${specialAttendeeIndex} .attendee7,#form-${specialAttendeeIndex} .attendee8,#form-${specialAttendeeIndex} .attendee9,#form-${specialAttendeeIndex} .attendee10,#addAttendee${specialAttendeeIndex},#removeAttendee${specialAttendeeIndex}').classList.remove('visually-hidden'),

                                document.querySelectorAll('.type1${specialAttendeeIndex}').forEach(elemento => { elemento.classList.add('visually-hidden');} ),
                                document.querySelectorAll('.type2${specialAttendeeIndex}').forEach(elemento => { elemento.classList.remove('visually-hidden');}),
                                maxAttendees[${specialAttendeeIndex}] = 8,
                                (currentAttendee[${specialAttendeeIndex}] > 8 ? currentAttendee[${specialAttendeeIndex}] = 8 : currentAttendee[${specialAttendeeIndex}] = currentAttendee[${specialAttendeeIndex}]),
                                document.querySelector('#form-${specialAttendeeIndex} .attendee9').classList.add('visually-hidden'),
                                document.querySelector('#form-${specialAttendeeIndex} .attendee9').querySelectorAll('input[type=text]').forEach(input => input.value = ''),
                                document.querySelector('#form-${specialAttendeeIndex} .attendee10').classList.add('visually-hidden'),
                                document.querySelector('#form-${specialAttendeeIndex} .attendee10').querySelectorAll('input[type=text]').forEach(input => input.value = '')
                            );
                            updateButtons(${specialAttendeeIndex}
                        );
                    })(event)"
                    data-rid="${rid}" required
                    >
                    <option></option>
                    <option value="centre_educatiu" ${"typeGroup" in form_data ? ("value" in form_data.typeGroup ? (form_data.typeGroup.value === "centre_educatiu" ? "selected" : "") : "") : ""}>
                        ${$("#typeGroupOpt1LabelTrans").val()}
                    </option>
                    <option value="altres_grups" ${"typeGroup" in form_data ? ("value" in form_data.typeGroup ? (form_data.typeGroup.value === "altres_grups" ? "selected" : "") : "") : ""}>
                        ${$("#typeGroupOpt2LabelTrans").val()}
                    </option>
                </select>
            </div>
            <div class="form-field important custom-check visually-hidden type1${specialAttendeeIndex}">
                <p><strong>${$("#instrucionsLabelTrans").val()}</strong>: ${$("#important1LabelTrans").val()}</p>
                <p>${$("#important2LabelTrans").val()}</p>
            </div>
             <div class="form-field important custom-check visually-hidden type2${specialAttendeeIndex}">
                <p><strong>${$("#instrucionsLabelTrans").val()}</strong>: ${$("#important1aLabelTrans").val()}</p>
                <p>${$("#important2aLabelTrans").val()}</p>
            </div>
            <div class="form-field nameSchool  visually-hidden type1${specialAttendeeIndex}">
                <label>${$("#nameSchoolLabelTrans").val()}</label>
                <input 
                class='input attendee' 
                type="text"
                value='${"nameSchool" in form_data ? ("value" in form_data.nameSchool ? form_data.nameSchool.value : "") : ""}'
                name="nameSchool-${ticketRecurrenceId}${specialAttendeeIndex}"
                data-id-ticket-recurrence="${ticketRecurrenceId}"
                data-attendee-index="${attendeeIndex}"
                data-rid="${rid}" required
                />
            </div>

            <div class="form-field cif visually-hidden type1${specialAttendeeIndex}">
                <label>${$("#cifLabelTrans").val()}</label>
                <input 
                class='input attendee' 
                type="text"
                value='${"cif" in form_data ? ("value" in form_data.cif ? form_data.cif.value : "") : ""}'
                name="cif-${ticketRecurrenceId}${specialAttendeeIndex}"
                data-id-ticket-recurrence="${ticketRecurrenceId}"
                data-attendee-index="${attendeeIndex}"
                data-rid="${rid}" required
                />
            </div>

            <div class="form-field city visually-hidden type1${specialAttendeeIndex}"">
                <label>${$("#cityLabelTrans").val()}</label>
                <input 
                class='input attendee' 
                type="text"
                value='${"city" in form_data ? ("value" in form_data.city ? form_data.city.value : "") : ""}'
                name="city-${ticketRecurrenceId}${specialAttendeeIndex}"
                data-id-ticket-recurrence="${ticketRecurrenceId}"
                data-attendee-index="${attendeeIndex}"
                data-rid="${rid}" required
                />
            </div>
            
            <div class="form-field cp visually-hidden type1${specialAttendeeIndex}">
                <label>${$("#cpLabelTrans").val()}</label>
                <input 
                class='input attendee' 
                type="text"
                value='${"cp" in form_data ? ("value" in form_data.cp ? form_data.cp.value : "") : ""}'
                name="cp-${ticketRecurrenceId}${specialAttendeeIndex}"
                data-id-ticket-recurrence="${ticketRecurrenceId}"
                data-attendee-index="${attendeeIndex}"
                data-rid="${rid}" required
                />
            </div>
            
            <div class="form-field visually-hidden typeOrganization type2${specialAttendeeIndex}">
                <label>${$("#typeOrganizationLabelTrans").val()}</label>
                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" role="img">
                    <use href="images/icon-sprite.svg#angle-arrow"></use>
                </svg>
                <select 
                class='input attendee' 
                type="select"
                value=''
                name="typeOrganization-${ticketRecurrenceId}${specialAttendeeIndex}"
                data-id-ticket-recurrence="${ticketRecurrenceId}"
                data-attendee-index="${attendeeIndex}"
                data-rid="${rid}" required
                >
                    <option value=""></option>
                    <option value="coops_del_bloc4" ${"typeOrganization" in form_data ? ("value" in form_data.typeOrganization ? (form_data.typeOrganization.value === "coops_del_bloc4" ? "selected" : "") : "") : ""}>
                        ${$("#typeOrganizationOpt1LabelTrans").val()}
                    </option>
                    <option value="coops_ess" ${"typeOrganization" in form_data ? ("value" in form_data.typeOrganization ? (form_data.typeOrganization.value === "coops_ess" ? "selected" : "") : "") : ""}>
                        ${$("#typeOrganizationOpt2LabelTrans").val()}
                    </option>
                    <option value="entitat_representativa" ${"typeOrganization" in form_data ? ("value" in form_data.typeOrganization ? (form_data.typeOrganization.value === "entitat_representativa" ? "selected" : "") : "") : ""}>
                        ${$("#typeOrganizationOpt3LabelTrans").val()}
                    </option>
                    <option value="adm_publica" ${"typeOrganization" in form_data ? ("value" in form_data.typeOrganization ? (form_data.typeOrganization.value === "adm_publica" ? "selected" : "") : "") : ""}>
                        ${$("#typeOrganizationOpt4LabelTrans").val()}
                    </option>
                    <option value="empresa_mercantil" ${"typeOrganization" in form_data ? ("value" in form_data.typeOrganization ? (form_data.typeOrganization.value === "empresa_mercantil" ? "selected" : "") : "") : ""}>
                        ${$("#typeOrganizationOpt5LabelTrans").val()}
                    </option>
                    <option value="autonom_negoci_familiar" ${"typeOrganization" in form_data ? ("value" in form_data.typeOrganization ? (form_data.typeOrganization.value === "autonom_negoci_familiar" ? "selected" : "") : "") : ""}>
                        ${$("#typeOrganizationOpt6LabelTrans").val()}
                    </option>
                    <option value="grup_amics" ${"typeOrganization" in form_data ? ("value" in form_data.typeOrganization ? (form_data.typeOrganization.value === "grup_amics" ? "selected" : "") : "") : ""}>
                        ${$("#typeOrganizationOpt7LabelTrans").val()}
                    </option>
                    <option value="familia" ${"typeOrganization" in form_data ? ("value" in form_data.typeOrganization ? (form_data.typeOrganization.value === "familia" ? "selected" : "") : "") : ""}>
                        ${$("#typeOrganizationOpt8LabelTrans").val()}
                    </option>
                    <option value="altres" ${"typeOrganization" in form_data ? ("value" in form_data.typeOrganization ? (form_data.typeOrganization.value === "altres" ? "selected" : "") : "") : ""}>
                        ${$("#typeOrganizationOpt9LabelTrans").val()}
                    </option>
                </select>
            </div>

            <div class="form-field attendee1 visually-hidden type2${specialAttendeeIndex}">
                <label>${$("#attendeeLabelTrans").val()} 1</label>
                <div class='attendee-grid main-grid'>
                    <div class="form-field aname">
                        <label>${$("#nameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeName1" in form_data ? ("value" in form_data.attendeeName1 ? form_data.attendeeName1.value : "") : ""}'
                        name="attendeeName1-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field asurname">
                        <label>${$("#surnameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeSurname1" in form_data ? ("value" in form_data.attendeeSurname1 ? form_data.attendeeSurname1.value : "") : ""}'
                        name="attendeeSurname1-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field anif">
                        <label>${$("#nifonieLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"nif1" in form_data ? ("value" in form_data.nif1 ? form_data.nif1.value : "") : ""}'
                        name="nif1-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field gender">
                        <label>${$("#genderLabelTrans").val()} </label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeGender1" in form_data ? ("value" in form_data.attendeeGender1 ? form_data.attendeeGender1.value : "") : ""}'
                        name="attendeeGender1-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field birthday">
                        <label>${$("#birthdayLabelTrans").val()}</label>
                        <input 
                        placeholder='dd/mm/aaaa'
                        class='input attendee' 
                        type="text"
                        value='${"attendeeBirthday1" in form_data ? ("value" in form_data.attendeeBirthday1 ? form_data.attendeeBirthday1.value : "") : ""}'
                        name="attendeeBirthday1-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field town">
                        <label>${$("#townLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeTown1" in form_data ? ("value" in form_data.attendeeTown1 ? form_data.attendeeTown1.value : "") : ""}'
                        name="attendeeTown1-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                </div>
            </div>

            <div class="form-field attendee2 visually-hidden type2${specialAttendeeIndex}">
                <label>${$("#attendeeLabelTrans").val()} 2</label>
                <div class='attendee-grid main-grid'>
                    <div class="form-field aname">
                        <label>${$("#nameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeName2" in form_data ? ("value" in form_data.attendeeName2 ? form_data.attendeeName2.value : "") : ""}'
                        name="attendeeName2-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field asurname">
                        <label>${$("#surnameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeSurname2" in form_data ? ("value" in form_data.attendeeSurname2 ? form_data.attendeeSurname2.value : "") : ""}'
                        name="attendeeSurname2-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field anif">
                        <label>${$("#nifonieLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"nif2" in form_data ? ("value" in form_data.nif2 ? form_data.nif2.value : "") : ""}'
                        name="nif2-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field gender">
                        <label>${$("#genderLabelTrans").val()} </label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeGender2" in form_data ? ("value" in form_data.attendeeGender2 ? form_data.attendeeGender2.value : "") : ""}'
                        name="attendeeGender2-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field birthday">
                        <label>${$("#birthdayLabelTrans").val()}</label>
                        <input 
                        placeholder='dd/mm/aaaa'
                        class='input attendee' 
                        type="text"
                        value='${"attendeeBirthday2" in form_data ? ("value" in form_data.attendeeBirthday2 ? form_data.attendeeBirthday2.value : "") : ""}'
                        name="attendeeBirthday2-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field town">
                        <label>${$("#townLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeTown2" in form_data ? ("value" in form_data.attendeeTown2 ? form_data.attendeeTown2.value : "") : ""}'
                        name="attendeeTown2-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>

                </div>
            </div>

            <div class="form-field attendee3 visually-hidden type2${specialAttendeeIndex}">
                <label>${$("#attendeeLabelTrans").val()} 3</label>
                <div class='attendee-grid main-grid'>
                    <div class="form-field aname">
                        <label>${$("#nameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeName3" in form_data ? ("value" in form_data.attendeeName3 ? form_data.attendeeName3.value : "") : ""}'
                        name="attendeeName3-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field asurname">
                        <label>${$("#surnameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeSurname3" in form_data ? ("value" in form_data.attendeeSurname3 ? form_data.attendeeSurname3.value : "") : ""}'
                        name="attendeeSurname3-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field anif">
                        <label>${$("#nifonieLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"nif3" in form_data ? ("value" in form_data.nif3 ? form_data.nif3.value : "") : ""}'
                        name="nif3-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field gender">
                        <label>${$("#genderLabelTrans").val()} </label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeGender3" in form_data ? ("value" in form_data.attendeeGender3 ? form_data.attendeeGender3.value : "") : ""}'
                        name="attendeeGender3-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field birthday">
                        <label>${$("#birthdayLabelTrans").val()}</label>
                        <input 
                        placeholder='dd/mm/aaaa'
                        class='input attendee' 
                        type="text"
                        value='${"attendeeBirthday3" in form_data ? ("value" in form_data.attendeeBirthday3 ? form_data.attendeeBirthday3.value : "") : ""}'
                        name="attendeeBirthday3-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field town">
                        <label>${$("#townLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeTown3" in form_data ? ("value" in form_data.attendeeTown3 ? form_data.attendeeTown3.value : "") : ""}'
                        name="attendeeTown3-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>

                </div>
            </div>
            <div class="form-field visually-hidden attendee4">
                <label>${$("#attendeeLabelTrans").val()} 4</label>
                <div class='attendee-grid main-grid'>
                    <div class="form-field aname">
                        <label>${$("#nameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeName4" in form_data ? ("value" in form_data.attendeeName4 ? form_data.attendeeName4.value : "") : ""}'
                        name="attendeeName4-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field asurname">
                        <label>${$("#surnameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeSurname4" in form_data ? ("value" in form_data.attendeeSurname4 ? form_data.attendeeSurname4.value : "") : ""}'
                        name="attendeeSurname4-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field anif">
                        <label>${$("#nifonieLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"nif4" in form_data ? ("value" in form_data.nif4 ? form_data.nif4.value : "") : ""}'
                        name="nif4-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field gender">
                        <label>${$("#genderLabelTrans").val()} </label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeGender4" in form_data ? ("value" in form_data.attendeeGender4 ? form_data.attendeeGender4.value : "") : ""}'
                        name="attendeeGender4-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field birthday">
                        <label>${$("#birthdayLabelTrans").val()}</label>
                        <input 
                        placeholder='dd/mm/aaaa'
                        class='input attendee' 
                        type="text"
                        value='${"attendeeBirthday4" in form_data ? ("value" in form_data.attendeeBirthday4 ? form_data.attendeeBirthday4.value : "") : ""}'
                        name="attendeeBirthday4-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field town">
                        <label>${$("#townLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeTown4" in form_data ? ("value" in form_data.attendeeTown4 ? form_data.attendeeTown4.value : "") : ""}'
                        name="attendeeTown4-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>

                </div>
            </div>
            <div class="form-field visually-hidden attendee5">
                <label>${$("#attendeeLabelTrans").val()} 5</label>
                <div class='attendee-grid main-grid'>
                    <div class="form-field aname">
                        <label>${$("#nameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeName5" in form_data ? ("value" in form_data.attendeeName5 ? form_data.attendeeName5.value : "") : ""}'
                        name="attendeeName5-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field asurname">
                        <label>${$("#surnameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeSurname5" in form_data ? ("value" in form_data.attendeeSurname5 ? form_data.attendeeSurname5.value : "") : ""}'
                        name="attendeeSurname5-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field anif">
                        <label>${$("#nifonieLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"nif5" in form_data ? ("value" in form_data.nif5 ? form_data.nif5.value : "") : ""}'
                        name="nif5-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field gender">
                        <label>${$("#genderLabelTrans").val()} </label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeGender5" in form_data ? ("value" in form_data.attendeeGender5 ? form_data.attendeeGender5.value : "") : ""}'
                        name="attendeeGender5-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field birthday">
                        <label>${$("#birthdayLabelTrans").val()}</label>
                        <input 
                        placeholder='dd/mm/aaaa'
                        class='input attendee' 
                        type="text"
                        value='${"attendeeBirthday5" in form_data ? ("value" in form_data.attendeeBirthday5 ? form_data.attendeeBirthday5.value : "") : ""}'
                        name="attendeeBirthday5-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field town">
                        <label>${$("#townLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeTown5" in form_data ? ("value" in form_data.attendeeTown5 ? form_data.attendeeTown5.value : "") : ""}'
                        name="attendeeTown5-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                </div>
            </div>
            <div class="form-field visually-hidden attendee6">
                <label>${$("#attendeeLabelTrans").val()} 6</label>
                <div class='attendee-grid main-grid'>
                    <div class="form-field aname">
                        <label>${$("#nameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeName6" in form_data ? ("value" in form_data.attendeeName6 ? form_data.attendeeName6.value : "") : ""}'
                        name="attendeeName6-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field asurname">
                        <label>${$("#surnameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeSurname6" in form_data ? ("value" in form_data.attendeeSurname6 ? form_data.attendeeSurname6.value : "") : ""}'
                        name="attendeeSurname6-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field anif">
                        <label>${$("#nifonieLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"nif6" in form_data ? ("value" in form_data.nif6 ? form_data.nif6.value : "") : ""}'
                        name="nif6-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field gender">
                        <label>${$("#genderLabelTrans").val()} </label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeGender6" in form_data ? ("value" in form_data.attendeeGender6 ? form_data.attendeeGender6.value : "") : ""}'
                        name="attendeeGender6-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field birthday">
                        <label>${$("#birthdayLabelTrans").val()}</label>
                        <input 
                        placeholder='dd/mm/aaaa'
                        class='input attendee' 
                        type="text"
                        value='${"attendeeBirthday6" in form_data ? ("value" in form_data.attendeeBirthday6 ? form_data.attendeeBirthday6.value : "") : ""}'
                        name="attendeeBirthday6-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field town">
                        <label>${$("#townLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeTown6" in form_data ? ("value" in form_data.attendeeTown6 ? form_data.attendeeTown6.value : "") : ""}'
                        name="attendeeTown6-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                </div>
            </div>
            <div class="form-field visually-hidden attendee7">
                <label>${$("#attendeeLabelTrans").val()} 7</label>
                <div class='attendee-grid main-grid'>
                    <div class="form-field aname">
                        <label>${$("#nameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeName7" in form_data ? ("value" in form_data.attendeeName7 ? form_data.attendeeName7.value : "") : ""}'
                        name="attendeeName7-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field asurname">
                        <label>${$("#surnameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeSurname7" in form_data ? ("value" in form_data.attendeeSurname7 ? form_data.attendeeSurname7.value : "") : ""}'
                        name="attendeeSurname7-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field anif">
                        <label>${$("#nifonieLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"nif7" in form_data ? ("value" in form_data.nif7 ? form_data.nif7.value : "") : ""}'
                        name="nif7-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field gender">
                        <label>${$("#genderLabelTrans").val()} </label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeGender7" in form_data ? ("value" in form_data.attendeeGender7 ? form_data.attendeeGender7.value : "") : ""}'
                        name="attendeeGender7-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field birthday">
                        <label>${$("#birthdayLabelTrans").val()}</label>
                        <input 
                        placeholder='dd/mm/aaaa'
                        class='input attendee' 
                        type="text"
                        value='${"attendeeBirthday7" in form_data ? ("value" in form_data.attendeeBirthday7 ? form_data.attendeeBirthday7.value : "") : ""}'
                        name="attendeeBirthday7-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field town">
                        <label>${$("#townLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeTown7" in form_data ? ("value" in form_data.attendeeTown7 ? form_data.attendeeTown7.value : "") : ""}'
                        name="attendeeTown7-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                </div>
            </div>
            <div class="form-field visually-hidden attendee8">
                <label>${$("#attendeeLabelTrans").val()} 8</label>
                <div class='attendee-grid main-grid'>
                    <div class="form-field aname">
                        <label>${$("#nameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeName8" in form_data ? ("value" in form_data.attendeeName8 ? form_data.attendeeName8.value : "") : ""}'
                        name="attendeeName8-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field asurname">
                        <label>${$("#surnameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeSurname8" in form_data ? ("value" in form_data.attendeeSurname8 ? form_data.attendeeSurname8.value : "") : ""}'
                        name="attendeeSurname8-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field anif">
                        <label>${$("#nifonieLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"nif8" in form_data ? ("value" in form_data.nif8 ? form_data.nif8.value : "") : ""}'
                        name="nif8-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field gender">
                        <label>${$("#genderLabelTrans").val()} </label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeGender8" in form_data ? ("value" in form_data.attendeeGender8 ? form_data.attendeeGender8.value : "") : ""}'
                        name="attendeeGender8-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field birthday">
                        <label>${$("#birthdayLabelTrans").val()}</label>
                        <input 
                        placeholder='dd/mm/aaaa'
                        class='input attendee' 
                        type="text"
                        value='${"attendeeBirthday8" in form_data ? ("value" in form_data.attendeeBirthday8 ? form_data.attendeeBirthday8.value : "") : ""}'
                        name="attendeeBirthday8-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field town">
                        <label>${$("#townLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeTown8" in form_data ? ("value" in form_data.attendeeTown8 ? form_data.attendeeTown8.value : "") : ""}'
                        name="attendeeTown8-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                </div>
            </div>
            <div class="form-field visually-hidden attendee9">
                <label>${$("#attendeeLabelTrans").val()} 9</label>
                <div class='attendee-grid main-grid'>
                    <div class="form-field aname">
                        <label>${$("#nameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeName9" in form_data ? ("value" in form_data.attendeeName9 ? form_data.attendeeName9.value : "") : ""}'
                        name="attendeeName9-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field asurname">
                        <label>${$("#surnameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeSurname9" in form_data ? ("value" in form_data.attendeeSurname9 ? form_data.attendeeSurname9.value : "") : ""}'
                        name="attendeeSurname9-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field anif">
                        <label>${$("#nifonieLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"nif9" in form_data ? ("value" in form_data.nif9 ? form_data.nif9.value : "") : ""}'
                        name="nif9-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field gender">
                        <label>${$("#genderLabelTrans").val()} </label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeGender9" in form_data ? ("value" in form_data.attendeeGender9 ? form_data.attendeeGender9.value : "") : ""}'
                        name="attendeeGender9-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field birthday">
                        <label>${$("#birthdayLabelTrans").val()}</label>
                        <input 
                        placeholder='dd/mm/aaaa'
                        class='input attendee' 
                        type="text"
                        value='${"attendeeBirthday9" in form_data ? ("value" in form_data.attendeeBirthday9 ? form_data.attendeeBirthday9.value : "") : ""}'
                        name="attendeeBirthday9-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field town">
                        <label>${$("#townLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeTown9" in form_data ? ("value" in form_data.attendeeTown9 ? form_data.attendeeTown9.value : "") : ""}'
                        name="attendeeTown9-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                </div>
            </div>
            <div class="form-field visually-hidden attendee10">
                <label>${$("#attendeeLabelTrans").val()} 10</label>
                <div class='attendee-grid main-grid'>
                    <div class="form-field aname">
                        <label>${$("#nameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeName10" in form_data ? ("value" in form_data.attendeeName10 ? form_data.attendeeName10.value : "") : ""}'
                        name="attendeeName10-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field asurname">
                        <label>${$("#surnameLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeSurname10" in form_data ? ("value" in form_data.attendeeSurname10 ? form_data.attendeeSurname10.value : "") : ""}'
                        name="attendeeSurname10-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field anif">
                        <label>${$("#nifonieLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"nif10" in form_data ? ("value" in form_data.nif10 ? form_data.nif10.value : "") : ""}'
                        name="nif10-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field gender">
                        <label>${$("#genderLabelTrans").val()} </label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeGender10" in form_data ? ("value" in form_data.attendeeGender10 ? form_data.attendeeGender10.value : "") : ""}'
                        name="attendeeGender10-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field birthday">
                        <label>${$("#birthdayLabelTrans").val()}</label>
                        <input 
                        placeholder='dd/mm/aaaa'
                        class='input attendee' 
                        type="text"
                        value='${"attendeeBirthday10" in form_data ? ("value" in form_data.attendeeBirthday10 ? form_data.attendeeBirthday10.value : "") : ""}'
                        name="attendeeBirthday10-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                    <div class="form-field town">
                        <label>${$("#townLabelTrans").val()}</label>
                        <input 
                        class='input attendee' 
                        type="text"
                        value='${"attendeeTown10" in form_data ? ("value" in form_data.attendeeTown10 ? form_data.attendeeTown10.value : "") : ""}'
                        name="attendeeTown10-${ticketRecurrenceId}${specialAttendeeIndex}"
                        data-id-ticket-recurrence="${ticketRecurrenceId}"
                        data-attendee-index="${attendeeIndex}"
                        data-rid="${rid}" required
                        />
                    </div>
                </div>
            </div>

            <button type="button" class="button button--default addAttendee visually-hidden type2${specialAttendeeIndex}" id="addAttendee${specialAttendeeIndex}" onclick="if (currentAttendee[${specialAttendeeIndex}] < maxAttendees[${specialAttendeeIndex}]) { currentAttendee[${specialAttendeeIndex}]++; document.querySelector('#form-${specialAttendeeIndex} .attendee' + currentAttendee[${specialAttendeeIndex}]).classList.remove('visually-hidden'); } updateButtons(${specialAttendeeIndex});">${$("#addAttendeeLabelTrans").val()}</button>
            
            <button type="button" class="button button--default removeAttendee visually-hidden type2${specialAttendeeIndex}" id="removeAttendee${specialAttendeeIndex}" onclick="if (currentAttendee[${specialAttendeeIndex}] > minAttendees) { let attendeeFields = document.querySelector('#form-${specialAttendeeIndex} .attendee' + currentAttendee[${specialAttendeeIndex}]); attendeeFields.classList.add('visually-hidden'); attendeeFields.querySelectorAll('input[type=text]').forEach(input => input.value = ''); currentAttendee[${specialAttendeeIndex}]--; } updateButtons(${specialAttendeeIndex});" disabled>${$("#removeAttendeeLabelTrans").val()}</button>

            <div class="form-field notChilds custom-check visually-hidden type1${specialAttendeeIndex}">
                <input class='attendee visually-hidden' type="checkbox" name="notChilds-${ticketRecurrenceId}${specialAttendeeIndex}" id="notChilds-${ticketRecurrenceId}${specialAttendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" data-rid="${rid}">
                <label for="notChilds-${ticketRecurrenceId}${specialAttendeeIndex}" class="check-label">${$("#notChildsLabelTrans").val()}</label>
            </div>

            <div class="form-field compromise custom-check visually-hidden type1${specialAttendeeIndex}">
                <input class='attendee visually-hidden' type="checkbox" name="compromise-${ticketRecurrenceId}${specialAttendeeIndex}" id="compromise-${ticketRecurrenceId}${specialAttendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" data-rid="${rid}" required>
                <label for="compromise-${ticketRecurrenceId}${specialAttendeeIndex}" class="check-label">${$("#compromiseLabelTrans").val()}</label>
            </div>

            <div class="form-field childs custom-check visually-hidden type2${specialAttendeeIndex}">
                <input class='attendee visually-hidden' type="checkbox" name="childs-${ticketRecurrenceId}${specialAttendeeIndex}" id="childs-${ticketRecurrenceId}${specialAttendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" data-rid="${rid}">
                <label for="childs-${ticketRecurrenceId}${specialAttendeeIndex}" class="check-label">${$("#childsLabelTrans").val()}</label>
            </div>

            <div class="form-field under30 custom-check visually-hidden type2${specialAttendeeIndex}">
                <input class='attendee visually-hidden' type="checkbox" name="under30-${ticketRecurrenceId}${specialAttendeeIndex}" id="under30-${ticketRecurrenceId}${specialAttendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" data-rid="${rid}">
                <label for="under30-${ticketRecurrenceId}${specialAttendeeIndex}" class="check-label">${$("#under30LabelTrans").val()}</label>
            </div>

            <div class="form-field complementary custom-check visually-hidden type1${specialAttendeeIndex}">
                <input class='attendee visually-hidden' type="checkbox" name="complementary-${ticketRecurrenceId}${specialAttendeeIndex}" id="complementary-${ticketRecurrenceId}${specialAttendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" data-rid="${rid}">
                <label for="complementary-${ticketRecurrenceId}${specialAttendeeIndex}" class="check-label">${$("#complementaryLabelTrans").val()}</label>
            </div>

        </div>
    </fieldset>`;
}

function formEscapeRoomBloc4ExtraFormRow({ticketRecurrenceId, attendeeIndex, label, attendee}) {
    const {name, surname, email, form_data, grandstand, row, seat, price_type} = attendee;
    return `
    <fieldset class='attendee-fieldset escape-room-bloc4-extra card card--sm'>
        <h4>${label}
            #${price_type && grandstand && row && seat ? `${grandstand} - ${row} - ${seat} - ${price_type}` : attendeeIndex + 1}
        </h4>
        <div class='attendee-grid main-grid'>

            <div class="form-field name">
                <label>${$("#nameLabelTrans").val()}</label>
                <input class='input attendee' value="${name}" name="name-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" required>
            </div>

            <div class="form-field surname">
                <label>${$("#surnameLabelTrans").val()}</label>
                <input class='input attendee' value="${surname}" name="surname-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" required>
            </div>
            <div class="form-field anif">
                <label>${$("#dniNiePassportLabelTrans").val()}</label>
                <input 
                class='input attendee' 
                type="text"
                value='${"nif1" in form_data ? ("value" in form_data.nif1 ? form_data.nif1.value : "") : ""}'
                name="nif1-${ticketRecurrenceId}-${attendeeIndex}"
                data-id-ticket-recurrence="${ticketRecurrenceId}"
                data-attendee-index="${attendeeIndex}"
                required
                />
            </div>
            <div class="form-field nameSchool">
                <label>${$("#nameSchoolLabelTrans").val()}</label>
                <input 
                class='input attendee' 
                type="text"
                value='${"nameSchool" in form_data ? ("value" in form_data.nameSchool ? form_data.nameSchool.value : "") : ""}'
                name="nameSchool-${ticketRecurrenceId}-${attendeeIndex}"
                data-id-ticket-recurrence="${ticketRecurrenceId}"
                data-attendee-index="${attendeeIndex}"
                required
                />
            </div>
           
            <div class="form-field gender">
                <label>${$("#genderLabelTrans").val()} </label>
                <input 
                class='input attendee' 
                type="text"
                value='${"attendeeGender1" in form_data ? ("value" in form_data.attendeeGender1 ? form_data.attendeeGender1.value : "") : ""}'
                name="attendeeGender1-${ticketRecurrenceId}-${attendeeIndex}"
                data-id-ticket-recurrence="${ticketRecurrenceId}"
                data-attendee-index="${attendeeIndex}"
                required
                />
            </div>
            <div class="form-field birthday">
                <label>${$("#birthdayLabelTrans").val()}</label>
                <input 
                class='input attendee' 
                type="text"
                value='${"attendeeBirthday1" in form_data ? ("value" in form_data.attendeeBirthday1 ? form_data.attendeeBirthday1.value : "") : ""}'
                name="attendeeBirthday1-${ticketRecurrenceId}-${attendeeIndex}"
                data-id-ticket-recurrence="${ticketRecurrenceId}"
                data-attendee-index="${attendeeIndex}"
                required
                />
            </div>
            <div class="form-field schedule">
                <label>${$("#scheduleLabelTrans").val()}</label>
                <input 
                class='input attendee' 
                type="text"
                value='${"attendeeSchedule" in form_data ? ("value" in form_data.attendeeSchedule ? form_data.attendeeSchedule1.value : "") : ""}'
                name="attendeeSchedule-${ticketRecurrenceId}-${attendeeIndex}"
                data-id-ticket-recurrence="${ticketRecurrenceId}"
                data-attendee-index="${attendeeIndex}"
                required
                />
            </div>
            <div class="form-field town">
                <label>${$("#townLabelTrans").val()}</label>
                <input 
                class='input attendee' 
                type="text"
                value='${"attendeeTown1" in form_data ? ("value" in form_data.attendeeTown1 ? form_data.attendeeTown1.value : "") : ""}'
                name="attendeeTown1-${ticketRecurrenceId}-${attendeeIndex}"
                data-id-ticket-recurrence="${ticketRecurrenceId}"
                data-attendee-index="${attendeeIndex}"
                required
                />
            </div>
        </div>
    </fieldset>`;
}

function formEscoltesFormRow({ticketRecurrenceId, attendeeIndex, label, attendee}) {
    const {name, surname, email, form_data, grandstand, row, seat, price_type} = attendee;


    return `<fieldset class='attendee-fieldset card card--sm escoltes'>
        <h4>${label}
            #${price_type && grandstand && row && seat ? `${grandstand} - ${row} - ${seat} - ${price_type}` : attendeeIndex + 1}
        </h4>
        <div class='attendee-grid main-grid'>
            <div class="form-field name">
                <label>${$("#nameLabelTrans").val()}</label>
                <input class='input attendee' value="${name}" name="name-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" required>
            </div>
            <div class="form-field surname">
                <label>${$("#surnameLabelTrans").val()}</label>
                <input class='input attendee' value="${surname}" name="surname-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" required>
            </div>
            <div class="form-field email">
                <label>${$("#emailObligatoryLabelTrans").val()}</label>
                <input class='input attendee' type="email" value="${email}" name="email-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" required>
            </div>

            <div class="form-field vegueria">
                <label>${$("#vegueriaLabelTrans").val()}</label>
                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" role="img">
                    <use href="images/icon-sprite.svg#angle-arrow"></use>
                </svg>
                <select 
                class='input vegueria' 
                type="select"
                value=''
                name="vegueria-${ticketRecurrenceId}-${attendeeIndex}"
                data-id-ticket-recurrence="${ticketRecurrenceId}"
                data-attendee-index="${attendeeIndex}"
                >
                    <option value=""></option>
                    <option value="0" ${
                        "vegueria" in form_data
                            ? "value" in form_data.vegueria
                                ? form_data.vegueria.value === "0"
                                    ? "selected"
                                    : ""
                                : ""
                            : ""
                    }>Vegueria Baix Llobregat - Anoia</option>
                    <option value="1" ${
                        "vegueria" in form_data
                            ? "value" in form_data.vegueria
                                ? form_data.vegueria.value === "1"
                                    ? "selected"
                                    : ""
                                : ""
                            : ""
                    }>Vegueria Barcelonès</option>
                    <option value="2" ${
                        "vegueria" in form_data
                            ? "value" in form_data.vegueria
                                ? form_data.vegueria.value === "2"
                                    ? "selected"
                                    : ""
                                : ""
                            : ""
                    }>Vegueria Camp de Tarragona - Penedès</option>
                    <option value="3" ${
                        "vegueria" in form_data
                            ? "value" in form_data.vegueria
                                ? form_data.vegueria.value === "3"
                                    ? "selected"
                                    : ""
                                : ""
                            : ""
                    }>Vegueria Ponent</option>
                    <option value="4" ${
                        "vegueria" in form_data
                            ? "value" in form_data.vegueria
                                ? form_data.vegueria.value === "4"
                                    ? "selected"
                                    : ""
                                : ""
                            : ""
                    }>Vegueria Maresme</option>
                    <option value="5" ${
                        "vegueria" in form_data
                            ? "value" in form_data.vegueria
                                ? form_data.vegueria.value === "5"
                                    ? "selected"
                                    : ""
                                : ""
                            : ""
                    }>Vegueria Vallès</option>

                </select>
            </div>
        </div>
    </fieldset>`;
}
// TODO: Translations
function formAutobusPalestina1FormRow({ticketRecurrenceId, attendeeIndex, label, attendee}) {
    const {name, surname, email, ruta, grandstand, row, seat, rid, price_type} = attendee;

    console.log({ruta});

    return `<fieldset class='attendee-fieldset card card--sm'>
        <h4>${label}
            #${price_type && grandstand && row && seat ? `${grandstand} - ${row} - ${seat} - ${price_type}` : attendeeIndex + 1}
        </h4>
        <div class='attendee-grid main-grid'>
            <div class="form-field name">
                <label>${$("#nameLabelTrans").val()}</label>
                <input class='input attendee' value="${name}" name="name-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" required>
            </div>
            <div class="form-field surname">
                <label>${$("#surnameLabelTrans").val()}</label>
                <input class='input attendee' value="${surname}" name="surname-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" required>
            </div>
            <div class="form-field email">
                <label>${$("#emailOptionalLabelTrans").val()}</label>
                <input class='input attendee' type="email" value="${email}" name="email-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}">
            </div>
            <div class="form-field selectorCol3">
                <label>Lloc de sortida</label>
                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" role="img">
                    <use href="images/icon-sprite.svg#angle-arrow"></use>
                </svg>
                <select class='input select attendee' name="ruta-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" data-rid="${rid}" required>
                    <option value=""></option>    
                    <option value="1" ${ruta === "1" ? "selected" : ""}>Sortida Girona (Fira)</option>
                    <option value="2" ${ruta === "2" ? "selected" : ""}>Sortida Granollers (Estació d'autobusus)</option>
                </select>
            </div>
        </div>
    </fieldset>`;
}


// TODO: Translations
function formAutobusPalestina2FormRow({ticketRecurrenceId, attendeeIndex, label, attendee}) {
    const {name, surname, email, ruta, grandstand, row, seat, rid, price_type} = attendee;

    console.log({ruta});

    return `<fieldset class='attendee-fieldset card card--sm'>
        <h4>${label}
            #${price_type && grandstand && row && seat ? `${grandstand} - ${row} - ${seat} - ${price_type}` : attendeeIndex + 1}
        </h4>
        <div class='attendee-grid main-grid'>
            <div class="form-field name">
                <label>${$("#nameLabelTrans").val()}</label>
                <input class='input attendee' value="${name}" name="name-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" required>
            </div>
            <div class="form-field surname">
                <label>${$("#surnameLabelTrans").val()}</label>
                <input class='input attendee' value="${surname}" name="surname-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" required>
            </div>
            <div class="form-field email">
                <label>${$("#emailOptionalLabelTrans").val()}</label>
                <input class='input attendee' type="email" value="${email}" name="email-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}">
            </div>
            <div class="form-field selectorCol3">
                <label>Lloc de sortida</label>
                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" role="img">
                    <use href="images/icon-sprite.svg#angle-arrow"></use>
                </svg>
                <select class='input select attendee' name="ruta-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" data-rid="${rid}" required>
                    <option value=""></option>    
                    <option value="3" ${ruta === "3" ? "selected" : ""}>Sortida Tordera (Parc de la Sardana)</option>
                    <option value="4" ${ruta === "4" ? "selected" : ""}>Sortida Mataró (Mataró Parc)</option>
                    <option value="5" ${ruta === "5" ? "selected" : ""}>Sortida Badalona (Museu de Badalona)</option>
                </select>
            </div>
        </div>
    </fieldset>`;
}




// TODO: Translations
function formAutobusPalestina3FormRow({ticketRecurrenceId, attendeeIndex, label, attendee}) {
    const {name, surname, email, ruta, grandstand, row, seat, rid, price_type} = attendee;

    console.log({ruta});

    return `<fieldset class='attendee-fieldset card card--sm'>
        <h4>${label}
            #${price_type && grandstand && row && seat ? `${grandstand} - ${row} - ${seat} - ${price_type}` : attendeeIndex + 1}
        </h4>
        <div class='attendee-grid main-grid'>
            <div class="form-field name">
                <label>${$("#nameLabelTrans").val()}</label>
                <input class='input attendee' value="${name}" name="name-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" required>
            </div>
            <div class="form-field surname">
                <label>${$("#surnameLabelTrans").val()}</label>
                <input class='input attendee' value="${surname}" name="surname-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" required>
            </div>
            <div class="form-field email">
                <label>${$("#emailOptionalLabelTrans").val()}</label>
                <input class='input attendee' type="email" value="${email}" name="email-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}">
            </div>
            <div class="form-field selectorCol3">
                <label>Lloc de sortida</label>
                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" role="img">
                    <use href="images/icon-sprite.svg#angle-arrow"></use>
                </svg>
                <select class='input select attendee' name="ruta-${ticketRecurrenceId}-${attendeeIndex}" data-id-ticket-recurrence="${ticketRecurrenceId}" data-attendee-index="${attendeeIndex}" data-rid="${rid}" required>
                    <option value=""></option>    
                    <option value="6" ${ruta === "6" ? "selected" : ""}>Sortida Manresa (Renfe)</option>
                    <option value="7" ${ruta === "7" ? "selected" : ""}>Sortida Sabadell (Estació Renfe Sabadell Centre)</option>
                </select>
            </div>
        </div>
    </fieldset>`;
}


/* prepen carga los js, los que no se usan se comentan */

// ./forms/_form1.js
// ./forms/_form2.js
// ./forms/_form3.js
// ./forms/_formUescoopAttendee.js
// ./forms/_formUescoopStudent.js
// ./forms/_formUescoopSpeacker.js
// ./forms/_formUescoopUniPetita.js
// ./forms/_formUescoopUniPetita0to4.js
// ./forms/_formEsperanzahVueling.js
// ./forms/_formResiduZero.js
// ./forms/_formCentreDelas.js
// ./forms/_formHkdGeneral.js
// ./forms/_formHkdSocis.js
// ./forms/_formHkdNoSocis.js
// ./forms/_formAbacus.js

// Organism cart-2-attendees scripts
console.log("//Organism cart-2-attendees scripts");

// * On-screen keyboard active (body class toggle)
const wSize = window.innerHeight;
window.addEventListener("resize", reportWindowSize);
function reportWindowSize() {
    const newHsize = window.innerHeight;
    if (newHsize / wSize > 0.7) {
        $("body").removeClass("kbd-active");
    } else {
        $("body").addClass("kbd-active");
    }
    return false;
}

$("form#attendeeList").validate({
    lang: "ca", // or whatever language option you have.
});

function invitationField(action) {
    if (action === true) {
        console.log("Autocomplete filds");
        $(".name input.attendee").val($("#invitationLabel").val());
        const idOrder = $("#cart").data("id_order");

        $(".attendee-fieldset").each(function () {
            const surnameInput = $(this).find(".surname input");
            const attendeeSurname = surnameInput.attr("data-attendee-invitation");
            const uniqueId = `#${idOrder}-${attendeeSurname}`;
            surnameInput.val(uniqueId);
        });
    } else {
        console.log("Erase fields");
        $(".name input.attendee").val("");
        $(".surname input.attendee").val("");
    }
    updateAllFields();
}

function updateAllFields() {
    $(".attendee-wrap input, .attendee-wrap select").each(function () {
        addInputDataToOrder(this);
    });
}

$(function () {
    $(".cart-2-attendees").on("change", "input, select", function () {
        addInputDataToOrder(this);
    });

    $(".cart-2-attendees").on("change", ".organization_yes_no input", function () {
        console.log("changing radio");
        const radioValue = $(this).val();
        if (radioValue === "yes") {
            $(this).parent().parent().next("div.group-organization").show();
        } else {
            $(this).parent().parent().next("div.group-organization").hide();
        }
    });

    $(".cart-2-attendees").on("change", ".organization_invoice_yes_no input", function () {
        console.log("changing radio");
        const radioValue = $(this).val();
        if (radioValue === "yes") {
            $(this).parent().parent().next("div.group-organization-invoice").show();
        } else {
            $(this).parent().parent().next("div.group-organization-invoice").hide();
        }
    });

    $(".cart-2-attendees").on("change", ".lunch_yes_no input", function () {
        console.log("changing radio");
        const radioValue = $(this).val();
        if (radioValue === "yes") {
            $(this).parent().parent().next("div.group-lunch").show();
        } else {
            const groupLunch = $(this).parent().parent().next("div.group-lunch");
            groupLunch.hide();
            groupLunch.find(":input").each(function () {
                const input = $(this);
                if (input.attr("type") === "text") input.val("");
                if (input.attr("type") === "checkbox") input.prop("checked", false);
            });
        }
    });
});

function addInputDataToOrder(currentInput) {
    console.log("Attendee Input Changed");

    const inputName = $(currentInput).attr("name");
    let value = $(currentInput).val();

    if ($(currentInput).attr("type") === "checkbox") {
        value = $(currentInput).prop("checked") ? "1" : "0";
    }

    if (value.trim() === "") {
        $(currentInput).val("");
        value = "";
    }

    console.log(">>>>>>>>>>>>>>>>>>>>>>>>>", inputName, value);

    if (inputName !== "minor") {
        const ticketRecurrenceId = $(currentInput).attr("data-id-ticket-recurrence");
        const priceTypeId = $(currentInput).attr("data-id-price-type");
        const attendeeIndex = $(currentInput).attr("data-attendee-index");
        const ticketRecurrence = getTicketRecurrence(ticketRecurrenceId);

        let orderLineIndex = ticketRecurrenceId+"_"+priceTypeId;
        if (ticketRecurrence && ticketRecurrence.seatable_ticket) {
            orderLineIndex = $(currentInput).attr("data-rid");
            console.log("Seteable orderLineIndex data-rid: "+orderLineIndex);
        }
        console.log(">>>>>>>>>>>>>>>>>>>>>>>>>", orderLineIndex);
        addAttendeeData(orderLineIndex, attendeeIndex, currentInput, inputName, value);
    } else {
        addAttendeeMinorData(value);
    }
}

$("#detail_2-toggle-order").on("click", function () {
    $(".summary-footer").toggleClass("opened");
});

function attendeeAssign() {
    console.log("function attendeeAssign()");
    if (Object.values(orderLines).length == 0) {
        // TODO: Mostrar un error per l'usuari conforme ha de seleccionar alguna entrada si vol continuar
        console.log("Fes la teva reserva per continuar");
    } else {
        $(".cart-1-reserve, .cart-1-5-seats").hide();
        $(".cart-2-attendees").show();
        $("#cart > .main-container").scrollTop(0);
        $(".timer").appendTo(".cart-2-attendees .timer-wrap");
        document.getElementById("specialAttendeeIndex").value = 0;

        prepareAttendees();
    }
}

function prepareAttendees() {
    console.log("function prepareAttendees()");
    $(".attendee-wrap *").remove();
    let isDonationFlags = [];
    const formConfig = JSON.parse($("#form-config").val());
    console.log({formConfig})
    console.log({orderLines});
    Object.values(orderLines).forEach((orderLine) => {
        console.log({orderLine});
        if (orderLine.qty > 0) {
            isDonationFlags.push(isDonationOrder(orderLine));
        }
        if (orderLine.attendees === undefined) {
            orderLine.attendees = [];
        }

        const attendeesInbound = orderLine.attendees.splice(0, orderLine.qty * orderLine.multiplier);
        orderLine.attendees = attendeesInbound;

        for (let attendeeIndex = 0; attendeeIndex < (orderLine.qty * orderLine.multiplier); attendeeIndex++) {
            if (orderLine.attendees[attendeeIndex] === undefined) {
                orderLine.attendees[attendeeIndex] = {
                    name: "",
                    surname: "",
                    email: "",
                    city: "",
                    company_type: "0",
                    opt_in: "",
                    phone: "",
                    dinner: "",
                    footwear: "",
                    sandwich: "",
                    rid: orderLine.rid || "",
                    price_type: orderLine.price_type || "",
                    grandstand: orderLine.grandstandName,
                    row: orderLine.rowName,
                    seat: orderLine.seatName,
                    minor: "0",
                    id_ticket_form: null,
                    form_data: {},
                };
            }
            printAttendeeLine({
                ticketRecurrenceId: orderLine.id_ticket_recurrence,
                priceTypeId: orderLine.id_price_type,
                attendeeIndex,
                label: orderLine.label,
                formConfig,
                attendee: orderLine.attendees[attendeeIndex],
            });
        }

        donationTicketsQuantity = isDonationFlags.reduce((partial_sum, a) => partial_sum + a, 0);
        setDonationOrderStatus(donationTicketsQuantity);
    });
    console.log("BEFORE MINOR")
    addMinorCheckbox({formConfig});
    console.log("HELLO THERE!")
}

// const getNonExistingAttendees = (ticketsQuantity) => Object

function addMinorCheckbox({formConfig}) {
    console.log("function addMinorCheckbox() ONLINE");
    const eventId = $("#id-event").val();
    const {form_4: form} = formConfig;
    console.log({eventId}, {form});

    const hasEventActivation = form.event.includes(parseInt(eventId));

    if (!hasEventActivation) return;

    // If form_4 has activated ticket recurrence configuracion if is not in the list don't show the checkbox
    const configTicketRecurrenceIds = form.id_ticket_recurrences[eventId];
    console.log({configTicketRecurrenceIds});
    let hasToCheckTicketRecurrence = true;
    if (configTicketRecurrenceIds.length === 0) hasToCheckTicketRecurrence = false;

    if (hasToCheckTicketRecurrence) {
        let ticketRecurrenceInCart = false;
        const ticketRecurrenceIds = Object.keys(orderLines);
        console.log({ticketRecurrenceIds});
        ticketRecurrenceIds.forEach((ticketRecurrenceId) => {
            if (configTicketRecurrenceIds.includes(parseInt(ticketRecurrenceId))) {
                console.log(orderLines[ticketRecurrenceId]);
                if (orderLines[ticketRecurrenceId].qty > 0) {
                    ticketRecurrenceInCart = true;
                }
            }
        });

        if (!ticketRecurrenceInCart) return;
    }

    let minor = 0;
    let attendeesNum = 0;
    Object.values(orderLines).forEach((orderLine) => {
        orderLine.attendees.forEach((attendee) => {
            minor += parseInt(attendee.minor);
            attendeesNum += 1;
        });
    });
    const minorValue = minor === attendeesNum ? 1 : 0;
    $(".attendee-wrap").append(minorForm({minorValue, eventId}));
}

function addAttendeeMinorData(value) {
    console.log("function addAttendeeMinorData()");
    Object.values(orderLines).forEach((orderLine) => {
        orderLine.attendees.forEach((attendee) => {
            attendee.minor = value;
        });
    });
}

function isDonationOrder(orderLine) {
    return orderLine.ticket_type === "donation" && orderLine.price_amount > 0 ? 1 : 0;
}

function setDonationOrderStatus(donationTicketsQuantity) {
    console.log("function setDonationOrderStatus()");
    console.log(`Donations quantity: ${donationTicketsQuantity}`);
    if (donationTicketsQuantity > 0) {
        $("#is-donation").val("Yes");
    } else {
        $("#is-donation").val("");
    }
    setBackCart4Checkout();
}

function printAttendeeLine({ticketRecurrenceId, priceTypeId, attendeeIndex, label, formConfig, attendee}) {
    console.log("function printAttendeeLine()");

    let formRow = defaultFormRow({ticketRecurrenceId, priceTypeId, attendeeIndex, label, attendee});
    let loadedForm = "FORM_DEFAULT";

    let ids = formConfig.form_6.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = form1FormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_1";
    // }

    // ids = formConfig.form_2.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = form2FormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_2";
    // }

    // ids = formConfig.form_3.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = form3FormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_3";
    // }

    ids = formConfig.form_5.id_ticket_recurrences;
    if (ids.includes(parseInt(ticketRecurrenceId))) {
        formRow = form5FormRow({ticketRecurrenceId, priceTypeId, attendeeIndex, label, attendee});
        loadedForm = "FORM_5";
    }

    ids = formConfig.form_6.id_ticket_recurrences;
    if (ids.includes(parseInt(ticketRecurrenceId))) {
        formRow = form6FormRow({ticketRecurrenceId, priceTypeId, attendeeIndex, label, attendee});
        loadedForm = "FORM_6";
    }

    // ids = formConfig.uescoop_attendee.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = formUescoopAttendeeFormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_uescoop_attendee";
    // }

    // ids = formConfig.uescoop_student.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = formUescoopStudentFormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_uescoop_student";
    // }

    // ids = formConfig.uescoop_speacker.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = formUescoopSpeackerFormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_uescoop_speacker";
    // }
    // ids = formConfig.uescoop_uni_petita.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = formUescoopUniPetitaFormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_uescoop_uni_petita";
    // }
    // ids = formConfig.uescoop_uni_petita_0to4.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = formUescoopUniPetita0to4FormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_uescoop_uni_petita_0to4";
    // }
    // ids = formConfig.esperanzah_vueling.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = formEsperanzahVuelingFormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_esperanzah_vueling";
    // }
    // ids = formConfig.residu_zero.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = formResiduZeroFormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_residu_zero";
    // }
    // ids = formConfig.centre_delas.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = formCentreDelasFormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_centre_delas";
    // }
    // ids = formConfig.hkd_general.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = formHkdGeneralFormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_hkd_general";
    // }
    // ids = formConfig.hkd_seminario_socios.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = formHkdSeminarioSociosFormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_hkd_seminario_socios";
    // }
    // ids = formConfig.hkd_seminario_no_socios.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = formHkdSeminarioNoSociosFormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_hkd_seminario_no_socios";
    // }

    ids = formConfig.escape_room_bloc4.id_ticket_recurrences;
    if (ids.includes(parseInt(ticketRecurrenceId))) {
        formRow = formEscapeRoomBloc4FormRow({ticketRecurrenceId, priceTypeId, attendeeIndex, label, attendee});
        loadedForm = "FORM_escape_room_bloc4";
    }

    ids = formConfig.escape_room_bloc4_extra.id_ticket_recurrences;
    if (ids.includes(parseInt(ticketRecurrenceId))) {
        formRow = formEscapeRoomBloc4ExtraFormRow({ticketRecurrenceId, priceTypeId, attendeeIndex, label, attendee});
        loadedForm = "FORM_escape_room_bloc4_extra";
    }

    // ids = formConfig.abacus.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = formAbacusFormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_abacus";
    // }

    ids = formConfig.escoltes.id_ticket_recurrences;
    if (ids.includes(parseInt(ticketRecurrenceId))) {
        formRow = formEscoltesFormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
        loadedForm = "FORM_escoltes";
    }

    // ids = formConfig.autobus_palestina1.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = formAutobusPalestina1FormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_autobus_palestina1";
    // }

    // ids = formConfig.autobus_palestina2.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = formAutobusPalestina2FormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_autobus_palestina2";
    // }

    // ids = formConfig.autobus_palestina3.id_ticket_recurrences;
    // if (ids.includes(parseInt(ticketRecurrenceId))) {
    //     formRow = formAutobusPalestina3FormRow({ticketRecurrenceId, attendeeIndex, label, attendee});
    //     loadedForm = "FORM_autobus_palestina3";
    // }

    console.log(`Loaded form: ${loadedForm}`);

    $(".attendee-wrap").append(formRow);
}

function addAttendeeData(orderLineIndex, attendeeIndex, currentInput, inputName, value) {
    console.log("function addAttendeeData()");
    console.log( inputName.split("-") );
    const [field] = inputName.split("-");
    console.log({orderLineIndex}, {attendeeIndex}, {inputName}, {field}, {value});
    console.log("orderLines["+orderLineIndex+"].attendees["+attendeeIndex+"]["+field+"] = "+value+";");
    
    orderLines[orderLineIndex].attendees[attendeeIndex][field] = value;
    console.log({orderLines});

    const type = $(currentInput).attr("type");
    console.log({currentInput, type});
    orderLines[orderLineIndex].attendees[attendeeIndex]["form_data"][field] = {
        id_field: field,
        value: value,
        type: type || "text",
    };
}

jQuery.validator.addMethod(
    "code",
    function (value, element) {
        return checkCodes(element);
    },
    $("#codeErrorTrans").val()
);

function checkCodes(input) {
    console.log("function checkCodes()");
    const data = {code: input.value, ticketRecurrenceId: $(input).attr("data-id-ticket-recurrence")};
    const now = new Date();
    const formConfig = JSON.parse($("#form-config").val());

    let configCodes = formConfig.form_5.codes;
    if (configCodes[data.ticketRecurrenceId] === undefined) {
        configCodes = formConfig.uescoop_speacker.codes;
    }

    if (mysqlToJsDateTime(configCodes[data.ticketRecurrenceId].valid) < now) {
        console.log("error code expired");
        return false;
    }

    if (configCodes[data.ticketRecurrenceId].code !== data.code) {
        console.log("error no valid code");
        return false;
    }

    return true;
}

jQuery.validator.addMethod(
    "lunch_days",
    function (value, element) {
        console.log("ADDED METHOD ERROR LUNCH DAY!!");
        return lunchDays(element);
    },
    $("#lunchErrorTrans").val()
);

function lunchDays(objectInput) {
    console.log("##################################", $(objectInput).find("input:checkbox"), objectInput);
    const checkboxes = $(objectInput).find("input:checkbox");
    let isValid = false;
    checkboxes.each(function () {
        if ($(this).prop("checked")) isValid = true;
    });
    return isValid;
}

jQuery.validator.addMethod(
    "participation_timetable",
    function (value, element) {
        console.log("ADDED METHOD ERROR PARTICIPATION TIMETABLE!!");
        return participationTimetable(element);
    },
    $("#participationTimetableErrorTrans").val()
);

function participationTimetable(objectInput) {
    console.log("##################################", $(objectInput).find("input:checkbox"), objectInput);
    const checkboxes = $(objectInput).find("input:checkbox");
    let isValid = false;
    checkboxes.each(function () {
        if ($(this).prop("checked")) isValid = true;
    });
    return isValid;
}

jQuery.validator.addMethod(
    "enrolment_email_unique_same_ticket_recurrence",
    function (value, element) {
        console.log("ADDED METHOD ERROR enrolment_email_unique_same_ticket_recurrence!!");
        return enrolmentEmailUniqueSameTicketRecurrence();
    },
    $("#enrolmentEmailDuplicatedErrorTrans").val()
);

function enrolmentEmailUniqueSameTicketRecurrence() {
    const inputEmails = $("#attendeeList input[type='email']");
    const processed = {};
    let isValid = true;
    inputEmails.each(function () {
        const input = $(this);
        const value = input.val();
        const ticketRecurrenceId = input.attr("data-id-ticket-recurrence");
        const ticketType = input.attr("data-ticket-type");

        if (!ticketType || ticketType !== "enrolment") return; // continue

        if (value !== "") {
            if (processed[ticketRecurrenceId]) {
                if (processed[ticketRecurrenceId].includes(value)) {
                    isValid = false;
                    return false; // exit loop
                }
            }

            if (!processed[ticketRecurrenceId]) processed[ticketRecurrenceId] = [];
            processed[ticketRecurrenceId].push(value);
        }
    });
    return isValid;
}

function mysqlToJsDateTime(dateTime) {
    let dateTimeParts = dateTime.split(/[- :]/); // regular expression split that creates array with: year, month, day, hour, minutes, seconds values
    dateTimeParts[1]--; // monthIndex begins with 0 for January and ends with 11 for December so we need to decrement by one
    return new Date(...dateTimeParts); // our Date object
}

function payReserve() {
    console.log("function payReserve()");

    const formAttendee = $("form#attendeeList");

    if (formAttendee.valid()) {
        $(".cart-2-attendees").hide();
        const logged = $("#uil").val();
        console.log(`LOGGED: ${logged}`);

        if (logged) {
            let totalAmount = getTotalAmount();
            console.log("TOTAL AMOUNT: ", totalAmount);
            if (totalAmount <= 0 && !orderHasInvitation()) {
                $(".cart-4-checkout-free").show();
                $(".timer").appendTo(".cart-4-checkout-free .timer-wrap");
            } else {
                console.log(">" + $("#is-donation").val() + "<");
                if ($("#is-donation").val() === "") {
                    $(".cart-4-checkout").show();
                    $(".timer").appendTo(".cart-4-checkout .timer-wrap");
                } else {
                    $(".cart-3-5-donation").show();
                    $("#cart > .main-container").scrollTop(0);
                    loadUserBillingAddresses(0);
                    $(".timer").appendTo(".cart-3-5-donation .timer-wrap");
                }
            }
        } else {
            $(".cart-3-login").show();
            $("#cart > .main-container").scrollTop(0);
            $(".timer").appendTo(".cart-3-login .timer-wrap");
        }
        updateOrderLines();
    } else {
        console.log("error payReserve");
        let firstError = formAttendee.find("input.error").first();
        firstError.animateScroll("#cart > .main-container", 2);
    }
}

function getTotalAmount() {
    console.log("function getTotalAmount()");
    let totalAmount = 0;
    Object.values(orderLines).forEach((orderLine) => {
        totalAmount += orderLine.price_amount;
        totalAmount += orderLine.handly;
    });
    Object.values(discountLines).forEach((discountLineGroup) => {
        discountLineGroup.forEach((discountLine) => {
            totalAmount += discountLine.total;
        });
    });
    return totalAmount;
}

function orderHasInvitation() {
    console.log("function orderHasInvitation()");
    let isInvitation = false;
    Object.values(orderLines).forEach((orderLine) => {
        if (orderLine.p_type === "invitation") isInvitation = true;
    });
    return isInvitation;
}

// TODO: Fer servir promeses per no tenir la logica de retorn dins de la crida ajax
function updateOrderLines() {
    console.log("function updateOrderLines()");
    console.log("--------------------------------");
    console.log(orderLines);
    console.log("--------------------------------");
    console.log(JSON.stringify({orders: orderLines}));
    console.log("--------------------------------");
    console.log(JSON.stringify({orders: Object.values(orderLines)}));
    console.log(JSON.stringify({discounts: Object.values(discountLines)}));
    console.log("--------------------------------");
    $.ajax({
        type: "post",
        url: "/taquilla/reserve/order-lines/",
        contentType: "application/json; charset=utf-8",
        cache: false,
        processData: true,
        dataType: "json",
        data: JSON.stringify({
            id_order: $("#cart").data("id_order"),
            orders: Object.values(orderLines),
            discounts: Object.values(discountLines),
        }),
        headers: {
            Accept: "application/json; charset=utf-8",
        },
    })
        .done(function (result) {
            console.log("update order lines:", result, typeof result);
        })
        .fail(function (jqXHR, textStatus) {
            console.log("fail updateOrderLines: " + jqXHR.statusText + " (" + jqXHR.status + ") : " + textStatus);
            console.log(jqXHR.responseText);
        });
}

// Organism cart-3-login scripts
console.log("// Organism cart-3-login scripts");
var intervalUserIsValid = null;

function loginCart() {
    console.log("function loginCart()");
    $("#login-error").addClass("hidden");
    let user = $("#email-user-order").val();
    let pass = $("#password-user-order").val();
    if (user == "" || pass == "") {
        $("#login-error").removeClass("hidden");
        return;
    }

    new login(user, pass)
        .then((response) => {
            let logged = $("#uil").val();
            if (response && logged) {
                checkoutCpShow();
                checkoutOptInThirdPartyPromotionShow();
                let totalAmount = getTotalAmount();
                console.log("TOTAL AMOUNT: ", totalAmount);
                if (totalAmount === 0) {
                    $(".cart-3-login").hide();
                    $(".cart-4-checkout-free").show();
                    $("#cart > .main-container").scrollTop(0);
                    $(".timer").appendTo(".cart-4-checkout-free .timer-wrap");
                } else {
                    $(".cart-3-login").hide();
                    if ($("#is-donation").val() === "") {
                        $(".cart-4-checkout").show();
                        $("#cart > .main-container").scrollTop(0);
                        $(".timer").appendTo(".cart-4-checkout .timer-wrap");
                    } else {
                        $(".cart-3-5-donation").show();
                        $("#cart > .main-container").scrollTop(0);
                        loadUserBillingAddresses(0);
                        $(".timer").appendTo(".cart-3-5-donation .timer-wrap");
                    }
                }
            } else {
                $("#login-error").removeClass("hidden");
            }
        })
        .catch((error) => {});
}

function checkoutCpShow() {
    $(".cp-cart").hide();
    getCp()
        .done(function (result) {
            console.log(result);
            if (result.user.cp === "") {
                $(".cp-cart").show();
            }
        })
        .fail(function (jqXHR, textStatus) {
            console.log("error loading cp: ", jqXHR.statusText, jqXHR.status, jqXHR.responseText, textStatus);
        });
}

function checkoutOptInThirdPartyPromotionShow() {
    $(".third-party-promotion").hide();
    getThirdPartyPromotion($("#id-event").val())
        .done(function (result) {
            console.log("THIRD PARTY PROMOTION", result);
            if (!result.user.third_party_promotion && result.organization.commercial_name && result.organization.legal_name) {
                console.log("NO HA ACEPTADO THIRD PARTY PROMOTION")
                $(".organization-info").html(`${result.organization.commercial_name} ( ${result.organization.legal_name})`);
                $(".third-party-promotion").show();
            }
        })
        .fail(function (jqXHR, textStatus) {
            console.log("error loading third party promotion: ", jqXHR.statusText, jqXHR.status, jqXHR.responseText, textStatus);
        });
}
 

$("form#form-signup").validate({
    lang: "ca", // or whatever language option you have.
});

$("#signup-wait").on("click", function() {
    $("#signup-wait").addClass("hidden");
})


$("#form-signup input").on("focus", function() {
    $("#signup-wait").addClass("hidden");
})

var intervalUserIsValid;

function signupUser() {
    $("#signup-error").addClass("hidden");
    $("#signup-wait").addClass("hidden");
    $("#signup-email-error").addClass("hidden");
    $("#signup-pass-error").addClass("hidden");

    let email = $("#email-new-user-email").val();
    let reemail = $("#email-confirm-new-user-email-confirm").val();
    let password = $("#new-password-new-user-new-password").val();
    let repassword = $(
        "#new-password-confirm-new-user-new-password-confirm"
    ).val();

    if (email !== reemail) {
        $("#signup-email-error").removeClass("hidden");
        return;
    }
    if (password !== repassword) {
        $("#signup-pass-error").removeClass("hidden");
        return;
    }

    console.log("function signupUser()");
    const formToValidate = $("form#form-signup");

    if (formToValidate.valid()) {
        ValidatedSignupUser();
    } else {
        console.log("error ValidatedSignupUser");
        let firstError = formToValidate.find("input.error").first();
        console.log(firstError);
        firstError.animateScroll("#cart > .main-container", 1);
    }
}

function ValidatedSignupUser() {
    console.log("function ValidatedSignupUser()");
    let email = $("#email-new-user-email").val()
    $("#signup-wait span").text(email);
    $("#signup-wait").removeClass("hidden");

    let formData = {
        name: $("#name-new-user-name").val(),
        surname: $("#surname-new-user-surname").val(),
        user: email,
        phone: $("#telephone-new-user-telephone").val(),
        cp: $("#cp-new-user-cp").val(),
        password: $("#new-password-new-user-new-password").val(),
        lang: getLangFromURL(),
    };
    $.ajax({
        type: "post",
        url: "/taquilla/signup/",
        contentType: "application/json; charset=utf-8",
        cache: false,
        processData: true,
        dataType: "json",
        data: JSON.stringify({form: formData}),
        headers: {
            Accept: "application/json; charset=utf-8",
        },
    })
        .done(function (result) {
            console.log("ValidatedSignupUser:", result, typeof result);
            if (result.success) {
                console.log("Success:", result.success);
                console.log("Result data status:", result.data.status);
                let l = document.getElementById("checking");
                let n = document.getElementById("retrycountdown");
                let o = document.getElementById("loader-line");
                initialValue = parseInt(n.innerText);
                e = initialValue; 
                t = setInterval((function() {
                  e--;
                  n.innerText = e;
                  if (e <= 0) {
                    e = initialValue; // Reinicia el contador al valor inicial
                  }
                }), 1000);
                if (result.data.status) {
                    intervalUserIsValid = setInterval(function () {
                        setTimeout(function() {
                            l.style.display = "block"; 
                            o.style.display = "block"; 
                        }, 1000); // 1000 ms = 1 segundo
                        userIsValidated(result.data.id_user);
                    }, MILLISECONDS_OF_A_SECOND * 10);
                } 
            } else {
                $("#signup-error").removeClass("hidden");
                $("#signup-wait").addClass("hidden");
            }
        })
        .fail(function (jqXHR, textStatus) {
            console.log(
                "fail ValidatedSignupUser: " +
                    jqXHR.statusText +
                    " (" +
                    jqXHR.status +
                    ") : " +
                    textStatus
            );
            console.log(jqXHR.responseText);
        });
}

function userIsValidated(userId) {
    console.log("function userIsValidated()");
    $.ajax({
        type: "get",
        url: "/user-validated/" + userId,
        contentType: "application/json; charset=utf-8",
        cache: false,
        processData: true,
        dataType: "json",
        // data: JSON.stringify({ form: formData }),
        headers: {
            Accept: "application/json; charset=utf-8",
        },
    })
        .done(function (result) {
            console.log("userIsValidated:", result, typeof result);
            if (result.success) {
                if (result.data.status === 1) {
                    clearInterval(intervalUserIsValid);
                    autologin();
                }
            }
        })
        .fail(function (jqXHR, textStatus) {
            console.log(
                "fail userIsValidated: " +
                    jqXHR.statusText +
                    " (" +
                    jqXHR.status +
                    ") : " +
                    textStatus
            );
            console.log(jqXHR.responseText);
        });
}

function autologin() {
    console.log("autologin");
    $("#email-user-order").val($("#email-new-user-email").val());
    $("#password-user-order").val(
        $("#new-password-new-user-new-password").val()
    );
    $("#login-user-order").trigger("click");
}

// Organism cart-3-5-donation scripts
console.log("// Organism cart-3-5-donation scripts");

$(function () {
    $("#form-donation").on("submit", function (e) {
        e.preventDefault();
    });

    $("#addresses").on("change", function () {
        let billingAddressId = $(this).val();
        console.log("CHANGE", billingAddressId);
        loadUserBillingAddress(billingAddressId);
    });
});

function isDonation() {
    return $("#is-donation").val() === "Yes";
}

function loadUserBillingAddresses(billingAddressId) {
    console.log("function loadUserBillingAddresses()");
    if (!isBillingAddressesLoaded()) {
        $.ajax({
            type: "get",
            url: "/taquilla/user/billing-addresses",
            contentType: "application/json; charset=utf-8",
            cache: false,
            processData: true,
            dataType: "json",
            headers: {
                Accept: "application/json; charset=utf-8",
            },
        })
            .done(function (result) {
                console.log("result loadUserBillingAddresses():", result, typeof result);
                if (result.success) {
                    if (result.data.length > 0) {
                        loadAddresses(result.data);
                        if (billingAddressId === 0) {
                            selectAddressFromDropdown(getMainBillingAddressId(result.data));
                        } else {
                            selectAddressFromDropdown(billingAddressId);
                        }
                    }
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log("fail loadUserBillingAddresses: " + jqXHR.statusText + " (" + jqXHR.status + ") : " + textStatus);
                console.log(jqXHR.responseText);
            });
    }
}

function isBillingAddressesLoaded() {
    return $("#addresses").children().length > 0;
}

function loadUserBillingAddress(billingAddressId) {
    console.log("function loadUserBillingAddress()");
    console.log(">>>>>[" + billingAddressId + "]<<<<<<", typeof billingAddressId);
    if (isSelectedBillingAddressTemplate(billingAddressId)) {
        $.ajax({
            type: "get",
            url: "/taquilla/user/billing-address/" + billingAddressId,
            contentType: "application/json; charset=utf-8",
            cache: false,
            processData: true,
            dataType: "json",
            headers: {
                Accept: "application/json; charset=utf-8",
            },
        })
            .done(function (result) {
                console.log("result loadUserBillingAddress():", result, typeof result);
                if (result.success) {
                    loadAddress(result.data);
                }
            })
            .fail(function (jqXHR, textStatus) {
                console.log("fail loadUserBillingAddress: " + jqXHR.statusText + " (" + jqXHR.status + ") : " + textStatus);
                console.log(jqXHR.responseText);
            });
    } else {
        $("form#form-donation").trigger("reset");
        $("form#form-donation input[type=hidden]").val("");
    }
}

function isSelectedBillingAddressTemplate(billingAddressId) {
    return billingAddressId !== "";
}

function saveUserDonationData() {
    console.log("function saveUserDonationData()");
    var $myForm = $("#form-donation");
    if ($myForm[0].reportValidity()) {
        console.log("valid form");
        createUserOrderBillingAddressData();
    } else {
        console.log("not valid");
    }
}

function createUserOrderBillingAddressData() {
    console.log("function createUserOrderBillingAddressData()");
    $.ajax({
        type: "post",
        url: "/taquilla/user/billing-address",
        contentType: "application/json; charset=utf-8",
        cache: false,
        processData: true,
        dataType: "json",
        data: JSON.stringify({
            label: $("#label-donation-label").val(),
            name: $("#name-donation-name").val(),
            surname: $("#surname-donation-surname").val(),
            nif: $("#nif-donation-nif").val(),
            address: $("#address-donation-address").val(),
            cp: $("#cp-donation-cp").val(),
            city: $("#city-donation-city").val(),
            province: $("#province-donation-province").val(),
            country: $("#country-donation-country").val(),
            company: $("#company-donation-company").val(),
            used: 1,
        }),
        headers: {
            Accept: "application/json; charset=utf-8",
        },
    })
        .done(function (result) {
            console.log("result createUserOrderBillingAddressData:", result, typeof result);
            if (result.success) {
                if ($("#billing-address-donation-id").val() !== "") {
                    updateUserBillingAddressData();
                } else {
                    createUserTemplateBillingAddressData();
                }
                updateOrderBillingAddressId(result.data.id_billing_address);
            }
        })
        .fail(function (jqXHR, textStatus) {
            console.log("fail createUserBillingAddressData: " + jqXHR.statusText + " (" + jqXHR.status + ") : " + textStatus);
            console.log(jqXHR.responseText);
        });
}

function updateUserBillingAddressData() {
    console.log("function updateUserBillingAddressData()");
    $.ajax({
        type: "post",
        url: "/taquilla/user/billing-address/" + $("#billing-address-donation-id").val(),
        contentType: "application/json; charset=utf-8",
        cache: false,
        processData: true,
        dataType: "json",
        data: JSON.stringify({
            main: $("#billing-address-donation-main").val(),
            label: $("#label-donation-label").val(),
            name: $("#name-donation-name").val(),
            surname: $("#surname-donation-surname").val(),
            nif: $("#nif-donation-nif").val(),
            address: $("#address-donation-address").val(),
            cp: $("#cp-donation-cp").val(),
            city: $("#city-donation-city").val(),
            province: $("#province-donation-province").val(),
            country: $("#country-donation-country").val(),
            company: $("#company-donation-company").val(),
        }),
        headers: {
            Accept: "application/json; charset=utf-8",
        },
    })
        .done(function (result) {
            console.log("result updateUserBillingAddressData:", result, typeof result);
        })
        .fail(function (jqXHR, textStatus) {
            console.log("fail updateUserBillingAddressData: " + jqXHR.statusText + " (" + jqXHR.status + ") : " + textStatus);
            console.log(jqXHR.responseText);
        });
}

function createUserTemplateBillingAddressData() {
    console.log("function createUserTemplateBillingAddressData()");
    $.ajax({
        type: "post",
        url: "/taquilla/user/billing-address",
        contentType: "application/json; charset=utf-8",
        cache: false,
        processData: true,
        dataType: "json",
        data: JSON.stringify({
            label: $("#label-donation-label").val(),
            name: $("#name-donation-name").val(),
            surname: $("#surname-donation-surname").val(),
            nif: $("#nif-donation-nif").val(),
            address: $("#address-donation-address").val(),
            cp: $("#cp-donation-cp").val(),
            city: $("#city-donation-city").val(),
            province: $("#province-donation-province").val(),
            country: $("#country-donation-country").val(),
            company: $("#company-donation-company").val(),
            used: 0,
        }),
        headers: {
            Accept: "application/json; charset=utf-8",
        },
    })
        .done(function (result) {
            console.log("result createUserTemplateBillingAddressData:", result, typeof result);
            if (result.success) {
                $("#billing-address-donation-id").val(result.data.id_billing_address);
                $("#billing-address-donation-main").val("false");
            }
        })
        .fail(function (jqXHR, textStatus) {
            console.log("fail createUserBillingAddressData: " + jqXHR.statusText + " (" + jqXHR.status + ") : " + textStatus);
            console.log(jqXHR.responseText);
        });
}

function updateOrderBillingAddressId(id_billing_addres) {
    console.log("function updateOrderBillingAddressData()");
    $.ajax({
        type: "post",
        url: "/taquilla/order/billing-address",
        contentType: "application/json; charset=utf-8",
        cache: false,
        processData: true,
        dataType: "json",
        data: JSON.stringify({
            id_order: $("#cart").data("id_order"),
            id_billing_address: id_billing_addres,
        }),
        headers: {
            Accept: "application/json; charset=utf-8",
        },
    })
        .done(function (result) {
            console.log("result:", result, typeof result);
            if (result.success) {
                $(".cart-3-5-donation").hide();
                $(".cart-4-checkout").show();
                $(".timer").appendTo(".cart-4-checkout .timer-wrap");
            }
        })
        .fail(function (jqXHR, textStatus) {
            console.log("fail updateOrderBillingAddressData: " + jqXHR.statusText + " (" + jqXHR.status + ") : " + textStatus);
            console.log(jqXHR.responseText);
        });
}

function loadAddresses(addresses) {
    $("#user-billing-addresses").show();
    $("#form-donation").trigger("reset");
    $("#addresses").empty();
    $("#addresses").append(`<option value="">${$("#labelNewAddress").val()}</option>`);
    $.each(addresses, function (key, value) {
        $("#addresses").append('<option value="' + value.id_billing_address + '">' + value.label + "</option>");
    });
}

function loadAddress(address) {
    $("#billing-address-donation-id").val(address.id_billing_address);
    $("#billing-address-donation-main").val(address.main);
    $("#label-donation-label").val(address.label);
    $("#name-donation-name").val(address.name);
    $("#surname-donation-surname").val(address.surname);
    $("#nif-donation-nif").val(address.nif);
    $("#address-donation-address").val(address.address);
    $("#cp-donation-cp").val(address.cp);
    $("#city-donation-city").val(address.city);
    $("#province-donation-province").val(address.province);
    $("#country-donation-country").val(address.country);
    $("#company-donation-company").val(address.company);
}

function getMainBillingAddressId(addresses) {
    let billingAddressId = 0;
    $.each(addresses, function (key, value) {
        if (value.main) {
            billingAddressId = value.id_billing_address;
        }
    });
    return billingAddressId;
}

function selectAddressFromDropdown(billingAddressId) {
    console.log("function selectAddressFromDropdown()")
    if (billingAddressId > 0) {
        $("#addresses").val(billingAddressId);
        $("#addresses").trigger("change");
    }
}

// Organism cart-4-checkout scripts

$(function () {
    if($("#organization-commercial-name").val() === "" && $("#organization-legal-name").val() === "") {
        $(".third-party-promotion").hide();
    }

    $("#form-payment").on("submit", function (e) {
        e.preventDefault();
    });

    $("#tpv-tpv-tpv").on("click", function () {
        var $myForm = $("#form-payment");
        if ($myForm[0].reportValidity()) {
            console.log("valid form");
            $(this).prop("disabled", true);
            const paymentMethod = $("input:radio[name=payment-method]:checked").val();
            console.log({paymentMethod});
            if (paymentMethod !== "INVITATION") {
                requestTPV();
            } else {
                invitationPayment();
            }
        } else {
            console.log("not valid");
        }
    });

    const elemento = document.getElementById("tpv-tpv-tpv");

    elemento.addEventListener("mouseenter", () => {
        toggleActiveClass()
    });

    function toggleActiveClass() {
        elemento.classList.add("active");
        setTimeout(() => {
            elemento.classList.remove("active");
        }, 300);
    }

    // Configuramos el intervalo para ejecutar la función cada 3 segundos
    setTimeout(() => {
        setInterval(toggleActiveClass, 3000);
    }, 15000);

});

function requestTPV() {
    console.log("function requestTPV()");

    $.ajax({
        type: "post",
        url: "/payment/request-tpv/",
        contentType: "application/json; charset=utf-8",
        cache: false,
        processData: true,
        dataType: "json",
        data: JSON.stringify({
            id_order: $("#cart").data("id_order"),
            method: $('input[name="payment-method"]:checked').val(),
            currentPathname: window.location.pathname,
        }),
        headers: {
            Accept: "application/json; charset=utf-8",
        },
        beforeSend: function (xhr) {
            const cp = $("#cp-cart-pay").val();
            if (cp !== "" && cp !== undefined) {
                saveCp(cp);
            }

            const optInThirdparty = $("#third-party-promotion").is(":checked");
            console.log(optInThirdparty);
            if (optInThirdparty) {
                saveThirdPartyPromotion($("#id-organization").val());
            }
        },
    })
        .done(function (result) {
            console.log("result:", result, typeof result);
            $.redirect(
                result.url,
                {
                    Ds_SignatureVersion: result.Ds_SignatureVersion,
                    Ds_MerchantParameters: result.Ds_MerchantParameters,
                    Ds_Signature: result.Ds_Signature,
                },
                "POST"
            );
        })
        .fail(function (jqXHR, textStatus) {
            console.log("fail requestTPV: " + jqXHR.statusText + " (" + jqXHR.status + ") : " + textStatus);
            console.log(jqXHR.responseText);
            $("#tpv-tpv-tpv").prop("disabled", false);
        });
}

function invitationPayment() {
    console.log("function invitationPayment()");

    $.ajax({
        type: "post",
        url: "/payment/free/",
        contentType: "application/json; charset=utf-8",
        cache: false,
        processData: true,
        dataType: "json",
        data: JSON.stringify({
            id_order: $("#cart").data("id_order"),
            currentPathname: window.location.pathname,
            tpv_payment_method: "invitation",
        }),
        headers: {
            Accept: "application/json; charset=utf-8",
        },
        beforeSend: function (xhr) {
            const cp = $("#cp-cart-pay").val();
            if (cp !== "" && cp !== undefined) {
                saveCp(cp);
            }
        },
    })
        .done(function (result) {
            console.log("result:", result, typeof result);
            // goto cart 5
            if (result) {
                $(".cart-4-checkout").hide();
                $(".cart-5-response").show();
            } else {
                console.log("Return from tickets validation request", result);
                $("#tpv-tpv-tpv").prop("disabled", false);
            }
        })
        .fail(function (jqXHR, textStatus) {
            console.log("fail requestTPV: " + jqXHR.statusText + " (" + jqXHR.status + ") : " + textStatus);
            console.log(jqXHR.responseText);
            $("#tpv-tpv-tpv").prop("disabled", false);
        });
}

function setBackCart4Checkout() {
    console.log("function setBackCart4Checkout()");
    if (isDonation()) {
        console.log("ES DONACIÓ");
        $("#goback-donations").show();
        $("#goback-assignations").hide();
    } else {
        console.log("NO DONACIÓ");
        $("#goback-assignations").show();
        $("#goback-donations").hide();
    }
}

$("#detail_4-toggle-order").on("click", function () {
    $(".summary-footer").toggleClass("opened");
});
// Organism cart-4-checkout scripts

$(function () {
    if($("#organization-commercial-name").val() === "" && $("#organization-legal-name").val() === "") {
        $(".third-party-promotion").hide();
    }
    
    $("#form-payment-free").on("submit", function (e) {
        e.preventDefault();
    });

    $("#tpv-tpv-tpv-free").on("click", function () {
        var $myForm = $("#form-payment-free");
        if ($myForm[0].reportValidity()) {
            console.log("valid form");
            $(this).prop("disabled", true);
            freePayment();
        } else {
            console.log("not valid");
        }
    });

    const elemento = document.getElementById("tpv-tpv-tpv-free");

    elemento.addEventListener("mouseenter", () => {
        toggleActiveClass()
    });

    function toggleActiveClass() {
        elemento.classList.add("active");
        setTimeout(() => {
            elemento.classList.remove("active");
        }, 300);
    }

    // Configuramos el intervalo para ejecutar la función cada 3 segundos
    setTimeout(() => {
        setInterval(toggleActiveClass, 3000);
    }, 15000);
});

function freePayment() {
    console.log("function freePayment()");

    $.ajax({
        type: "post",
        url: "/payment/free/",
        contentType: "application/json; charset=utf-8",
        cache: false,
        processData: true,
        dataType: "json",
        data: JSON.stringify({
            id_order: $("#cart").data("id_order"),
            currentPathname: window.location.pathname,
            tpv_payment_method: "free",
        }),
        headers: {
            Accept: "application/json; charset=utf-8",
        },
        beforeSend: function (xhr) {
            const cp = $("#cp-cart-free").val();
            console.log("TRYING TO SAVE CP: ", cp);
            if (cp !== "" && cp !== undefined) {
                saveCp(cp);
            }

            const optInThirdparty = $("#third-party-promotion-free").is(":checked");
            if (optInThirdparty) {
                saveThirdPartyPromotion($("#id-organization").val());
            }
        },
    })
        .done(function (result) {
            console.log("result:", result, typeof result);
            // goto cart 5
            if (result) {
                showHasInvitationMessage();
                $(".cart-4-checkout-free").hide();
                $(".cart-5-response").show();
            } else {
                console.log("Return from tickets validation request", result);
                $("#tpv-tpv-tpv-free").prop("disabled", false);
            }
        })
        .fail(function (jqXHR, textStatus) {
            console.log("fail requestTPV: " + jqXHR.statusText + " (" + jqXHR.status + ") : " + textStatus);
            console.log(jqXHR.responseText);
            $("#tpv-tpv-tpv-free").prop("disabled", false);
        });
}

$("#detail_4f-toggle-order").on("click", function () {
    $(".summary-footer").toggleClass("opened");
});



// Organism cart-5-response scripts
// $(function(){
//     $( "#navigate-navigate-navigate, #close-cart-order" ).on( "click", 'input', function() {
//         console.log("click exit");
//         payProcessStatus = true;
//         if(payProcessStatus) {
//             // TODO netejar carro
//             cleanCart();
//             console.log("cart cleaned");
//         }
//     });
// });

function showHasInvitationMessage() {
    console.log("function showHasInvitationMessage()");
    console.log(orderLines);
    const currentUserEmail = $("#current-user-email").val();
    let hasInvitations = false;
    Object.values(orderLines).every((orderLine) => {
        const isInvitation = orderLine.attendees.some((attendee) => attendee.email !== "" && attendee.email !== currentUserEmail);
        if (isInvitation) {
            hasInvitations = true;
            return false;
        }
        return true;
    });
    if (hasInvitations) {
        $("#msg-tickets-invitation").show();
    }
}

function cleanCart() {
    console.log("function cleanCart()");
    console.log(orderLines);
    orderLines = {};
    $(".my-reserve *").remove();
    console.log(orderLines);
    $(".qty-ticket-reserve").val(0);
    $(".qty-ticket-reserve").removeData();
    $("#cart").removeData();
    clearInterval(timeCount);
    // $(".attendee").val(""); // this is cleaned at cart stage 2
    $("#payment-method-1, #payment-method-2, #terms-check").prop("checked", false);
}

// Test
function testLocalStorageWrite() {
    localStorage.setItem("id", "1");
    localStorage.setItem("name", "John");
    localStorage.setItem("surname", "Doe");
}

function testLocalStorageRead() {
    let id = localStorage.getItem("id");
    let name = localStorage.getItem("name");
    let surname = localStorage.getItem("surname");
    let noExists = localStorage.getItem("noExists");
    console.log("TESTING localStorage: ", id, name, surname, noExists);
}
// Config
const API_URL = $("#api-base-uri")
    .val()
    .substring(0, $("#api-base-uri").val().length - 1);

// CART
const CART_MODE = {
    NORMAL: "normal",
    BLOCKING: "blocked",
    INVITING: "invitation",
};

// SVG
const RECURRENCE_SEAT_SEPARATOR = "_";
const RESERVE_COLORS = {
    RESERVED: "#666",
    UNRESERVED: "#099",
    RESERVED_BY_USER: "#000",
};

// HTML
const SEAT_CLASS = "clickable-seat";
const SEAT_CLASS_RESERVED = "reserved";
const SEATS_SELECTED_ID = "seats-selected";
const PISTA_CLASS = "clickable-pista";
const PRICE_BUTTON_CLASS = "seat-reserve-price-button";
const PRICE_TYPE_BUTTON_CLASS = "seat-reserve-price-type-button";
const DELETE_BUTTON_CLASS = "seat-reserve-delete-button";

// OTHER
const DEFAULT_PRICE_TYPE_INDEX = 0;
const DEFAULT_PRICE_INDEX = 0;

const getTranslationSelector = (code) => {
    return `#translation-${code}`;
};

const getGeneralContainer = () => `.cart-1-5-seats`;

const getGeneralSpinnerSelector = () => `#seats-spinner`;

const getLegendSelector = () => `#legend-content`;

const getCurrentTicketRecurrenceIdSelector = () => "#current-id-ticket-recurrence";

const getReloadButtonSelector = () => "#seat-select-reload-button-";

const getEventTicketRecurrenceDateSelector = () => "#event-ticket-recurrence-date";

const getSvgContainerSelector = () => `#svg-container`;

const getSvgMessageSelector = () => "#svg-message";

const getReservedSeatsSelectors = (reservedSeats) => {
    return reservedSeats.map( ({rid}) => getMapSeatIdSelector(rid)).join();
};

const getMapSeatIdSelector = (rid) => {
    return `#${getMapSeatIdFromRid(rid)}`;
};

const getDisabledSelectors = () => "#ELEMENT_TO_DISABLE_ID_1, #ELEMENT_TO_DISABLE_ID_N";

const getSeatsSelectors = () => `[class*="${SEAT_CLASS}"]`;

const getPriceButtonsSelector = () => `.${PRICE_BUTTON_CLASS}`;

const getPriceTypeButtonsSelector = () => `.${PRICE_TYPE_BUTTON_CLASS}`;

const getTrashButtonsSelector = () => `.${DELETE_BUTTON_CLASS}`;

const getPistasSelectors = () => `rect[class*="${PISTA_CLASS}"]`;

const getMapSeatIdFromRid = (rid) => {
    const [_, id] = rid.split(RECURRENCE_SEAT_SEPARATOR);
    return id;
};

const datetimeToDate = (date, separator = "/") => {
    if (typeof date === "object") return `${date.getDate()}${separator}${date.getMonth() + 1}${separator}${date.getFullYear().toString().substring(2)}`;

    const dateObj = new Date(date);
    return `${dateObj.getDate()}${separator}${dateObj.getMonth() + 1}${separator}${dateObj.getFullYear().toString().substring(2)}`;
};

const datetimeToHour = (date) => {
    if (typeof date === "object") return `${date.getHours()}:${date.getMinutes().toString().padStart(2, "0")}`;

    const dateObj = new Date(date);
    return `${dateObj.getHours()}:${dateObj.getMinutes().toString().padStart(2, "0")}`;
};

const startDateToFinishDate = (startDate, finishDate) => {
    return `${$(getTranslationSelector("from")).val()} ${datetimeToDate(startDate)} ${$(getTranslationSelector("date-second-part")).val()} ${datetimeToHour(
        startDate
    )} h
    ${$(getTranslationSelector("date-third-part")).val()} ${datetimeToDate(finishDate)} ${$(getTranslationSelector("date-second-part")).val()} ${datetimeToHour(
        finishDate
    )} h`;
};

const differentPriceTypes = ({manyPrices, seatData}) => {
    return [
        ...new Set(
            manyPrices.map((aPriceType) => {
                return [
                    ...new Set(
                        aPriceType.map((priceType) => {
                            if (priceType.class !== seatData.myClass) return "";
                            return priceType.price_type;
                        })
                    ),
                ];
            })
        ),
    ].filter((el) => el[0] !== "");
};

const showGeneralSpinner = () => $(getGeneralSpinnerSelector()).show();

const hideGeneralSpinner = () => $(getGeneralSpinnerSelector()).hide();

const setContainerCartMode = (cartMode) => $(getGeneralContainer())
                                            .removeClass(Object.values(CART_MODE).map((mode) => `mode-${mode}`).join(' '))
                                            .addClass(`mode-${cartMode}`)

var _WIDTH;
var _HEIGHT;

var _SVG_ID;
var _MAIN_G_ID;
var _ELEMENTS_DECO;

var _INITIAL_SCALE;
var _MAX_SCALE;
var _INITIAL_X;
var _INITIAL_Y;

var myZoom;

function handleZoom() {
    const scale = d3.event.transform.k;
    console.log({scale});

    const scaledWidth = _WIDTH * scale;
    const scaledHeight = _HEIGHT * scale;

    // Change SVG dimensions.
    d3.select("#" + _SVG_ID)
        .attr("width", scaledWidth)
        .attr("height", scaledHeight);

    // Scale the image itself.
    d3.select("#" + _MAIN_G_ID).attr("transform", `scale(${scale})`);
    d3.select("#" + _ELEMENTS_DECO).attr("transform", `scale(${scale})`);

    // Move scrollbars.
    const wrapper = d3.select(getSvgContainerSelector()).node();
    wrapper.scrollLeft = -d3.event.transform.x;
    wrapper.scrollTop = -d3.event.transform.y;

    // If the image is smaller than the wrapper, move the image towards the
    // center of the wrapper.
    const dx = d3.max([0, wrapper.clientWidth / 2 - scaledWidth / 2]);
    const dy = d3.max([0, wrapper.clientHeight / 2 - scaledHeight / 2]);
    d3.select("#" + _SVG_ID).attr("transform", `translate(${dx}, ${dy})`);
}

function scrolled() {
    const wrapper = d3.select(getSvgContainerSelector());
    const x = wrapper.node().scrollLeft + wrapper.node().clientWidth / 2;
    const y = wrapper.node().scrollTop + wrapper.node().clientHeight / 2;
    const scale = d3.zoomTransform(wrapper.node()).k;
    // Update zoom parameters based on scrollbar positions.
    wrapper.call(d3.zoom().translateTo, x / scale, y / scale);
}

const loadSvg = (data, svgConfig) => {
    initVariables(svgConfig);
    $(getSvgContainerSelector()).html("");
    const {documentElement: svgNode} = data;
    const svgElement = createSvgElement(svgNode);
    console.log({svgElement})
    const childs = Object.values(svgNode.children);
    childs.forEach((child) => {
        console.log({child})
        svgElement.node().append(child);
    });
    disableSvgElements();

    // d3.select("#P62").attr("transform", `translate(${_INITIAL_X},${_INITIAL_Y}) scale(${_INITIAL_SCALE})`);

    d3.select(getSvgContainerSelector())
        .on("scroll", scrolled)
        .call(myZoom.transform, d3.zoomIdentity.scale(_INITIAL_SCALE).translate(_INITIAL_X, _INITIAL_Y)) // initial positionj
        .call(myZoom);
};

const initVariables = (svgConfig) => {
    console.log("INITIALIZING SVG VARSSSSSSSSSSSSS");
    const windowWidth = window.innerWidth;
    _WIDTH = svgConfig.width;
    _HEIGHT = svgConfig.height;
    _SVG_ID = svgConfig.id;
    _MAIN_G_ID = svgConfig.main_g;
    _ELEMENTS_DECO = "Elements-decoratius";
    _INITIAL_SCALE = windowWidth < 600 ? svgConfig.mobile.initial_scale : windowWidth < 800 ? svgConfig.tablet.initial_scale : svgConfig.desktop.initial_scale;
    _MAX_SCALE = windowWidth < 600 ? svgConfig.mobile.max_scale : windowWidth < 800 ? svgConfig.tablet.max_scale : svgConfig.desktop.max_scale;
    _INITIAL_X = windowWidth < 600 ? svgConfig.mobile.initial_x : windowWidth < 800 ? svgConfig.tablet.initial_x : svgConfig.desktop.initial_x;
    _INITIAL_Y = windowWidth < 600 ? svgConfig.mobile.initial_y : windowWidth < 800 ? svgConfig.tablet.initial_y : svgConfig.desktop.initial_y;

    myZoom = d3
        .zoom()
        .scaleExtent([_INITIAL_SCALE, _MAX_SCALE])
        .translateExtent([
            [0, 0],
            [_WIDTH, _HEIGHT],
        ])
        .on("zoom", handleZoom);
};

// Create SVG element for add zoom functionality
const createSvgElement = (svgNode) => {
    const id = svgNode.getAttribute("id");
    const myClass = svgNode.getAttribute("class");
    const svg = d3
        .select(getSvgContainerSelector())
        .append("svg")
        .attr("width", _WIDTH)
        .attr("height", _HEIGHT)
        // .attr("viewBox", viewBox)
        .attr("id", id)
        .attr("class", myClass);

    return svg;
};

const disableSvgElements = () => {
    d3.selectAll(getDisabledSelectors()).selectAll("circle").attr("class", "bloqued");
};

const loadPricesLegend = ({many_prices: manyPrices}) => {
    const lang = "es-ES";
    const currency = "EUR";
    let html = "";
    const manyPricesSortedByClassAndName = manyPrices.sort((a, b) => a[0].class.localeCompare(b[0].class) || a[0].price_type.localeCompare(b[0].price_type));
    manyPricesSortedByClassAndName.map((priceTypes) => {
        const priceType = priceTypes[0];
        html += `<div><span class="${priceType.class} legend-square-size"> </span> ${priceType.price_type} <strong>`;
        if (priceTypes.length > 1) {
            html += $(getTranslationSelector("from")).val();
        }
        html += ` ${new Intl.NumberFormat(lang, {style: "currency", currency: currency}).format(priceType.price)}
        </strong></div>`;
    });
    $(getLegendSelector()).html(html);
};

const getTicketReserves = async (ticketRecurrenceId) => {
    const url = `${API_URL}/seat-reserve/ticket_recurrence/${ticketRecurrenceId}`;
    return fetch(url, {
        method: "GET",
        headers: {
            "Content-type": "application/json",
        },
    })
        .then((res) => (res.ok ? res.json() : Promise.reject()))
        .then((res) => {
            const {success, data} = res;
            return success ? data : false;
        })
        .catch((err) => {
            console.warn(err);
        });
};

const createSeatReserve = async (data) => {
    const url = `${API_URL}/seat-reserve`;
    return fetch(url, {
        method: "POST",
        headers: {
            "Content-type": "application/json",
        },
        body: JSON.stringify(data),
    }).then((res) => (res.ok ? res.json() : Promise.reject()));
};

const deleteSeatReserve = async (data) => {
    const url = `${API_URL}/seat-reserve`;
    return fetch(url, {
        method: "DELETE",
        headers: {
            "Content-type": "application/json",
        },
        body: JSON.stringify(data),
    }).then((res) => (res.ok ? res.json() : Promise.reject()));
};

const getTicketRecurrence = (ticketRecurrenceId) => {
    const data = $(`#ticket-recurrence-data-${ticketRecurrenceId}`).val();
    if(data === undefined) return false;
    return JSON.parse(data);
    
    // const parsed = JSON.parse(data);
    // console.log({parsed})
    // const ordered  = {...parsed, many_prices: parsed.many_prices.sort((a, b) => a[0].id_event_seat_definition_price_type - b[0].id_event_seat_definition_price_type )}
    // console.log({ordered})
    // parsed.many_prices.sort((a, b) => a[0].id_event_seat_definition_price_type - b[0].id_event_seat_definition_price_type)
    // console.log({parsed2: parsed})
    // return parsed;
};

const getSvgConfig = (ticketRecurrenceId) => {
    const data = $(`#ticket-svg-data-${ticketRecurrenceId}`).val();
    if(data === undefined) return false;
    return JSON.parse(data);
};

const getSeatData = (element) => {
    const currentSeat = getCurrentSeat(element);
    const currentRow = getCurrentRow(element);
    const currentGrandstand = getCurrentGrandstand(element);
    const currentZone = getCurrentZone(element);
    const currentFloor = getCurrentFloor(element);

    return {
        reservedByMe: currentSeat.attr("data-status"),
        myClass: getPriceClass(currentSeat.attr("class")),
        allClass: currentSeat.attr("class"),
        seatId: currentSeat.attr("id"),
        seatStatus: currentSeat.classed("blocked"),
        seatName: currentSeat.attr("data-name"),
        rowId: currentRow.attr("id"),
        rowName: currentRow.attr("data-name"),
        grandstandId: currentGrandstand.attr("id"),
        grandstandName: currentGrandstand.attr("data-name"),
        zoneId: currentZone.attr("id"),
        zoneName: currentZone.attr("data-name"),
        floorId: currentFloor.attr("id"),
        floorName: currentFloor.attr("data-name"),
    };
};

const getSeatsReservedByUser = () => {
    return d3.selectAll("[data-status='true']");
};

const getPriceClass = (seatClasses) => {
    return seatClasses.split(" ").filter((aClass) => aClass.includes("clickable"))[0];
};

const svgReserve = (element) => {
    markSeatAsReserved(element);
};

const svgUnreserve = (element) => {
    markSeatAsUnreserved(element);
    setSeatColorUnreserved(element);
    getCurrentSeat(element).classed("reserved", false)
    getCurrentSeat(element).classed("blocked", false)
};

const svgReserved = (element) => {
    setSeatColorReserved(element);
};

const markSeatAsReserved = (element) => getCurrentSeat(element).attr("data-status", "true");

const markSeatAsUnreserved = (element) => getCurrentSeat(element).attr("data-status", "false");

// const toggleSeatColor = (element) => (!isSeatReserved(element) ? setSeatColorUnreserved(element) : setSeatColorReservedByUser(element));

// const setSeatColorReservedByUser = (element) => getCurrentSeat(element).style("fill", RESERVE_COLORS.RESERVED_BY_USER);

const isSeatReserved = (element) => getCurrentSeat(element).attr("data-status") === "true";

const showSeatSpinner = (element) => d3.select(element).style("fill", "url(#spinner)");

const showSeatCheck = (element) => d3.select(element).style("fill", "url(#checkOk)");

const blockSeat = (element) => {
    d3.select(element).style("fill", "url(#lock)")
    // TODO: Si no agrada el candau més fosc descomentar les lines d'abaix
    // d3.select(element).classed("reserved", "true")
    // d3.select(element).classed("blocked", "true")
}

const showPistaSpinner = (element) => {
    d3.select(element.parentNode).select(".reserving").classed("hidden", false);
    d3.select(element.parentNode).select(".reserved-ok").classed("hidden", true);
    d3.select(element.parentNode).select(".error").classed("hidden", true);
};

const showPistaCheck = (element) => {
    console.log({showPistaCheck: element, parent: element.parentNode, reservedNode: d3.select(element.parentNode).select(".reserved-ok")});
    d3.select(element.parentNode).select(".reserving").classed("hidden", true);
    d3.select(element.parentNode).select(".reserved-ok").classed("hidden", false);
    d3.select(element.parentNode).select(".error").classed("hidden", true);
};

const showPistaError = (element) => {
    d3.select(element.parentNode).select(".reserving").classed("hidden", true);
    d3.select(element.parentNode).select(".reserved-ok").classed("hidden", true);
    d3.select(element.parentNode).select(".error").classed("hidden", false);
};

const showPistaNothing = (element) => {
    d3.select(element.parentNode).select(".reserving").classed("hidden", true);
    d3.select(element.parentNode).select(".reserved-ok").classed("hidden", true);
    d3.select(element.parentNode).select(".error").classed("hidden", true);
};

const setSeatColorReserved = (element) => getCurrentSeat(element).style("opacity", 0.5);

const setSeatColorUnreserved = (element) => getCurrentSeat(element).style("fill", "");

const getCurrentSeat = (element) => d3.select(element);

const getCurrentRow = (element) => d3.select(element.parentNode);

const getCurrentGrandstand = (element) => d3.select(element.parentNode.parentNode);

const getCurrentZone = (element) => d3.select(element.parentNode.parentNode.parentNode);

const getCurrentFloor = (element) => d3.select(element.parentNode.parentNode.parentNode.parentNode);

const reserveSeat = ({reserveData, ticketRecurrence, seatData, element}) => {
    showSeatSpinner(element);
    if (!isSeatsReserveFull(ticketRecurrence)) {
        createSeatReserve(reserveData)
            .then((jsonObject) => {
                const {success} = jsonObject;
                if (success) {
                    console.log("Created");

                    svgReserve(element);

                    const {many_prices: manyPrices} = ticketRecurrence;
                    const candiatePriceTypeIndex = getClassFirstPriceTypeIndex({manyPrices, myClass: seatData.myClass});
                    let priceTypeIndex = candiatePriceTypeIndex < 0 ? DEFAULT_PRICE_TYPE_INDEX : candiatePriceTypeIndex;
                    let priceIndex = DEFAULT_PRICE_INDEX;
                    if (reserveData.rid in orderLines) {
                        priceTypeIndex = getCurrentPriceTypeIndex({manyPrices, rid: reserveData.rid});
                        if (priceTypeIndex < 0) priceTypeIndex = 0;
                        priceIndex = getCurrentPriceIndex({manyPrices, rid: reserveData.rid, priceTypeIndex});
                    }

                    createSeatReserveCard({
                        rid: reserveData.rid,
                        ticketRecurrence,
                        currentPriceType: manyPrices[priceTypeIndex],
                        currentPrice: manyPrices[priceTypeIndex][priceIndex],
                        seatData,
                        cartMode: reserveData.seatStatus
                    });

                    bindSeatCardsEvents(ticketRecurrence, reserveData.seatStatus);

                    if(reserveData.seatStatus === CART_MODE.BLOCKING) {
                        blockSeat(element);
                    }else {
                        const {
                            price,
                            price_management: priceManagement,
                            p_type,
                            id_event_seat_definition_price_type: priceTypeId,
                            price_type: priceType,
                        } = manyPrices[priceTypeIndex][priceIndex];
    
                        console.log(manyPrices[priceTypeIndex][priceIndex]);

                        if(orderLines[reserveData.rid] === undefined) {
                            seatData = {...seatData, seatStatus: reserveData.seatStatus}
                        }else {
                            seatData = {...seatData, seatStatus: orderLines[reserveData.rid].seatStatus}
                        }

                        createOrderLine({ticketRecurrence, price, priceManagement, p_type, priceTypeId, priceType, rid: reserveData.rid, seatData});

                        showSeatCheck(element);
                    }
                } else {
                    svgReserved(element);
                    loadReservedSeats(ticketRecurrence.id_ticket_recurrence);
                    showReservedMessage(reserveData.rid);
                }
            })
            .catch((err) => {
                console.warn(err);
                setSeatColorUnreserved(element);
                svgReserved(element);
                loadReservedSeats(ticketRecurrence.id_ticket_recurrence);
                showReservedMessage(reserveData.rid);
            });
    } else {
        showFullReservesMessage();
        setSeatColorUnreserved(element);
    }
};

const reservePista = ({reserveData, ticketRecurrence, seatData, element, pistaNode}) => {
    console.log({TEST: d3.select(element.parentNode).select(".reserving")});
    showPistaSpinner(element);
    if (!isSeatsReserveFull(ticketRecurrence)) {
        createSeatReserve(reserveData)
            .then(async (jsonObject) => {
                const {success} = jsonObject;
                if (success) {
                    console.log("Created");

                    svgReserve(element);

                    const {many_prices: manyPrices} = ticketRecurrence;
                    const candiatePriceTypeIndex = getClassFirstPriceTypeIndex({manyPrices, myClass: seatData.myClass});
                    let priceTypeIndex = candiatePriceTypeIndex < 0 ? DEFAULT_PRICE_TYPE_INDEX : candiatePriceTypeIndex;
                    let priceIndex = DEFAULT_PRICE_INDEX;
                    if (reserveData.rid in orderLines) {
                        priceTypeIndex = getCurrentPriceTypeIndex({manyPrices, rid: reserveData.rid});
                        if (priceTypeIndex < 0) priceTypeIndex = 0;
                        priceIndex = getCurrentPriceIndex({manyPrices, rid: reserveData.rid, priceTypeIndex});
                    }

                    createSeatReserveCard({
                        rid: reserveData.rid,
                        ticketRecurrence,
                        currentPriceType: manyPrices[priceTypeIndex],
                        currentPrice: manyPrices[priceTypeIndex][priceIndex],
                        seatData,
                    });

                    bindSeatCardsEvents(ticketRecurrence);

                    const {
                        price,
                        price_management: priceManagement,
                        p_type,
                        id_event_seat_definition_price_type: priceTypeId,
                        price_type: priceType,
                    } = manyPrices[priceTypeIndex][priceIndex];
                    createOrderLine({ticketRecurrence, price, priceManagement, p_type, priceTypeId, priceType, rid: reserveData.rid, seatData});

                    showPistaCheck(element);
                    showMyReservedTicketsQuantity({pistaNode});
                    showStockStatus({pistaNode});
                } else {
                    console.log("SUCCESS FALSE RESERVE PISTA");
                    // svgReserved(element);
                    removeReservedClassFromPista({pistaNode});

                    //Esto pone reserved a lo que toca
                    await loadReservedSeats(ticketRecurrence.id_ticket_recurrence);

                    //Intentar dar otra butaca de la pista
                    if (!isPistaFull({pistaNode})) {
                        d3.select(pistaNode).dispatch("click");
                    } else {
                        // No se puede dar otra butaca de la pista
                        showPistaMessage(reserveData.rid);
                        showPistaNothing(element);
                    }

                    // Mostrar siempre el cambio de estado
                    showMyReservedTicketsQuantity({pistaNode});
                    showStockStatus({pistaNode});
                }
            })
            .catch(async (err) => {
                console.log("CATCH ERROR RESERVE PISTA");
                console.warn(err);
                // showPistaError(element);
                // setSeatColorUnreserved(element);
                // svgReserved(element);

                removeReservedClassFromPista({pistaNode});

                //Esto pone reserved a lo que toca
                await loadReservedSeats(ticketRecurrence.id_ticket_recurrence);

                //Intentar dar otra butaca de la pista
                if (!isPistaFull({pistaNode})) {
                    d3.select(pistaNode).dispatch("click");
                } else {
                    // No se puede dar otra butaca de la pista
                    showPistaMessage(reserveData.rid);
                    showPistaNothing(element);
                }

                // Mostrar siempre el cambio de estado
                showMyReservedTicketsQuantity({pistaNode});
                showStockStatus({pistaNode});
            });
    } else {
        showFullReservesMessage();
        showPistaNothing(element);
    }
};

const isSeatsReserveFull = ({maximum_tickets_book: maxTickets}) => {
    return getSeatsReservedByUser().nodes().length >= parseInt(maxTickets);
};

const getClassFirstPriceTypeIndex = ({manyPrices, myClass}) => manyPrices.findIndex((priceType) => priceType[DEFAULT_PRICE_INDEX].class === myClass);

const getCurrentPriceTypeIndex = ({manyPrices, rid}) =>
    manyPrices.findIndex((priceType) => priceType[DEFAULT_PRICE_INDEX].price_type.toUpperCase() === orderLines[rid].price_type.toUpperCase());

const getCurrentPriceIndex = ({manyPrices, rid, priceTypeIndex}) => manyPrices[priceTypeIndex].findIndex((price) => price.price === orderLines[rid].price);

const showReservedMessage = (rid) => {
    $(getSvgMessageSelector())
        .html(`${$(getTranslationSelector("seat")).val()} ${getMapSeatIdFromRid(rid)} ${$(getTranslationSelector("seat-full")).val()}`)
        .fadeIn(0)
        .delay(5000)
        .fadeOut();
};

const showFullReservesMessage = () => {
    $(getSvgMessageSelector())
        .html($(getTranslationSelector("limit-exceded")).val())
        .fadeIn(0)
        .delay(5000)
        .fadeOut();
};

const showPistaMessage = (rid) => {
    $(getSvgMessageSelector())
        .html($(getTranslationSelector("pista-full")).val())
        .fadeIn(0)
        .delay(5000)
        .fadeOut();
};

const unreserveSeat = ({reserveData, element}) => {
    showSeatSpinner(element);
    deleteSeatReserve(reserveData)
        .then((jsonObject) => {
            svgUnreserve(element);
            const {success} = jsonObject;
            if (success) {
                console.log("Deleted");
                removeSeatReserveCard(reserveData.rid);
                removeOrderLine(reserveData.rid);
            } else {
                svgReserve(element);
            }
        })
        .catch((err) => {
            console.warn(err);
            svgReserve(element);
        });
};

const unreservePista = ({reserveData, element}) => {
    showPistaSpinner(element);
    deleteSeatReserve(reserveData)
        .then((jsonObject) => {
            svgUnreserve(element);
            const {success} = jsonObject;
            if (success) {
                console.log("Deleted");
                removeSeatReserveCard(reserveData.rid);
                removeOrderLine(reserveData.rid);

                const pistaNode = getPistaNodeFromGroup({parentGroup: d3.select(element.parentNode)});
                const pistaSeatQuantity = getMySeatsQuantity({pistaNode});
                console.log({pistaSeatQuantity});
                if (pistaSeatQuantity === 0) {
                    showPistaNothing(element);
                } else {
                    showPistaCheck(element);
                }
                showMyReservedTicketsQuantity({pistaNode});
                showStockStatus({pistaNode});
            } else {
                svgReserve(element);
            }
        })
        .catch((err) => {
            console.warn(err);
            // showPistaError(element);
            svgReserve(element);
        });
};

const createOrderLine = ({ticketRecurrence, price, priceManagement, p_type, priceTypeId, priceType, rid, seatData}) => {
    orderLines[rid] = {
        ...orderLines[rid],
        ...seatData,
        id_ticket: ticketRecurrence.id_ticket,
        id_ticket_recurrence: ticketRecurrence.id_ticket_recurrence,
        qty: 1,
        multiplier: 1,
        price: price,
        price_amount: price,
        p_type,
        handly: priceManagement,
        currency: "",
        ticket_type: ticketRecurrence.ticket_type,
        label: ticketRecurrence.title,
        price_type: priceType,
        id_price_type: priceTypeId,
        rid,
    };

    if (cartHasValidDiscounts()) {
        applyDiscounts();
    } else {
        printMyReserve();
    }
};

const removeOrderLine = (rid) => {
    delete orderLines[rid];
    if (cartHasValidDiscounts()) {
        applyDiscounts();
    } else {
        printMyReserve();
    }
};

const getPistaNodeFromGroup = ({parentGroup}) => {
    console.log("function: getPistaNodeFromGroup()");
    console.log({parentGroup});
    return parentGroup
        .selectAll(":scope > rect")
        .nodes()
        .find((child) => d3.select(child).attr("data-name") === null);
};

const getPistaSeats = ({pistaNode}) => {
    const childs = d3.select(pistaNode.parentNode).selectAll(":scope > rect").nodes();
    return childs.filter((child) => d3.select(child).node() !== pistaNode);
};

const getPistaFreeSeat = ({pistaNode}) => {
    const pistaSeats = getPistaSeats({pistaNode});
    const freeSeat = pistaSeats.find((seat) => {
        const currentChild = d3.select(seat);
        return !currentChild.classed("reserved") && (!currentChild.attr("data-status") || currentChild.attr("data-status") === "false");
    });
    return freeSeat;
};

const isPistaFull = ({pistaNode}) => {
    const pistaSeats = getPistaSeats({pistaNode});
    const pistaFullSeats = pistaSeats.reduce((acc, seat) => {
        const currentSeat = d3.select(seat);
        return currentSeat.classed("reserved") || currentSeat.attr("data-status") === "true" ? acc + 1 : acc;
    }, 0);
    return pistaSeats.length === pistaFullSeats;
};

const getMySeatsQuantity = ({pistaNode}) => {
    console.log("function: getMySeatsQuantity()");
    const pistaSeats = getPistaSeats({pistaNode});
    return pistaSeats.reduce((acc, seat) => (d3.select(seat).attr("data-status") === "true" ? acc + 1 : acc), 0);
};

const getFreeSeatsQuantity = ({pistaSeats}) => {
    // const childs = d3.select(pistaNode.parentNode).selectAll(":scope > rect").nodes();
    return pistaSeats.reduce((acc, pistaSeat) => {
        const currentSeat = d3.select(pistaSeat);
        if (!currentSeat.classed("reserved") && (!currentSeat.attr("data-status") || currentSeat.attr("data-status") === "false")) {
            return acc + 1;
        }
        return acc;
    }, 0);
};

const showMyReservedTicketsQuantity = ({pistaNode}) => {
    const mySeatsQuantity = getMySeatsQuantity({pistaNode});
    console.log({mySeatsQuantity});
    const pistaQuantityLabels = d3.select(pistaNode.parentNode).select(".quantity-reserved-pista").selectAll(":scope > g").nodes();
    pistaQuantityLabels.forEach((child) => {
        const currentChild = d3.select(child);
        if (currentChild.attr("data-name") === mySeatsQuantity.toString()) {
            currentChild.classed("hidden", false);
        } else {
            currentChild.classed("hidden", true);
        }
    });
};

const showStockStatus = ({pistaNode}) => {
    console.log("function: showStockStatus()");

    const pistaSeats = getPistaSeats({pistaNode});
    const freeSeatsQuantity = getFreeSeatsQuantity({pistaSeats});

    console.log({freeSeatsQuantity});

    const freePercent = (freeSeatsQuantity * 100) / pistaSeats.length;
    const stockQuantityLabels = d3.select(pistaNode.parentNode).select(".stock-information-pista").selectAll(":scope > g").nodes();

    console.log({freePercent});
    console.log(stockQuantityLabels);

    hidePistaStockQuantityLabels({stockQuantityLabels});
    d3.select(getStockQuantityLabelByFreePercent({stockQuantityLabels, freePercent})).classed("hidden", false);
};

const hidePistaStockQuantityLabels = ({stockQuantityLabels}) => {
    stockQuantityLabels.forEach((child) => {
        const currentChild = d3.select(child);
        currentChild.classed("hidden", true);
    });
};

const getStockQuantityLabelByFreePercent = ({stockQuantityLabels, freePercent}) => {
    return stockQuantityLabels.find((child) => {
        if (freePercent === 0) {
            return d3.select(child).attr("data-name") === "0";
        } else if (freePercent < 25) {
            return d3.select(child).attr("data-name") === "less-25";
        } else if (freePercent < 50) {
            return d3.select(child).attr("data-name") === "less-50";
        } else {
            return d3.select(child).attr("data-name") === "more-50";
        }
    });
};

const showPistasStockStatus = () => {
    console.log("function showPistasStockStatus()");
    console.log(getPistasSelectors());
    d3.selectAll(getPistasSelectors())
        .nodes()
        .forEach((pistaNode) => showStockStatus({pistaNode}));
};

const showPistasQuantity = () => {
    d3.selectAll(getPistasSelectors())
        .nodes()
        .forEach((pistaNode) => showMyReservedTicketsQuantity({pistaNode}));
};

const removeReservedClassFromPista = ({pistaNode}) => {
    const pistaSeats = getPistaSeats({pistaNode});
    pistaSeats.forEach((seat) => d3.select(seat).classed("reserved", false));
};

const bindSeatCardsEvents = (ticketRecurrence, cartMode) => {
    if(cartMode !== CART_MODE.BLOCKING) {
        bindPriceButtonOnClickEvent(ticketRecurrence);
        bindPriceTypeButtonOnClickEvent(ticketRecurrence);
    }
    bindTrashButtonOnClickEvent();
};

const bindPriceButtonOnClickEvent = (ticketRecurrence) => {
    $(getPriceButtonsSelector())
        .off("change")
        .on("change", {ticketRecurrence}, function (event) {
            const selectedOptionElement = $(this).find(":selected");
            const rid = selectedOptionElement.attr("data-rid");
            const priceTypeId = parseInt(selectedOptionElement.attr("data-id-price-type"));
            const priceType = selectedOptionElement.attr("data-label");
            const priceManagement = parseFloat(selectedOptionElement.attr("data-price-management"));
            const pType = selectedOptionElement.attr("data-p-type");
            const price = parseFloat(selectedOptionElement.attr("value"));
            const {ticketRecurrence} = event.data;
            createOrderLine({ticketRecurrence, price, priceManagement, p_type: pType, priceTypeId, priceType, rid, seatData: orderLines[rid]});
        });
};

const bindPriceTypeButtonOnClickEvent = (ticketRecurrence) => {
    $(getPriceTypeButtonsSelector())
        .off("change")
        .on("change", {ticketRecurrence}, function (event) {
            const selectedOptionElement = $(this).find(":selected");
            const rid = selectedOptionElement.attr("data-rid");
            const index = selectedOptionElement.attr("data-index");

            const {ticketRecurrence} = event.data;
            const newPriceType = ticketRecurrence.many_prices[index];
            changeCardPrices(rid, newPriceType);

            const {price, price_management: priceManagement, p_type, id_event_seat_definition_price_type: priceTypeId, price_type: priceType} = newPriceType[
                DEFAULT_PRICE_INDEX
            ];
            createOrderLine({ticketRecurrence, price, priceManagement, p_type, priceTypeId, priceType, rid, seatData: orderLines[rid]});

            bindPriceButtonOnClickEvent(ticketRecurrence);
        });
};

const bindTrashButtonOnClickEvent = () => {
    $(getTrashButtonsSelector())
        .off("click")
        .on("click", function () {
            d3.select(getMapSeatIdSelector($(this).attr("data-id"))).dispatch("click");
        });
};

const removeSeatReserveCard = (rid) => $(`#seat-reserve-card-${rid}`).remove();

const createSeatReserveCard = ({rid, ticketRecurrence, currentPriceType, currentPrice, seatData, cartMode}) => {
    const cardId = `seat-reserve-card-${rid}`;
    if (!existsCard(cardId)) {
        let html = `<article id="${cardId}" class="seat card mode-${cartMode}">`;

        html += createCardTitle(ticketRecurrence);

        html += createCardSeat(seatData);

        html += createReservedTicketMessage(cartMode);

        if(cartMode != CART_MODE.BLOCKING) {
            html += createCardPrice({rid, currentPriceType, currentPrice, seatData});
    
            html += createCardPriceType({rid, ticketRecurrence, currentPriceType, currentPrice, seatData});
        }

        html += createTrashButton({rid});

        html += `</article>`;

        $("#seats-selected").append(html);
    }
};

const existsCard = (cardId) => {
    return document.getElementById(cardId);
};

const createCardTitle = ({event_title: eventTitle, start_date: startDate, finish_date: finishDate}) => {
    return `<div class="title"><h4>${eventTitle}</h4>
    <span class="datetime">${startDateToFinishDate(startDate, finishDate)}</span></div>`;
};

const createCardSeat = ({grandstandName, rowName, seatName}) => {
    return `<span class="seat-num">${grandstandName} - ${rowName} - ${seatName}</span>`;
};

const createReservedTicketMessage = (cartMode) => {
    return `<span class="seat-reserved">
    <svg class="svg-icon legend-icon" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
    <use href="images/icon-sprite.svg#check" xlink:href="images/icon-sprite.svg#check"></use>
    </svg>${cartMode !== CART_MODE.BLOCKING ? $(getTranslationSelector("ticket-reserved")).val() : $(getTranslationSelector("ticket-blocked")).val()}</span>`;
};

const createCardLegend = ({myClass, allClass}) => {
    let html = "";
    if (allClass.includes("low-vis")) {
        html += `<div class="legend-icon"><svg class="svg-icon" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
        <use href="images/icon-sprite.svg#eye-slash" xlink:href="images/icon-sprite.svg#eye-slash"></use>
        </svg><span class="icon-popup">Butaca amb visibilitat reduïda</span></div>`;
    }
    if (allClass.includes("no-vis")) {
        html += `<div class="legend-icon"><svg class="svg-icon" style="color:#ff0000" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
        <use href="images/icon-sprite.svg#eye-slash" xlink:href="images/icon-sprite.svg#eye-slash"></use>
        </svg><span class="icon-popup">Butaca amb visibilitat nul·la</span></div>`;
    }
    if (allClass.includes("accessible")) {
        html += `<div class="legend-icon"><svg class="svg-icon" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
        <use href="images/icon-sprite.svg#wheelchair" xlink:href="images/icon-sprite.svg#wheelchair"></use>
        </svg><span class="icon-popup">Butaca reservada per mobilitat reduïda</span></div>`;
    }
    html += `<span class="${myClass} legend-icon"> </span>`;
    return html;
};

const createCardPrice = ({rid, currentPriceType, currentPrice, seatData}) => {
    let html = `<div id="price-container-${rid}" class="price">`;

    html += createCardLegend(seatData);

    html += `<div id="price-container-content-${rid}" class="price">`;

    if (currentPriceType.length > 1) {
        html += createPriceSelect({rid, currentPriceType, currentPrice});
    } else {
        html += createPriceString({rid, price: currentPrice});
    }

    html += "</div>";

    html += "</div>";
    return html;
};

const createCardPriceType = ({rid, ticketRecurrence, currentPriceType, currentPrice, seatData}) => {
    if (differentPriceTypes({manyPrices: ticketRecurrence.many_prices, seatData}).length > 1) {
        return createRateTypeSelect({rid, manyPrices: ticketRecurrence.many_prices, currentPrice, myClass: seatData.myClass});
    }
    return createRateTypeString({rid, priceType: currentPriceType[DEFAULT_PRICE_TYPE_INDEX]});
};

const createPriceSelect = ({rid, currentPriceType, currentPrice}) => {
    let html = `
    <div class="custom-select">
        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" role="img">
            <use href="images/icon-sprite.svg#angle-arrow"></use>
        </svg>
        <select id="seat-reserve-prices-${rid}" class="${PRICE_BUTTON_CLASS} tarifa" name="price">`;

    html += createPriceOptions({rid, currentPriceType, currentPrice});

    html += `
        </select>
    </div>`;

    return html;
};

const changeCardPrices = (rid, currentPriceType) => {
    let html = "";
    if (currentPriceType.length > 1) {
        html = createPriceSelect({rid, currentPriceType, currentPrice: {}});
    } else {
        html = createPriceString({rid, price: currentPriceType[DEFAULT_PRICE_TYPE_INDEX]});
    }
    $(`#price-container-content-${rid}`).html(html);
};

const createPriceOptions = ({rid, currentPriceType, currentPrice}) => {
    return currentPriceType.map((price) => createPriceOption({rid, price, currentPrice})).join(" ");
};

const createPriceOption = ({rid, price, currentPrice}) => {
    let selected = "";

    console.log({currentPrice});
    console.log({price});

    if (currentPrice.price === price.price && currentPrice.p_type === price.p_type) {
        selected = "selected";
    }

    return `<option value="${price.price}" data-price-management="${price.price_management}" data-p-type="${price.p_type}" data-label="${price.price_type}" 
            data-id-price-type="${price.id_event_seat_definition_price_type}" data-rid="${rid}" ${selected}>    
    ${getFormattedPrice({price})}
    </option>`;
};

const createPriceString = ({rid, price}) => {
    return `<div id="seat-reserve-prices-${rid}" class="tarifa" data-price-management="${price.price_management}" data-p-type="${price.p_type}" data-label="${
        price.price_type
    }" data-id-price-type="${price.id_event_seat_definition_price_type}" data-rid="${rid}">
    ${getFormattedPrice({price})}
    </div>`;
};

const getFormattedPrice = ({price}) => {
    const lang = "es-ES";
    const currency = "EUR";
    if (price.p_type === "invitation") {
        return $(getTranslationSelector("invitation")).val();
    }
    return new Intl.NumberFormat(lang, {style: "currency", currency: currency}).format(price.price);
};

const createRateTypeSelect = ({rid, manyPrices, currentPrice, myClass}) => {
    let html = `
        <div class="custom-select tarifa">
            <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" role="img">
                <use href="images/icon-sprite.svg#angle-arrow"></use>
            </svg>
            <select class="${PRICE_TYPE_BUTTON_CLASS} tarifa" name="tarifa">`;

    console.log({manyPrices})

    const firstPriceOfEachPriceType = manyPrices.map((priceType) => priceType[DEFAULT_PRICE_INDEX]);

    console.log({firstPriceOfEachPriceType})

    firstPriceOfEachPriceType.forEach((price, index) => {
        if (price.class !== myClass) return;
        if (currentPrice.price_type === price.price_type)
            html += `<option value="${price.id_event_seat_definition_price_type}" data-index="${index}" data-rid="${rid}" selected>${price.price_type}</option>`;
        else html += `<option value="${price.id_event_seat_definition_price_type}" data-index="${index}" data-rid="${rid}">${price.price_type}</option>`;
    });

    html += `</select>
        </div>
    `;

    return html;
};

const createRateTypeString = ({rid, priceType}) => {
    return `<div class="tarifa">${priceType.price_type}</div>`;
};

const createTrashButton = ({rid}) => {
    return `
        <button type="button" class="${DELETE_BUTTON_CLASS} button button--default button--icon button--icon-only" title="Delete" data-id="${rid}">
            <svg class="svg-icon" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
                <use href="images/icon-sprite.svg#x" xlink:href="images/icon-sprite.svg#x"></use>
            </svg>

            <span class="visually-hidden" role="presentation">${$(getTranslationSelector("delete")).val()}</span>
        </button>
    `;
};





const loadSeatMap = (orderId, ticketRecurrenceId, cartMode = CART_MODE.NORMAL) => {
    console.log("function loadSeatMap(orderId, ticketRecurrenceId)");
    console.log("LOADING MAP", { orderId });

    setContainerCartMode(cartMode);
    showGeneralSpinner();

    const svgConfig = getSvgConfig(ticketRecurrenceId);
    if (!svgConfig) return;

    const ticketRecurrence = getTicketRecurrence(ticketRecurrenceId);
    if(!ticketRecurrence) return;

    if (!svgConfig) return;

    loadTicketRecurrenceIdOnElements(ticketRecurrenceId);
    loadTicketRecurrenceDateLabel(ticketRecurrence);
    loadPricesLegend(ticketRecurrence);

    d3.xml(svgConfig.svgPath).then(async (data) => {
        loadSvg(data, svgConfig);
        await loadReservedSeats(ticketRecurrence);
        bindFreeSeatsOnClickEvent(orderId, ticketRecurrence, cartMode);
        bindPistaOnClickEvent(orderId, ticketRecurrence);
        reloadMyReserves();
        showPistasStockStatus();
    });
};

const loadTicketRecurrenceIdOnElements = (ticketRecurrenceId) => {
    $(getCurrentTicketRecurrenceIdSelector()).val(ticketRecurrenceId);
    $(getReloadButtonSelector()).attr("data-id", ticketRecurrenceId);
};

const loadTicketRecurrenceDateLabel = ({ start_date: startDate, finish_date: finishDate }) => {
    $(getEventTicketRecurrenceDateSelector()).html(startDateToFinishDate(startDate, finishDate));
};

const loadReservedSeats = async (ticketRecurrence) => {
    try {
        const reservedSeats = await getTicketReserves(ticketRecurrence.id_ticket_recurrence);
        if (reservedSeats.length > 0) {
            const myReservedSeatsRids = Object.keys(orderLines).filter((rid) => rid.includes("_"));
            const reservedSeatsFromOtherOrders = reservedSeats.filter(({ rid }) => !myReservedSeatsRids.includes(rid));
            const blockedSeatsFromOtherOrders = reservedSeatsFromOtherOrders.filter(({ seat_status }) => seat_status === CART_MODE.BLOCKING)

            console.log({ reservedSeatsFromOtherOrders });
            console.log({ 'reserved': getReservedSeatsSelectors(reservedSeatsFromOtherOrders) })
            console.log({ 'blocked': getReservedSeatsSelectors(blockedSeatsFromOtherOrders) })

            const reservedSelector = getReservedSeatsSelectors(reservedSeatsFromOtherOrders)
            if (reservedSelector !== '') d3.selectAll(reservedSelector).classed("reserved", "true");

            if (ticketRecurrence.is_event_admin) {
                const blockedSelector = getReservedSeatsSelectors(blockedSeatsFromOtherOrders)
                if (blockedSelector !== '') {
                    d3.selectAll(blockedSelector).classed("blocked", "true")
                    d3.selectAll(blockedSelector).style("fill", "url(#lock)")
                }
            }
        }
        hideGeneralSpinner();
    } catch (err) {
        console.warn(err);
    }
};

const reloadMyReserves = () => {
    console.log("RELOADING SEATS", { orderLines });
    const myReservedSeatsRids = Object.keys(orderLines).filter((rid) => rid.includes("_B"));
    console.log("MY_RESERVES", { myReservedSeatsRids })
    myReservedSeatsRids.forEach((rid) => d3.select(getMapSeatIdSelector(rid)).dispatch("click"));
};

const bindFreeSeatsOnClickEvent = (orderId, ticketRecurrence, cartMode) => {
    d3.selectAll(getSeatsSelectors()).on("click", function () {
        const currentNode = d3.select(this);
        const parentNode = d3.select(this.parentNode);

        if (currentNode.style("fill").indexOf("spinner") !== -1) return;

        if (currentNode.classed("reserved") && !currentNode.classed("blocked")) return;

        console.log({ parentNode });
        if (parentNode.attr("data-is-pista") === "true") {
            const pistaNode = getPistaNodeFromGroup({ parentGroup: parentNode });
            console.log({ pistaNode });

            savePistaSeatReserve({ element: this, pistaNode, orderId, ticketRecurrence });
        } else {
            saveSeatReserve(this, orderId, ticketRecurrence, cartMode)
        }
    });
};

const saveSeatReserve = (element, orderId, ticketRecurrence, cartMode) => {
    const seatData = getSeatData(element);
    const rid = `${ticketRecurrence.id_ticket_recurrence}${RECURRENCE_SEAT_SEPARATOR}${seatData.seatId}`;
    const reserveData = {
        id_order: orderId,
        id_ticket_recurrence: ticketRecurrence.id_ticket_recurrence,
        rid,
        seatStatus: orderLines[rid] === undefined ? cartMode : orderLines[rid].seatStatus
    };

    const isBlockedSeatFromAnotherOrder = d3.select(element).classed("blocked")
    if (isBlockedSeatFromAnotherOrder) {
        unreserveSeat({ 'reserveData': { ...reserveData, seatStatus: CART_MODE.BLOCKING }, element })
        return
    }

    console.log("SAVING SEAT", { "orderLine": orderLines[rid] });

    if (!isSeatReserved(element) && !isBlockedSeatFromAnotherOrder) {
        reserveSeat({ reserveData, ticketRecurrence, seatData, element });
    } else {
        unreserveSeat({ reserveData, element });
    }
};

const bindPistaOnClickEvent = (orderId, ticketRecurrence) => {
    d3.selectAll(getPistasSelectors()).on("click", async function () {
        const pistaNode = this;
        let freePistaSeat = getPistaFreeSeat({ pistaNode });

        // Try to load possible free seats from another purchasing order
        if (freePistaSeat === undefined) {
            removeReservedClassFromPista({ pistaNode });
            await loadReservedSeats(ticketRecurrence.id_ticket_recurrence);
            freePistaSeat = getPistaFreeSeat({ pistaNode });
        }

        if (freePistaSeat) savePistaSeatReserve({ element: freePistaSeat, pistaNode, orderId, ticketRecurrence });
        else return false;
    });
};

const savePistaSeatReserve = ({ element, pistaNode, orderId, ticketRecurrence }) => {
    const seatData = getSeatData(element);
    const rid = `${ticketRecurrence.id_ticket_recurrence}${RECURRENCE_SEAT_SEPARATOR}${seatData.seatId}`;
    const reserveData = {
        id_order: orderId,
        id_ticket_recurrence: ticketRecurrence.id_ticket_recurrence,
        rid,
    };

    if (!isSeatReserved(element)) {
        reservePista({ reserveData, ticketRecurrence, seatData, element, pistaNode });
    } else {
        unreservePista({ reserveData, element });
    }
};

const validateDiscount = () => {
    console.log("function validateDiscount()");
    const code = $("#discount-code-input").val();
    const metaTag = document.querySelector('meta[property="og:locale"]');
    const locale = (metaTag ? metaTag.getAttribute('content') : "ca_ES");
    $("#discount-code-message").removeClass("show");
    $("#discount-code-message").html('');

    if (code !== "") {
        const eventId = $("#id-event").val();
        const url = `/event/${eventId}/locale/${locale}/discount/validate/${code}`;
        $.ajax({
            type: "get",
            url: url,
            contentType: "application/json; charset=utf-8",
            cache: false,
            processData: true,
            dataType: "json",
            beforeSend: function () {
                $("#discount-code-spinner").show();
            },
        })
            .done(function (result) {
                console.log({result});
                setTimeout(() => {

                    $("#discount-code-spinner").hide();
                    $("#discount-code-message").html(result.message);
                    $("#discount-code-message").addClass("show");
                    if(result.status){
                        $("#discount-code-message").addClass("success");
                    } else {
                        $("#discount-code-message").removeClass("success");
                    }
                }, 300);

                // Use a dictionary to ensure no duplications
                discounts[result.discount.id_discount] = result.discount;

                applyDiscounts();
            })
            .fail(function (jqXHR, textStatus) {
                console.log("fail createEmptyOrder: " + jqXHR.statusText + " (" + jqXHR.status + ") : " + textStatus);
                console.log(jqXHR.responseText);
            });
    } else {
        setTimeout(() => {
            $("#discount-code-message").html($("#error-code-empty").val());
            $("#discount-code-message").removeClass("success");
            $("#discount-code-message").addClass("show");
        }, 300);
    }
};

const applyDiscounts = () => {
    console.log("function applyDiscounts()");
    const validDiscounts = Object.values(discounts);
    const ticketsTmp = {};
    Object.values(orderLines).forEach((ticket) => {
        const ticketId = ticket.id_ticket + "";
        if (!ticketsTmp[ticketId]) {
            ticketsTmp[ticketId] = {id_ticket: ticketId, id_ticket_recurrence: ticket.id_ticket_recurrence, quantity: ticket.qty};
        } else {
            ticketsTmp[ticketId].quantity += ticket.qty;
        }
    });
    const tickets = Object.values(ticketsTmp);
    console.log({validDiscounts});
    console.log({tickets});
    const metaTag = document.querySelector('meta[property="og:locale"]');
    const locale = (metaTag ? metaTag.getAttribute('content') : "ca_ES");
    $("#discount-code-message").removeClass("show");
    $("#discount-code-message").html('');

    if (validDiscounts.length > 0 && tickets.length > 0) {
        console.log("getEventDiscounts");
        const eventId = $("#id-event").val();
        const url = `/event/${eventId}/locale/${locale}/discount`;
        $.ajax({
            type: "post",
            url: url,
            contentType: "application/json; charset=utf-8",
            cache: false,
            processData: true,
            dataType: "json",
            data: JSON.stringify({discounts: validDiscounts, tickets}),
            beforeSend: function () {
                $("#discount-code-spinner").show();
            },
        })
            .done(function (result) {
                console.log({result});
                $("#discount-code-spinner").hide();
                if(result.message){
                    $("#discount-code-message").html(result.message);
                    $("#discount-code-message").addClass("show");
                    if(result.status){
                        $("#discount-code-message").addClass("success");
                    } else {
                        $("#discount-code-message").removeClass("success");
                    }
                }
                $(".discounts-applyed").html(getApplyedDiscountsHtml(result.applied_discounts));

                discountLines = result.discount_lines;

                printMyReserve();
            })
            .fail(function (jqXHR, textStatus) {
                console.log("fail createEmptyOrder: " + jqXHR.statusText + " (" + jqXHR.status + ") : " + textStatus);
                console.log(jqXHR.responseText);
            });
    } else {
        console.log("!getEventDiscounts");
        printMyReserve();
    }
};

const getApplyedDiscountsHtml = (applyedDiscounts) => {
    let html = "";
    applyedDiscounts.forEach((discount) => {
        // html += `<button type="button" class="button button--default button--icon button--icon-only discount-code-applyed" title="Delete" data-id="${discount.id_discount}">
        //             <svg class="svg-icon" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg">
        //                 <use href="images/icon-sprite.svg#x" xlink:href="images/icon-sprite.svg#x"></use>
        //             </svg>
        //             <span role="presentation"> ${discount.code}</span>
        //         </button>
        // </span>`;
        const lang = "es-ES";
        const currency = "EUR";
        const amount = new Intl.NumberFormat(lang, {
            style: "currency",
            currency: currency,
        }).format(discount.price/100);
        
        const applicable = (discount.applicable_type === "per_ticket" ? $("#per_ticket").val() : $("#per_order").val())
        html += `<span class="code">${discount.label}: ${amount} ${applicable}</span>`;
    });
    return html;
};

const cartHasValidDiscounts = () => {
    return Object.values(discounts).length > 0;
};

const removeDiscount = (discountId) => {
    delete discounts[discountId];
    if (cartHasValidDiscounts()) {
        applyDiscounts();
    } else {
        discountLines = {};
    }
    printMyReserve();
};

$(function () {
    loadOrder();

    $(".stream-local-link").on("click", function () {
        console.log("stream local link click");
        document.querySelector("#tickets").scrollIntoView({ behavior: "smooth" });
    });
    $("button").on("click", function (event) {
        let a = $(this).attr("data-action");
        let idButt = $(this).attr("id");
        let idElem = $(this).attr("data-id");
        eventButton(a, idButt, idElem);
    });
    $(".clicable").on("click", function () {
        let a = $(this).find("a").attr("href");
        window.location.href = a;
    });
});

function loadOrder() {
    console.log("function loadOrder()");
    let paymentStatus = $("#payment-order-status").val();
    if (paymentStatus === "OK") {
        loadOrderLines();
        modalCart(5);
    } else if (paymentStatus === "KO") {
        // TODO Borrar aquest set es fa al enviar el pagament pero es per testing
        // localStorage.setItem("timer", "150000");

        loadOrderContent();
        modalCart(4);
    }
    return false;
}

function loadOrderContent() {
    console.log("function loadOrderContent()");

    // Initialize timer
    const currentDate = new Date();
    const orderRemainingTime = $("#payment-order-remaining-time").val();
    const freeExtraTime = 5 * 60 * 1000 + "";
    const timeInMilliseconds = parseInt(orderRemainingTime ? orderRemainingTime : freeExtraTime);
    const reservationTime = currentDate.setTime(currentDate.getTime() + timeInMilliseconds);
    const timerDate = new Date(reservationTime);

    inactivityTime();
    updateCountdown(timerDate);
    timeCount = setInterval(function () {
        updateCountdown(timerDate, timeCount);
    }, MILLISECONDS_OF_A_SECOND);

    $("#cart").data("reservation", reservationTime);

    // Reserve recovery data
    const recoveryStr = $("#payment-order-data").val();
    console.log({ recoveryStr });
    const { data: recoveryObj } = JSON.parse(recoveryStr);
    console.log({ recoveryObj });
    $("#cart").data("id_order", recoveryObj.id_order);

    loadOrderLines();

    console.log(orderLines);
    prepareAttendees();

    // set cart 3.5 (donations)
    // loadUserBillingAddresses(recoveryObj.previous_id_billing_address);
    $("#billing-address-donation-id").val(recoveryObj.previous_id_billing_address)
    if (recoveryObj.previous_id_billing_address > 0 && recoveryObj.order_has_tickets_donation) {
        $("#is-donation").val("Yes");
    }
    setBackCart4Checkout();

    //totals info
    printMyReserve();
}

function loadOrderLines() {
    const recoveryStr = $("#payment-order-data").val();
    const { data: recoveryObj } = JSON.parse(recoveryStr);
    console.log({ recoveryObj });

    // create obj
    const processedRidsOrderLines = [];
    // set cart 1 (stock)
    recoveryObj.order_lines.forEach((order_line) => {
        console.log(order_line);
        let seat = recoveryObj.seats.find(
            (seat) => seat.id_ticket_recurrence === order_line.id_ticket_recurrence && !processedRidsOrderLines.includes(seat.rid)
        );

        if (seat === undefined) {
            orderLines[order_line.id_ticket_recurrence + "_" + order_line.id_price_type] = {
                id_ticket: order_line.id_ticket,
                id_ticket_recurrence: order_line.id_ticket_recurrence,
                id_price_type: order_line.id_price_type,
                qty: order_line.quantity,
                price: order_line.price,
                price_amount: order_line.price_amount,
                handly: order_line.handly_amount,
                label: order_line.label,
                currency: order_line.currency,
                p_type: order_line.p_type,
                multiplier: order_line.multiplier,
                ticket_type: order_line.ticket_type,
            };
            $("#qty-ticket-reserve-" + order_line.id_ticket_recurrence + "_" + order_line.id_price_type).val(order_line.quantity);
            $("#qty-ticket-reserve-" + order_line.id_ticket_recurrence + "_" + order_line.id_price_type).data("oldvalue", order_line.quantity);
            $("#ticket-many-prices-" + order_line.id_ticket_recurrence + "_" + order_line.id_price_type).val(order_line.price);
        } else {
            orderLines[seat.rid] = {
                id_ticket: order_line.id_ticket,
                id_ticket_recurrence: order_line.id_ticket_recurrence,
                qty: order_line.quantity,
                price: order_line.price,
                price_amount: order_line.price_amount,
                handly: order_line.handly_amount,
                label: order_line.label,
                currency: order_line.currency,
                multiplier: order_line.multiplier,
                ticket_type: order_line.ticket_type,
                rid: seat.rid,
                price_type: order_line.price_type,
                p_type: order_line.p_type,
                floorName: order_line.floor,
                zoneName: order_line.zone,
                grandstandName: order_line.grandstand,
                rowName: order_line.row,
                seatName: order_line.seat,
                seatStatus: ('seat_status' in seat) ? seat.seat_status : CART_MODE.NORMAL,
            };
            processedRidsOrderLines.push(seat.rid);
        }
    });

    discountLines = recoveryObj.discount_lines;
    discounts = recoveryObj.applyed_discounts;
    $(".discounts-applyed").html(getApplyedDiscountsHtml(Object.values(discounts)));
    console.log("discount recovery ------------ ", { discountLines });
    console.log({ "before attendees": orderLines });

    const processedRidsAttendees = [];
    // set cart 2 (attendees)
    recoveryObj.attendees.forEach((attendee) => {
        console.log({ attendee })
        let seat = recoveryObj.seats.find((seat) => seat.id_ticket_recurrence === attendee.id_ticket_recurrence && !processedRidsAttendees.includes(seat.rid));
        console.log({ seat });
        if (seat === undefined) {
            if (!("attendees" in orderLines[attendee.id_ticket_recurrence + "_" + attendee.id_price_type])) {
                orderLines[attendee.id_ticket_recurrence + "_" + attendee.id_price_type].attendees = [];
            }
            console.log("ADDING TO ATTENDEES THE ATTENDEE: ", attendee)
            orderLines[attendee.id_ticket_recurrence + "_" + attendee.id_price_type].attendees.push({
                name: attendee.name,
                surname: attendee.surname,
                email: attendee.email,
                city: attendee.city,
                company_type: attendee.company_type,
                opt_in: attendee.opt_in,
                phone: attendee.phone,
                dinner: attendee.dinner,
                footwear: attendee.footwear,
                sandwich: attendee.sandwich,
                id_ticket_form: attendee.id_ticket_form,
                form_data: attendee.form_data,
            });
            console.log({ orderLines })
        } else {
            if (!("attendees" in orderLines[seat.rid])) {
                orderLines[seat.rid].attendees = [];
            }
            console.log(orderLines[seat.rid]);
            orderLines[seat.rid].attendees.push({
                name: attendee.name,
                surname: attendee.surname,
                email: attendee.email,
                city: attendee.city,
                company_type: attendee.company_type,
                opt_in: attendee.opt_in,
                phone: attendee.phone,
                dinner: attendee.dinner,
                footwear: attendee.footwear,
                sandwich: attendee.sandwich,
                id_ticket_form: attendee.id_ticket_form,
                form_data: attendee.form_data,
                rid: seat.rid,
                price_type: orderLines[seat.rid].price_type,
                grandstand: orderLines[seat.rid].grandstandName,
                row: orderLines[seat.rid].rowName,
                seat: orderLines[seat.rid].seatName,
            });
            processedRidsAttendees.push(seat.rid);
        }
    });
}

function eventButton(action, idButton, idElement) {
    console.log({ action });
    switch (action) {
        case "share-event":
            console.log("Element " + idElement + " shared from " + idButton + " button.");
            break;
        case "love-event":
            console.log("Element " + idElement + " loved from " + idButton + " button.");
            break;
        case "openCart-event":
            console.log("Element " + idElement + " opened from " + idButton + " button.");
            // The reservation timer no longer starts on open; it starts on the
            // first confirmed reservation (see returnStatus / initTimer guard).
            modalCart(1);
            break;
        case "minus-ticket-reserve":
            console.log("Element " + idElement + " minus from " + idButton + " button.");
            prepareReserve(-1, idElement);
            break;
        case "more-ticket-reserve":
            console.log("Element " + idElement + " more from " + idButton + " button.");
            prepareReserve(1, idElement);
            break;
        case "attendee-assign":
            console.log("Element " + idElement + " go to assign " + idButton + " button.");
            modalCart(2);
            break;
        case "login-user":
            console.log("Element " + idElement + " go to assign " + idButton + " button.");
            loginCart();
            break;
        case "signup-user":
            console.log("Element " + idElement + " go to assign " + idButton + " button.");
            signupUser();
            break;
        case "donation-user":
            console.log("Element " + idElement + " go to assign " + idButton + " button.");
            saveUserDonationData();
            break;
        case "pay-reserve":
            console.log("Element " + idElement + " go to pay " + idButton + " button.");
            payReserve();
            break;
        case "seat-select-button":
            console.log("Element " + idElement + " go to open seat modal " + idButton + " button.");
            createOrderIdForSeats()
                .then(() => {
                    loadSeatMap($("#cart").data("id_order"), parseInt(idElement));
                    modalCart(15);
                });
            break;
        case "seat-block-button":
            console.log("Element " + idElement + " go to open seat blocking modal " + idButton + " button.");
            if (blockedOrderId === undefined) {
                createEmptyBlockingOrder(parseInt(idElement))
            } else {
                loadSeatMap($("#cart").data("id_order_blocked_seats"), parseInt(idElement), CART_MODE.BLOCKING);
                modalCart(16);
            }
            break;
        case "seat-select-reload-button":
            console.log("Element " + idElement + " go to reload seat modal " + idButton + " button.");
            if ($(getGeneralContainer()).hasClass(`mode-${CART_MODE.BLOCKING}`)) {
                loadSeatMap($("#cart").data("id_order_blocked_seats"), parseInt(idElement), CART_MODE.BLOCKING);
                modalCart(16);
            } else {
                loadSeatMap($("#cart").data("id_order"), parseInt(idElement));
                modalCart(15);
            }
            break;
        case "seat-accept-button":
            goBack("1.5");
            break;
        case "discount-code":
            validateDiscount();
            break;
        case "complete-fields":
            console.log("Element " + idElement + " go to pay " + idButton + " button.");
            invitationField(true);
            break;
        case "empty-fields":
            console.log("Element " + idElement + " go to pay " + idButton + " button.");
            invitationField();
            break;
        case "goback-from":
            console.log("Element " + idElement + " goback with " + idButton + " button.");
            goBack(idElement);
            break;
        case "close-cart":
            console.log("Element " + idElement + " close with " + idButton + " button.");
            if ($(".cart-5-response").is(":visible")) {
                // cleanCart();
                window.location.href = $("#event-url").val();
            }
            modalCart(0);
            break;
        default:
            console.log("Nothing to do here.");
            break;
    }
    return false;
}

function goBack(from) {
    console.log("function goBack");
    console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>", $(".timer"));
    switch (from) {
        case "1.5":
            $(".cart-1-5-seats").hide();
            $(".cart-1-reserve").show();
            $("#cart > .main-container").scrollTop(0);
            $(".timer").appendTo(".cart-1-reserve .timer-wrap");
            break;
        case "2":
            $(".cart-2-attendees").hide();
            $(".cart-1-reserve").show();
            $(".timer").appendTo(".cart-1-reserve .timer-wrap");
            break;
        case "3":
            $(".cart-3-login").hide();
            $(".cart-2-attendees").show();
            $(".timer").appendTo(".cart-2-attendees .timer-wrap");
            break;
        case "3.5":
            $(".cart-3-5-donation").hide();
            $(".cart-2-attendees").show();
            $(".timer").appendTo(".cart-2-attendees .timer-wrap");
            break;
        case "4":
            $(".cart-4-checkout").hide();
            $(".cart-2-attendees").show();
            $(".timer").appendTo(".cart-2-attendees .timer-wrap");
            break;
        case "4.1":
            $(".cart-4-checkout-free").hide();
            $(".cart-2-attendees").show();
            $(".timer").appendTo(".cart-2-attendees .timer-wrap");
            break;
        case "4.2":
            $(".cart-4-checkout").hide();
            $("#addresses").empty();
            billingAddressId = $("#billing-address-donation-id").val();
            loadUserBillingAddresses(billingAddressId);
            $(".cart-3-5-donation").show();
            $(".timer").appendTo(".cart-3-5-donation .timer-wrap");
            break;
        default:
            console.log("Go where?");
            break;
    }
}

async function createOrderIdForSeats() {
    // Serialised single-order creation (shared with the reserve flow) so rapid
    // seat-button clicks cannot create duplicate orders.
    await ensureOrder();
}

function modalCart(action) {
    console.log("function modalCart changed 222");
    switch (action) {
        case 0:
            $("#cart,.cart .modal-card .modal-content > div").hide();
            $("body").removeClass("modal-opened");
            break;
        case 1:
            $("#cart,.cart-1-reserve").show();
            $("body").addClass("modal-opened");
            $(".timer").appendTo(".cart-1-reserve .timer-wrap");
            break;
        case 15:
            $(".cart-1-reserve").hide();
            $("#seat-accept-button-").children("span").first().html($(getTranslationSelector("accept-seats")).val())
            $("#cart,.cart-1-5-seats").show();
            $("#cart > .main-container").scrollTop(0);
            $("body").addClass("modal-opened");
            $(".timer").appendTo(".cart-1-5-seats .timer-wrap");
            break;
        case 16:
            $(".cart-1-reserve").hide();
            $("#seat-accept-button-").children("span").first().html($(getTranslationSelector("accept-blocking")).val())
            $("#cart,.cart-1-5-seats").show();
            $("#cart > .main-container").scrollTop(0);
            $("body").addClass("modal-opened");
            $(".timer").appendTo(".cart-1-5-seats .timer-wrap");
            break;
        case 2:
            attendeeAssign();
            break;
        case 4: //payment KO
            $("#cart, .cart-4-checkout").show();
            $("#cart > .main-container").scrollTop(0);
            $("body").addClass("modal-opened");
            $(".timer").appendTo(".cart-4-checkout .timer-wrap");
            break;
        case 5: //payment OK
            showHasInvitationMessage();
            $("#cart, .cart-5-response").show();
            $("#cart > .main-container").scrollTop(0);
            $("body").addClass("modal-opened");
            break;
    }
    return;
}





/* Intersection Observer for reserve-button styling */
if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype) {
    const targetElement = document.querySelector("#main-footer");
    const btnGrid = document.querySelector("#reserve-button-grid");

    let observer1 = new IntersectionObserver((entries) => {
        if (entries[0].intersectionRatio > 0) {
            btnGrid.classList.add("unfixed");
        } else {
            btnGrid.classList.remove("unfixed");
        }
    });
    if (targetElement && btnGrid) {
        observer1.observe(targetElement);
    }

    const topPx = document.querySelector("#topPx");
    const bodyContent = document.querySelector("#content");

    let observer2 = new IntersectionObserver((entries) => {
        if (entries[0].intersectionRatio > 0) {
            bodyContent.classList.remove("scrolled");
        } else {
            bodyContent.classList.add("scrolled");
        }
    });
    if (topPx && bodyContent) {
        observer2.observe(topPx);
    }
}
/* END Intersection Observer */



// import { cart } from "../organisms/cart/cart";


/***/ })
/******/ 	]);
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module used 'module' so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(0);
/******/ 	
/******/ })()
;